import { Component, OnInit, Input, ViewChild, EventEmitter, Output, TemplateRef, ChangeDetectorRef, ElementRef, ViewChildren, QueryList, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { CategoriesService } from 'src/app/services/categories.service';
import { download, LeadgetPageSize, ResourceAccess, validateAllFormFields } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { ImportExcelComponent } from 'src/app/pages/commonImport/import-excel/import-excel.component';
import { CommonDownloadComponent } from 'src/app/pages/common-download/common-download.component';
import { DatePipe, Location } from '@angular/common';
import { TransferLeadComponent } from '../transfer-lead/transfer-lead.component';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import * as XLSX from 'xlsx';
import { takeUntil, filter, take } from 'rxjs/operators';
import { WhatsapptemplatemessageService } from 'src/app/services/whatsapptemplatemessage.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadOwnerSearchComponent } from '../lead-owner-search/lead-owner-search.component';
import { ConfigService } from 'src/app/services/config.service';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { CrmNoteComponent } from '../crm-note/crm-note.component';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { LeadService } from 'src/app/services/lead.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { LoaderService } from 'src/app/services/loader.service';
import { RealEstatePropertyService } from 'src/app/services/real-estate-property.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { LeadDynamicFormComponent } from './lead-dynamic-form/lead-dynamic-form.component';
import { GridService } from 'src/app/services/grid.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { TemplateServiceService } from 'src/app/services/template-service.service';
import { AdvanceFilterComponent } from './advance-filter/advance-filter.component';
import { CrmBusinessEditComponent } from '../crm-business-edit/crm-business-edit.component';
import { UsersService } from 'src/app/services/users.service';
import { LeadDetailPanelComponent } from 'src/app/pages/crm/lead-detail-panel/lead-detail-panel.component';
import { ConversationPopupComponent } from '../conversation-popup/conversation-popup.component';
import { CrmSearchComponent } from '../crm-search/crm-search.component';
import { EmailPopupComponentComponent } from 'src/app/pages/crm/lead-detail/email-popup-component/email-popup-component.component';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { CompaniesService } from 'src/app/services/companies.service';
import { AddMeetingComponent } from 'src/app/pages/companies/add-meeting/add-meeting.component';
import { PopupEditComponent } from '../popup-edit/popup-edit.component';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { SequencesService } from 'src/app/services/sequences.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { CrmdealskanbanComponent } from 'src/app/pages/crm/crmdealskanban/crmdealskanban.component';
import { SmartViewsService } from 'src/app/services/smart-views.service';
import { TwilloDialerComponent } from 'src/app/pages/phone-dialer/twillo-dialer/twillo-dialer.component';
import { UserMailConfigService } from 'src/app/services/user-mail-config.service';


// ─── GridType 8 Column-Width Config ───────────────────────────────────────────

/** Shape of the structured JSON stored in localStorage for GridType 8 */
interface LeadTableConfig {
  id?: number;
  name: string;
  url: string;
  data: string;
}


// ──────────────────────────────────────────────────────────────────────────────

@Component({
  selector: 'calsoft-common-product',
  templateUrl: './common-product.component.html',
  styleUrls: ['./common-product.component.scss']
})
export class CommonProductComponent implements OnInit, AfterViewInit {
  url: string = '';


  sanitizedUrl: string = '';


  @ViewChildren('auto', { read: ElementRef }) inlineAutocompleteEls: QueryList<ElementRef>;
  @ViewChildren('autoTrigger', { read: MatAutocompleteTrigger }) autocompleteTriggers: QueryList<MatAutocompleteTrigger>;
  private _scrollableListeners: Array<{ el: any, handler: EventListener }> = [];
  isPopupOpen1: boolean = false;
  selectedEntries = 15;
  entriesOptions: number[] = [10, 25, 50, 100];
  sizeone: number = this.entriesOptions[0];
  pageone: number = 0;
  columnsProperties: string[] = [];


  leadType = 1;

  icPhone = icPhone;
  icWhatsapp = icWhatsapp;
  templateId = new FormControl('', [Validators.required]);
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(CrmdealskanbanComponent) dealsKanban: CrmdealskanbanComponent;
  @ViewChild('tabsScroll', { static: false }) tabsScroll!: ElementRef;
  productList: any;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });


  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;
  pageIndex: any;
  pageSize: number;
  phoneNumber: any;
  pageList: any;
  spinner: boolean;
  search: any;
  id: any;
  pageSizeValue: any;
  resourcePrivilege: any;
  elements: any
  setList: any = [];
  read: any = false;
  serverPath: any = environment.ImageAPI;
  downloadDataComplete: string;
  create: any;
  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;
  configurableProductDropdown: any;
  configattributeType: any;
  productSelected: any;
  OwnerNameList: any;
  OwnerEmailList: any;
  text: string;
  textSend: string;

  @Input() primaryTitle = 'Product';

  @Input() secondaryType = 1;
  urlPage: any;
  urlSize: any;
  urlSort: string;
  redirected: boolean = false;
  crmType: any = 1;
  initCrmType: boolean = false;
  /**
   * In-memory map of column widths used by the template ([ngClass] bindings).
   * For GridType 8 this is pre-populated from the structured JSON in localStorage
   * so widths survive page refreshes.
   */
  columnWidths: { [key: string]: number } = {};
  gridConfigId: number | null = null;
  enableEditStatusPopup: any;

  // ─── GridType 8 Structured localStorage Helpers ─────────────────────────────

  saveColumnSize(columnName: string, width: number): void {
    try {
      // Keep in-memory widths in sync first
      this.columnWidths[columnName] = width;

      const config: LeadTableConfig = {
        name: 'lead',
        url: this.router.url,
        data: JSON.stringify(this.columnWidths)
      };

      if (this.gridConfigId) {
        config.id = this.gridConfigId;
      }

      this.gridService.saveGridConfig(config).subscribe(
        res => {
          // Robust ID retrieval: check res.id, then res.data.id, then res[0].id
          const newId = res?.id || res?.data?.id || (Array.isArray(res) ? res[0]?.id : null);
          if (newId) {
            this.gridConfigId = newId;
          }
        },
        err => {
          console.error('[gridTableConfig] Failed to save column size to API:', err);
        }
      );
    } catch (err) {
      console.error('[gridTableConfig] Unexpected error in saveColumnSize:', err);
    }
  }

  /**
   * Retrieves all stored column widths for the lead table from the database.
   * Scoped exclusively to GridType 8.
   */
  getColumnSizes(): void {
    this.gridService.getGridConfig().subscribe(
      (res: any) => {
        let config = null;
        if (Array.isArray(res)) {
          config = res.find(c => c.name === 'lead' || c.url === this.router.url) || res[0];
        } else if (res && res.data) {
          config = res;
        }

        if (config && config.data) {
          this.gridConfigId = config.id;
          try {
            this.columnWidths = JSON.parse(config.data);
          } catch (e) {
            console.error('[gridTableConfig] Failed to parse stored column widths:', e);
            this.columnWidths = {};
          }
          this.cdr.markForCheck();
        }
      },
      err => {
        console.error('[gridTableConfig] Failed to read column sizes from API:', err);
      }
    );
  }

  // ─────────────────────────────────────────────────────────────────────────────

  /**
   * Called by (widthResized) events from the [appResizable] directive.
   * - For GridType 8: persists via structured JSON and keeps columnWidths in sync.
   * - For other grid types: just updates the in-memory map (directive handles its own storage).
   */
  onColumnResized(column: string, width: number): void {
    if (this.columnWidths[column] === width) {
      return;
    }
    this.columnWidths[column] = width;
    this.cdr.markForCheck();
  }

  /**
   * Only called when the user releases the resize handle.
   * Scoped to GridType 8 (DB persistence).
   */
  onColumnResizeEnd(column: string, width: number): void {
    if (this.GridType === 8) {
      this.saveColumnSize(column, width);
    }
  }
  useDefaultHeading: any = false;
  selectUpload: boolean = false;
  leadDetailType: any = 0;
  leadDetailPageType: any = 0;
  leadTypeInMobile: any = 0;
  display: boolean;
  leadCallList: any;
  unAssigneLeadCalls: any = [];
  newlyAddedList: any = [];
  tableDesign: any;
  data: Object;
  GridType: any = 1;
  noteList: any;
  storeName: any;
  currentLeadID: any = '';
  LeadDetaisobject: any;
  whatsAppCustomUrl: any = 0;
  whatAppUrl: any;
  callDurationAppEnabled: any = 0;
  leadFilterType: number;
  storeNameAdded: boolean;
  leadObject: any;
  pageListThree: any;
  pageListFour: any;
  pageListFive: any;
  pageListTwo: any;
  defaultSet: any;
  filterType: any = 1;
  dialerType: any;
  authorizationToken: string = '';
  frejunEmail: string = '';
  dialerVisible: boolean = false;
  dialerLoaded: boolean = false;
  authRequired: boolean = false;
  crmSettingsData: any;
  useIndividualMail: any = 0;
  configData: any;
  displayOwner: boolean;
  todayUntochedCnt: any;
  assignLeadCnt: any;
  sortEnabled: boolean = false;
  sortDirection: number | boolean;
  sortParamNew: any;
  totalLeadCount: any;
  newContactCount: any;
  currentRouterPath: any;
  allEntityIds: any;
  templateDisplayed: any;
  storename: any;
  columnsVisble: ListColumn[];
  selectedLeadStat: string = 'total';
  lastValue: any;
  notesType: any;
  entityId: any;
  contactPage: boolean = false;
  searchContact: any = 'isClosedWon:*1,*';
  title: string;
  connectedCall: boolean = false;
  encryptPhone: any;
  encryptEmail: any;
  customValue: boolean;
  typeSequence: number = 1;
  showFailedRecords: boolean = false;
  failedRecords: any[] = [];
  leadPageIconVisibility: number = 0;
  webMobileCallEnable: any = 0;

  constructor(
    private leadService: LeadService,
    private crmNoteService: CrmNoteService,
    private ecryptService: EcryptServiceService,
    private productService: ProductService,
    private categoriesService: CategoriesService,
    private router: Router,
    private commonService: CommonService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private dataPipe: DatePipe,
    private crmsettingsService: CrmsettingsService,
    private whatsapptemplatemessageService: WhatsapptemplatemessageService,
    private leadStatusService: LeadStatusService,
    private cdr: ChangeDetectorRef,
    private leadActivityService: LeadActivityService,
    private loaderService: LoaderService,
    private gridService: GridService,
    private templateService: TemplateServiceService,
    private usersService: UsersService,
    private tagesStatusService: TagesStatusService,
    private companiesService: CompaniesService,
    private leadSourceService: LeadSourceService,
    private sequencesService: SequencesService,
    public websocket: WebsocketService,
    private smartViewsService: SmartViewsService,
    private userMailConfigService: UserMailConfigService,
    private realEstatePropertyService: RealEstatePropertyService

  ) {

    this.currentRouterPath = this.router.url;



    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.guide.start('lead-guide', LEAD_GUIDE);
    // }, 300);
  }

  isFavorite = false;

  toggleFavorite(leadData: any): void {


    leadData.favourite = leadData.favourite == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      favourite: leadData.favourite

    }

    this.loaderService.show();

    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";

          this.getLead();


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();

      }
    );
  }


  getAllTabs() {
    const tabs: { key: string; type: 'new' | 'all' | 'smart'; data?: any }[] = [];

    if (!this.contactPage && !this.connectedCall) {
      tabs.push({ key: 'new', type: 'new' });
      tabs.push({ key: 'all', type: 'all' });
    }

    if (this.contactPage) {
      tabs.push({ key: 'all', type: 'all' });
    }

    this.smartViewList.forEach(tab => {
      tabs.push({ key: tab.tabName, type: 'smart', data: tab });
    });

    return tabs;
  }


  scrollTabs(direction: 'left' | 'right', event: Event) {

    const tabs = this.getAllTabs();
    if (!tabs.length) return;

    const currentIndex = tabs.findIndex(t => t.key === this.activeTab);
    if (currentIndex === -1) return;

    const nextIndex =
      direction === 'right'
        ? (currentIndex + 1) % tabs.length
        : (currentIndex - 1 + tabs.length) % tabs.length;

    const nextTab = tabs[nextIndex];


    const tabElements = Array.from(
      this.tabsScroll.nativeElement.querySelectorAll('.tab-item')
    ) as HTMLElement[];

    const targetEl = tabElements.find(el =>
      el.textContent?.trim().toLowerCase() === nextTab.key.toLowerCase()
    );

    const container = this.tabsScroll.nativeElement as HTMLElement;

    if (direction === 'right' && nextIndex === 0) {
      container.scrollLeft = 0;
    }

    if (direction === 'left' && nextIndex === tabs.length - 1) {
      container.scrollLeft = container.scrollWidth;
    }

    if (nextTab.type === 'smart') {
      this.onClickTabData(nextTab.data);
    } else {
      this.onTabClick(nextTab.key as any, event);
    }

    setTimeout(() => {
      if (targetEl) {
        this.scrollToTabElement(targetEl);
      }
    });
  }


  private getTabItemsAndActiveIndex(): { tabItems: HTMLElement[]; labels: string[]; activeIndex: number } {
    const el: HTMLElement | undefined = this.tabsScroll?.nativeElement;
    const tabItems: HTMLElement[] = el ? Array.from(el.querySelectorAll('.tab-item')) as HTMLElement[] : [];

    const getLabel = (t: HTMLElement) => {
      const textNode = Array.from(t.childNodes).find(n => n.nodeType === Node.TEXT_NODE) as Text;
      return textNode ? (textNode.textContent || '').trim() : (t.textContent || '').trim();
    };

    const labels = tabItems.map(t => (getLabel(t) || '').trim());

    let activeIndex = tabItems.findIndex(t => t.classList.contains('active'));
    if (activeIndex === -1 && this.activeTab) {
      const lowerActive = String(this.activeTab).toLowerCase();
      activeIndex = labels.findIndex(l => l && l.toLowerCase().startsWith(lowerActive));
    }
    if (activeIndex === -1) activeIndex = 0;

    return { tabItems, labels, activeIndex };
  }

  private scrollToTabElement(el: HTMLElement) {
    const container = this.tabsScroll.nativeElement as HTMLElement;

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const currentScroll = container.scrollLeft;

    const elCenter =
      elRect.left - containerRect.left + currentScroll - (containerRect.width / 2) + (elRect.width / 2);

    container.scrollTo({
      left: elCenter,
      behavior: 'smooth'
    });
  }


  private scrollAndActivateTabByLabel(labelStart: string | null | undefined, activateType?: 'all' | 'new' | 'smart' | 'none') {
    // If labelStart is falsy, do nothing (safe guard)
    if (!labelStart) return;
    try {
      const { tabItems, labels } = this.getTabItemsAndActiveIndex();
      const idx = labels.findIndex(l => l && l.toLowerCase().startsWith((labelStart || '').toLowerCase()));
      if (idx >= 0 && tabItems[idx]) {
        const targetEl = tabItems[idx];
        this.scrollToTabElement(targetEl);
      } else {
        // nothing to scroll; helper intentionally does not activate tabs
      }
    } catch (e) {
      // ignore errors; this helper only scrolls and won't change active tab
    }
  }
  onPageSizeChange() {
    const event = {
      length: this.pageList,
      pageIndex: this.page,
      pageSize: this.sizeone,
      // previousPageIndex: this.previousPageIndex
    };

    this.getUpdate(event);
  }


  walkIn(leadData: any): void {


    leadData.walkIn = leadData.walkIn == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      walkIn: leadData.walkIn

    }
    this.loaderService.show();
    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";

          this.getLead();


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();

      },
      () => {
        this.loaderService.hide();

      }
    );
  }

  flag(leadData: any, i): void {

    this.dialClose();

    leadData.flag = leadData.flag == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      flag: leadData.flag

    }

    this.loaderService.show();
    this.openFlagStage(leadData, i);
    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";

          this.getLead();


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();

      }
    );
  }

  toggleEdit(element: any, field: string) {
    switch (field) {
      case 'name': // ✅ NEW for name field
        element.isEditingName = !element.isEditingName;
        break;
      case 'customValuesIsAccount':
        element.isEditingAccount = !element.isEditingAccount;
        break;
      case 'jobtitle':
        element.isEditingJobTitle = !element.isEditingJobTitle;
        break;
      case 'email':
        element.isEditingEmail = !element.isEditingEmail;
        break;
      case 'Tags':
        element.isEditingTags = !element.isEditingTags;
        break;
      case 'ownerIdName':
        element.isEditingSaleOwners = !element.isEditingSaleOwners;
        break;
      case 'phoneNumber':  // Corrected field for phone number
        element.isEditingPhoneNumber = !element.isEditingPhoneNumber;
        break;
      case 'statusName':  // Corrected field for status
        element.isEditingStatusName = !element.isEditingStatusName;
        break;
      default:
        break;
    }
  }

  selectedRow: any = null;

  editAllFields(row: any) {
    console.log("Edit all fields:", row);
  }

  addMeeting(row: any) {
    console.log("Add meeting:", row);
  }

  addCallLog(row: any) {
    console.log("Add call log:", row);
  }

  sendSmsMobile(row: any) {
    console.log("Send SMS to mobile:", row);
  }

  sendSmsWork(row: any) {
    console.log("Send SMS to work:", row);
  }

  cloneRow(row: any) {
    console.log("Clone row:", row);
  }

  deleteRow(row: any) {
    console.log("Delete row:", row);
  }

  unsubscribeRow(row: any) {
    console.log("Unsubscribe row:", row);
  }

  forgetRow(row: any) {
    console.log("Forget row:", row);
  }

  get visibleColumns(): string[] {
    if (!this.columns || !Array.isArray(this.columns)) {
      return [];
    }
    const cols = this.columns
      .filter(column => column && column.visible && column.property != null && column.property !== '' && column.property !== 'null' && column.property !== 'undefined')
      .map(column => column.property);
    return Array.from(new Set(cols));
  }

  isSpecialColumn(property: string): boolean {
    if (!property) return false;
    const specialProps = new Set([
      'actions', 'name', 'lastActivityNotes', 'statusName', 'totalCallDuration',
      'note', 'followUpDateTimePopup', 'deal', 'score', 'status', 'sourceName',
      'createdDate', 'activityCountOnLead', 'CrNo_cust', 'CrName_cust',
      'choiceofprogram', 'preferablelanguage', 'college', 'collegeName',
      'jobtitle', 'department', 'district', 'parentsnumber', 'yearofstudy',
      'section', 'quoted', 'updatedDate', 'adGroupName', 'Country', 'City',
      'State', 'flag', 'priority', 'phoneNumber', 'icons', 'walkIn', 'favourite',
      'select'
    ]);
    return specialProps.has(property);
  }


  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "1").subscribe(
      res => {
        this.noteList = res;
      },
      () => {

      }
    )
  }

  mapperMap = new Map<string, string>();
  isMobile = false;


  enableSequence: boolean = false
  @Input() leadsTableView: number = 1;

  @ViewChild('companyInput') companyInput!: ElementRef<HTMLInputElement>;

  ngOnInit() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        if (data != null) {
          this.useIndividualMail = data['useIndividualMail'];
          this.storename = data.storeName;

          if (this.useIndividualMail == 1) {
            this.fromEmailId.setValidators([Validators.required]);
            this.fromEmail.setValidators([Validators.required]);
          } else {
            this.fromEmailId.clearValidators();
            this.fromEmail.clearValidators();
          }
          this.fromEmailId.updateValueAndValidity();
          this.fromEmail.updateValueAndValidity();
        }
      } catch (error) {
        console.error("Failed to decrypt crmSettingsData in ngOnInit:", error);
      }
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const targetUrl = event.urlAfterRedirects || event.url || '';
        if (!targetUrl.includes('/lead') && !targetUrl.includes('/contact')) {
          localStorage.removeItem("activeTab");
          localStorage.removeItem("smartViewConditionsEnble");
        }
      }
    });

    this.ensureSmartViewFromFilter();

    if (this.router.url.includes('contact')) {

      this.title = 'Contacts'

      this.contactPage = true;

    } else {
      this.title = 'Lead'

    }

    if (this.router.url.includes('connectedCalls')) {

      this.title = 'connectedCalls'

      this.connectedCall = true;

    }


    this.checkScreen();


    if (window.innerWidth < 822) {
      this.display = false;
    } else {
      this.display = true
    }

    this.getResource();

    this.getEmailTemplateMessageList();

    this.EmailTemplateMessageYFilter();

    this.getUserDropDownList();

    this.usertypeYFilter();

    this.getLeadStatusList();

    this.LeadStatusYFilter();

    this.getAllTags();

    this.TagsYFilter();

    this.getLeadSourceDownList();

    this.LeadSourceYFilter();

    this.getALLSmartViewsNew();

    this.getAllUserMailConfig();

    this.typeEmailYFilter();

    this.loadMasterProducts();
    this.loadMasterCategories();


    const encryptedConfig = localStorage.getItem('configSettingsData')

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';



    if (encryptedConfig) {

      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        this.configData = JSON.parse(decrypted);
        this.GridType = this.configData.gridType;
        this.filterType = this.configData.filterType;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    if (this.GridType === 8) {
      this.getColumnSizes();
    }

    if (this.storename) {
      this.storeNameAdded = true;
      this.storeName = localStorage.getItem("storeName");

    } else {
      this.storeNameAdded = false;
    }

    this.text = "Save";

    this.textSend = "Send";

    this.getWhatsappTemplateMessageList();
    this.WhatsappTemplateMessageYFilter();
    this.getLeadDropDownList();
    this.getAllCountry();
    this.typeYFilter();
    this.mapperMap.set('adGroupName', 'adGroupName_configurableProduct');
    this.mapperMap.set('Country', 'Country_cust');
    this.mapperMap.set('City', 'City_cust');
    this.mapperMap.set('State', 'State_cust');
    this.mapperMap.set('Product', 'Product_cust');
    this.mapperMap.set('product', 'Product_cust');
    this.mapperMap.set('Category', 'Category_cust');
    this.mapperMap.set('category', 'Category_cust');
    this.mapperMap.set('quoted', 'QuotedValuecustomField10');
    this.mapperMap.set('College', 'collegeName');
    this.mapperMap.set('Company', 'company');
    this.mapperMap.set('department', 'DepartmentcustomField10');
    this.mapperMap.set('district', 'DistrictcustomField10');
    this.mapperMap.set('parentsnumber', 'ParentsNumbercustomField10');
    this.mapperMap.set('yearofstudy', 'YearOfStudycustomField10');
    this.mapperMap.set('section', 'SectioncustomField1');
    this.mapperMap.set('choiceofprogram', 'ChoiceOfProgramcustomField10');
    this.mapperMap.set('preferablelanguage', 'PreferableLanguagecustomField10');
    this.textAccount = 'OK';
    this.textAccountHousing = 'OK';
    this.downloadDataComplete = 'OK';
    this.urlPage = this.route.snapshot.queryParamMap.get("page")
    this.urlSize = this.route.snapshot.queryParamMap.get("size")
    this.urlSort = this.route.snapshot.queryParamMap.get("sort")

    if (this.urlPage != null) {

      this.page = this.urlPage
    }

    if (this.urlSize != null) {

      this.size = this.urlSize

    }

    if (this.urlSort != null) {

      this.sortParam = this.urlSort
    }

    if (this.sortParam == null) {

      this.sortParam = 'updatedDate' + "," + Constant.Dsc;

    }


    if (this.urlPage != null) {
      this.redirected = true;
    }
    if (this.leadsTableView == 1) {
      this.tableViewMode = 'tableView';
    }
    this.tableDesign = 1;


    if (this.smartViewConditionsEnble) {
      const activeTab = localStorage.getItem('activeTab');
      this.scrollAndActivateTabByLabel(activeTab, 'none');
    }


    this.cdr.detectChanges();

    const storedViewMode: any = localStorage.getItem('leadsViewMode');

    if (storedViewMode !== null && storedViewMode !== '') {
      this.tableViewMode = storedViewMode;
      this.viewMode = 'compact';
    } else {
      this.tableViewMode = this.router.url.includes('lead')
        ? 'tableView'
        : 'kanbanView';
      this.viewMode = 'compact';
    }



  }
  hideAdd = false


  checkScreen() {
    this.isMobile = window.innerWidth <= 768; // adjust breakpoint as needed
  }



  openLeadPopup(setId, leadId) {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(LeadDynamicFormComponent, {
        width: '1000px',
        height: '100vh ',
        disableClose: true,
        data: {
          setId: setId,
          leadId: leadId
        },
        panelClass: 'custom-dialog-container'
      });


      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {

          this.ngOnInit();

        }

      });
    }
    else {
      let dialogRef = this.dialog.open(LeadDynamicFormComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,

        data: {
          setId: setId,
          leadId: leadId
        },
        panelClass: 'custom-dialog-container'

      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


          this.ngOnInit();

        }
      });
    }
  }

  getUntouchedLed() {
    let search = 'statusName:*Pending,New,*';

    let page: any = Constant.PAGE;
    let size: any = Constant.SIZE;
    let sortParam: any = 'updatedDate' + "," + Constant.Dsc;

    this.spinner = true;
    this.productService.getLeadBySearch(search, page, size, sortParam).subscribe(
      res => {
        this.spinner = false;
        this.pageListFour = res['totalElements'];

      },
      () => {
        this.spinner = false;
      })
  }

  getTodayLead() {
    let page: any = Constant.PAGE;
    let size: any = Constant.SIZE;
    let sortParam: any = 'updatedDate' + "," + Constant.Dsc;
    let todayDate: Date = new Date();
    const formattedDate = todayDate.toISOString().split('T')[0];
    let search = `createdDate:*${formattedDate}~${formattedDate}*`;
    this.spinner = true;
    this.productService.getLeadBySearch(search, page, size, sortParam).subscribe(
      res => {

        this.pageListThree = res['totalElements'];

      },
      () => {
        this.spinner = false;
      })
  }

  getUnassignedlead() {
    let page: any = Constant.PAGE;
    let size: any = Constant.SIZE;
    let sortParam: any = 'updatedDate' + "," + Constant.Dsc;
    let todayDate: Date = new Date();
    let formattedDate = todayDate.toISOString().split('T')[0];


    let search = `createdDate:*${formattedDate}~${formattedDate}* OR transferDate:*${formattedDate}~${formattedDate}*`;

    // 


    this.spinner = true;
    this.productService.getLeadBySearch(search, page, size, sortParam).subscribe(
      res => {

        this.pageListFive = res['totalElements'];

      },
      () => {
        this.spinner = false;
      })
  }
  getLead() {
    let page: any = 0;
    let size: any = 1;
    let sortParam: any = 'updatedDate' + "," + Constant.Dsc;
    let sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;
    this.spinner = true;

    if (this.contactPage) {

      this.searchContact = "isClosedWon:*1,*";

      this.filterOption(this.search);

    } else {

      this.productService.getLead(page, size, sortParam != undefined ? sortParam : sortParamInit).subscribe(
        res => {
          this.spinner = false;
          this.pageListTwo = res['totalElements'];

          this.notifyKanbanUpdate();

        },
        () => {
          this.spinner = false;
        }
      )

    }


  }
  bulkUpload: boolean = false;
  _form: UntypedFormGroup;

  phonewhatsapp(data) {

    console.log("The Curren row data is ", data);

    if (this.whatsAppCustomUrl == 0) {


      let message = `Hi ${data.name}, I'm from ${this.storeName}.\n`;

      if (!this.storeNameAdded) {
        message = `Hi ${data.name};`
      }

      let url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(data.phoneNumber)}&text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    } else if (this.whatsAppCustomUrl == 2) {
      let contactUid = data?.whatsappContactUid || data?.contactUid || data?.uid;
      let rawPhone = data?.phoneNumber || data?.mobile || data?.phone || '';
      let phoneNumber = rawPhone ? rawPhone.toString().replace(/\D/g, "") : '';
      let target = contactUid || phoneNumber;

      if (target) {
        this.dialog.closeAll();
        this.router.navigate(['/whatsAppChat'], { queryParams: { contact: target } });
      } else {
        alert("Contact information not available");
      }
    } else {
      let url = this.whatAppUrl;
      window.open(url, '_blank');
    }

    this.dialog.closeAll();
  }


  phoneNumbercall(data) {
    if (this.webMobileCallEnable == 1) {

      this.leadActivityService.sendWebToMobileCall(data).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => { });

    } else {

      if (this.dialerType == 1) {
        this.leadActivityService.makeCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          () => {

          });
      }
      else if (this.dialerType == 2) {
        this.opendialCallsa(data)
        this.callANumber1(data, data.phoneNumber)
      }

      else if (this.dialerType == 3) {
        this.loaderService.show();

        let payload = {
          ...data,
          phoneNo: data.phoneNumber,
          phone: data.phoneNumber
        };

        this.leadActivityService.makeDooctiClickToCall(payload).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          () => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 5 || this.dialerType == 9) {
        this.loaderService.show();
        this.leadActivityService.makeTelecmi(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          () => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 6) {
        this.loaderService.show();
        this.leadActivityService.clickToCallAcefone(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          () => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 7) {
        this.callANumberNew(data)
      }
      else if (this.dialerType == 12) {
        this.initiateFrejunCall(data.phoneNumber, data.name);
      }
      else if (this.dialerType == 8) {
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            // width: '400px',
            height: 'auto',          // optional
            position: {
              bottom: '2px',        // distance from bottom
              right: '2px'          // distance from right
            },
            disableClose: true,
            data: {
              phone: data.phoneNumber
            }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });

        }
        else {
          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            minWidth: '100vw', height: '100vh',
            data: {
              phone: data.phoneNumber
            }
          });
          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });
        }
      }

      else if (this.dialerType == 10) {
        this.loaderService.show();
        this.leadActivityService.callForBuzzDieal(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          () => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 11) {
        this.loaderService.show();
        this.leadActivityService.calltoElevenlabs(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          () => {
            this.loaderService.hide();
          });

      }

      else {

        this.loaderService.hide();

        this.addLeadActivity('Phone Call', 0, null, data.entityId)
      }
    }
  }
  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }

  dialerEnable: boolean = false;
  lastDialedNumber: any;
  LeadDetailsObject: any;
  @ViewChild('myHelloSendFrame', { static: false }) myHelloSendFrame: ElementRef;

  onIframeLoaded() {
    setTimeout(() => {
      if (!this.myHelloSendFrame?.nativeElement) {
        console.error('iframe element not yet available');
        return;
      }
      this.callANumberNew(this.lastDialedNumber);
    }, 0); // allow next change detection cycle
  }

  callANumberNew(number: string) {
    const iframeWindow = this.myHelloSendFrame?.nativeElement?.contentWindow;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }

    const postData = {
      entity_type: "Lead",
      entity_id: this.LeadDetailsObject.entityId,
      entity_name: this.LeadDetailsObject.name,
      entity_number: this.LeadDetailsObject.phoneNumber.toString(),
      user_email: this.LeadDetailsObject.ownerEmail,
      user_id: this.LeadDetailsObject.ownerId,
      event_action: "click2call"
    };

    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));


    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }

  callNotes(data) {

    console.log("data", data);

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": 'Phone Call',
          "type": "lead",
          "leadId": data.entityId,
          "activityId": data.activityId,
          "leadObject": data.lead,
          "templateDisplayed": "",
          "taskSaveType": 1,
          "callnoteEnable": 1,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": 'Phone Call',
          "type": "lead",
          "leadId": data.entityId,
          "activityId": data.activityId,
          "leadObject": data.lead,
          "templateDisplayed": "",
          "taskSaveType": 1,
          "callnoteEnable": 1,
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

        }


      });
    }


  }

  dialerShow: boolean = false;

  opendialCall(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    // console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }


  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }
  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://app.doocti.com/') {
      return;
    }

    // console.log('Received message from iframe:', event.data);
  }


  getPriorityLetter(value: string): string {
    return value ? value.charAt(0).toUpperCase() : 'M';
  }

  toggleAllRows(isChecked: boolean) {
    if (isChecked) {
      this.selection.select(...this.productList);
      this.selectionLead = this.productList.map(row => row.entityId);
      this.leadIdList = this.productList.map(row => ({
        ...row,
        ownerId: row.ownerId,
        leadId: row.entityId,
        phoneNo: row.phoneNumber,
        status: row.statusName,
        downloadList: row.downloadList,
        entityId: row.entityId,
        email: row.email,
        name: row.name,
        activityCountOnLead: row.activityCountOnLead
      }));
    } else {
      this.selection.clear();
      this.selectionLead = [];
      this.leadIdList = [];
    }
    // console.log("Updated leadIdList:", this.leadIdList);
    this.onConfirAttribute.emit(this.attributeListForProduct);
  }


  secondaryphonewhatsapp(data) {
    // console.log("The Curren row data is ", data);

    let message = `Hi ${data.collegeName}, I'm from ${this.storeName}.\n`;
    let url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent("data.Secondaryphoneno")}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    this.dialog.closeAll();
  }

  secondaryphoneNumbercall(data) {
    // console.log("The Curren row data is ", data);

    let call = data.secondaryphoneno;
    let phonenumber;
    if (this.crmType == 4) {
      this.opendialCall(data)
      this.callANumber(data, data.secondaryphoneno)
    }
    else {

      if (data.secondaryphoneno.includes('+')) {
        phonenumber = "tel:" + call;
      } else {
        phonenumber = "tel:+" + data.phoneNumber;
      }

      window.location.href = phonenumber;

    }
  }


  gridColumnList: ListColumn[] = [];

  customGridType: any;

  leadToCustomer: any;


  ngOnDestroy(): void {
    this.detachScrollListeners();
  }

  initiateFrejunCall(candidateNumber: string, candidateName?: string) {
    let formattedNumber = candidateNumber ? candidateNumber.toString().trim() : '';
    if (formattedNumber && !formattedNumber.startsWith('+')) {
      formattedNumber = '+' + formattedNumber;
    }

    console.log('FreJun: dispatching initiate-call event', { number: formattedNumber, name: candidateName });
    window.dispatchEvent(new CustomEvent('frejun:initiate-call', {
      detail: {
        number: formattedNumber,
        name: candidateName || ''
      }
    }));
  }


  // Called from the inline input (on input event)
  onInlineCompanyInput(event: Event, element: any) {
    const inputElement = event.target as HTMLInputElement;
    // remove leading spaces right away
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
      // update model so UI and internal state stay in sync
      element.company = noLeading;
    }
    const inputValue = noLeading.trim();
    if (inputValue.length > 0) {
      this.getCompanyData(inputValue);
    }
    this.attachScrollListenersForElement(inputElement);
  }

  onInlineAutocompleteClosed(element: any) {
    // If element already has a CompanyId, preserve it
    if (element && element.CompanyId > 0) {
      this.detachScrollListeners();
      return;
    }

    const typed = (element && element.company) ? ('' + element.company).trim() : '';
    if (!typed) {
      this.detachScrollListeners();
      return;
    }

    const match = (this.companyList || []).find(opt => ((opt.name || '') + '').toLowerCase() === typed.toLowerCase());
    if (!match) {
      // clear typed value and any company id
      element.company = '';
      element.CompanyId = null;
    }

    this.detachScrollListeners();
  }

  closeAllAutocompletePanels() {
    if (!this.autocompleteTriggers) {
      return;
    }
    this.autocompleteTriggers.forEach(trigger => {
      try {
        if (trigger && trigger.panelOpen) {
          trigger.closePanel();
        }
      } catch (e) {
        // ignore
      }
    });
    this.detachScrollListeners();
  }

  private attachScrollListenersForElement(el: HTMLElement) {
    if (!el || !document) return;

    this.detachScrollListeners();

    const windowHandler = () => this.closeAllAutocompletePanels();
    // listen for scroll, wheel and touchmove so horizontal scrolls and touch gestures also close panels
    window.addEventListener('scroll', windowHandler, { passive: true });
    window.addEventListener('wheel', windowHandler, { passive: true });
    window.addEventListener('touchmove', windowHandler, { passive: true });
    this._scrollableListeners.push({ el: window as any, handler: windowHandler });

    let parent: HTMLElement | null = el.parentElement;
    while (parent) {
      try {
        const style = getComputedStyle(parent);
        const overflowY = style.overflowY;
        const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && parent.scrollHeight > parent.clientHeight;
        if (isScrollable) {
          const handler = () => this.closeAllAutocompletePanels();
          parent.addEventListener('scroll', handler, { passive: true });
          parent.addEventListener('wheel', handler, { passive: true });
          parent.addEventListener('touchmove', handler, { passive: true });
          this._scrollableListeners.push({ el: parent, handler });
        }
      } catch (e) { }
      parent = parent.parentElement;
    }
  }

  private detachScrollListeners() {
    if (!this._scrollableListeners || this._scrollableListeners.length === 0) return;
    this._scrollableListeners.forEach(item => {
      try {
        if (item.el === window) {
          try { window.removeEventListener('scroll', item.handler as EventListener); } catch (e) { }
          try { window.removeEventListener('wheel', item.handler as EventListener); } catch (e) { }
          try { window.removeEventListener('touchmove', item.handler as EventListener); } catch (e) { }
        } else if (item.el && item.handler) {
          try { item.el.removeEventListener('scroll', item.handler as EventListener); } catch (e) { }
          try { item.el.removeEventListener('wheel', item.handler as EventListener); } catch (e) { }
          try { item.el.removeEventListener('touchmove', item.handler as EventListener); } catch (e) { }
        }
      } catch (e) { }
    });
    this._scrollableListeners = [];
  }

  // Flags to disable/enable arrow buttons
  isAtStart = true;
  isAtEnd = false;



  getAllCrmData() {

    this.getAllTags();
    this.TagsYFilter();
    this.ensureSmartViewFromFilter();

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.templateDisplayed = data['templateDisplayed'];
          if (data['defaultSet'] == null) {

            this.crmsettingsService.getCrmSettingsData()
              .subscribe(
                (setting: any) => {
                  const encryptedCrmSettings = this.ecryptService.encryptionAES(JSON.stringify(setting));
                  localStorage.setItem('crmSettingsData', encryptedCrmSettings);
                  this.getAllCrmData();
                },
                () => {

                }
              );

          }

          if (data['webMobileCallEnable'] != undefined) {
            this.webMobileCallEnable = data['webMobileCallEnable'];
          } else {
            this.webMobileCallEnable = 0;
          }

          this.notesType = data['notesType'];

          this.crmType = data['crmType'];

          this.dialerType = data['dialerType'];

          this.authorizationToken = data['authorizationToken'];

          this.leadDetailType = data['leadDetailType'];

          this.leadDetailPageType = data['leadDetailPageType'];

          this.leadTypeInMobile = data['leadTypeInMobile'];

          this.whatsAppCustomUrl = data['whatsAppCustomUrl'];

          this.whatAppUrl = data['whatAppUrl'];

          this.leadFilterType = data['leadFilterType'];

          this.customGridType = data['customGridType'];

          this.leadToCustomer = data['leadToCustomer'];

          this.callDurationAppEnabled = data['callDurationAppEnabled'];

          this.defaultSet = data['defaultSet'];

          this.enableEditStatusPopup = data['enableEditStatusPopup'];

          this.enableSequence = data['enableSequences'] == 1 ? true : false;
          if (this.enableSequence) {
            this.typeSequncesYFilter();
            this.typeidSequnceYFilter();
          }

          this.defaultSetType = data['defaultSetType'];
          this.useIndividualMail = data['useIndividualMail'];
          if (this.useIndividualMail == 1) {
            this.fromEmailId.setValidators([Validators.required]);
            this.fromEmail.setValidators([Validators.required]);
          } else {
            this.fromEmailId.clearValidators();
            this.fromEmail.clearValidators();
          }
          this.fromEmailId.updateValueAndValidity();
          this.fromEmail.updateValueAndValidity();

          this.sortEnabled = data['updateUpdatedDate'] == 1 ? true : false;

          this.sortParamNew = data['sortParam'] == undefined ? 'updatedDate' : data['sortParam'];

          this.sortDirection = data['sortDirection'] == undefined ? 1 : data['sortDirection'];
          this.leadPageIconVisibility = data['leadPageIconVisibility'] == undefined ? 0 : data['leadPageIconVisibility'];

          let value = localStorage.getItem(Constant.Sup);
          if (value != undefined) {

            if (value == 'salesUser') {


              this.encryptPhone = data['encryptedPhoneNumber'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.encryptEmail = data['encryptedEmailId'] == undefined ? 0 : data['encryptedPhoneNumber'];

            } else {
              this.encryptPhone = 0;
              this.encryptEmail = 0;
            }

          } else {
            this.encryptPhone = 0;
            this.encryptEmail = 0;
          }

          if (this.sortEnabled) {

            if (this.sortDirection == 1) {
              this.sortParam = this.sortParamNew + "," + Constant.Dsc;
            } else {
              this.sortParam = this.sortParamNew + "," + Constant.Asc;
            }


          }

          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);



          this.initCrmType = true;

          if (this.initCrmType = true) {


            if (this.crmType == 1) {
              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Email', property: 'email', visible: false, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'Activity Count', property: 'activityCountOnLead', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Country', property: 'Country', visible: false, isModelProperty: false },
                { name: 'City', property: 'City', visible: true, isModelProperty: false },
                { name: 'State', property: 'State', visible: false, isModelProperty: false },
                { name: 'Campaign Name', property: 'adGroupName', visible: false, isModelProperty: false },
                { name: 'Budget', property: 'budget', visible: true, isModelProperty: true },
                { name: 'Budget Min', property: 'budgetMin', visible: true, isModelProperty: true },
                { name: 'Sub Loction', property: 'subLocation', visible: true, isModelProperty: true },
                { name: 'Last Activity Notes', property: 'lastActivityNotes', visible: false, isModelProperty: false },
                { name: 'Cr No', property: 'CrNo_cust', visible: false, isModelProperty: false },
                { name: 'Cr Name', property: 'CrName_cust', visible: false, isModelProperty: false },
                { name: 'Call Durations', property: 'totalCallDuration', visible: true, isModelProperty: false },
                { name: 'Score', property: 'score', visible: true, isModelProperty: false },
                { name: 'Notes', property: 'notes', visible: false, isModelProperty: true },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  modelValue: '',
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },
                {
                  name: 'Email',
                  property: 'email',
                  type: 'text',
                  position: 'thirdValue',
                  options: []
                },
                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'fourthValue',
                  options: []
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'fifthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Source Name',
                  property: 'sourceName',
                  type: 'select',
                  position: 'sixthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'seventhValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Activity Count',
                  property: 'activityCountOnLead',
                  type: 'text',
                  position: 'eighthValue',
                  options: []
                },
                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'ninthValue',
                  options: []
                },

                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'tenthValue',
                  options: []
                },
                {
                  name: 'Country',
                  property: 'Country_cust',
                  type: 'select',
                  position: 'eleventhValue',
                  options: []
                },
                {
                  name: 'City',
                  property: 'City_cust',
                  type: 'text',
                  position: 'TwelfthValue',
                  options: []
                },
                {
                  name: 'State',
                  property: 'State_cust',
                  type: 'text',
                  position: 'thirteenValue',
                  options: []
                },
                {
                  name: 'Campaign Name',
                  property: 'adGroupName_configurableProduct',
                  type: 'text',
                  position: 'fourteenValue',
                  options: []
                },
                {
                  name: 'Budget',
                  property: 'budget',
                  type: 'text',
                  position: 'fivteenthValue',
                  options: []
                },
                {
                  name: 'Budget Min',
                  property: 'budgetMin',
                  type: 'text',
                  position: 'sixteenthValue',
                  options: []
                },
                {
                  name: 'Sub Loction',
                  property: 'subLocation',
                  type: 'text',
                  position: 'seventeenthValue',
                  options: []
                },

                {
                  name: 'Last Activity notes',
                  property: 'lastActivityNotes',
                  type: 'text',
                  position: 'eighteenthValue',
                  options: []
                },

                {
                  name: 'Cr No',
                  property: 'CrNo_cust',
                  type: 'text',
                  position: 'nighteenthValue',
                  options: []
                },

                {
                  name: 'Cr Name',
                  property: 'CrName_cust',
                  type: 'text',
                  position: 'TwentyValue',
                  options: []
                },

                {
                  name: 'Call Durations',
                  property: 'totalCallDuration',
                  type: 'text',
                  position: 'TwentyOneValue',
                  options: []
                },
                {
                  name: 'Score',
                  property: 'score',
                  type: 'text',
                  position: 'TwentyTwoValue',
                  options: []
                },



              ]

            }
            else if (this.crmType == 2) {
              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Lead Id', property: 'incrementId', visible: true, isModelProperty: true },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Email', property: 'email', visible: false, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Product', property: 'product', visible: true, isModelProperty: true },
                { name: 'Quoted Value', property: 'quoted', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'Sub lead Status', property: 'secondaryLeadStatus', visible: true, isModelProperty: true },
                { name: 'Follow Up Date', property: 'followUpDateTime', visible: true, isModelProperty: true },
                { name: 'Activity Count', property: 'activityCountOnLead', visible: true, isModelProperty: false },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'Country', property: 'Country', visible: false, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];
              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  name: 'Lead ID',
                  property: 'incrementId',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },
                {
                  modelValue: '',
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'thirdvalue',
                  options: []
                },
                {
                  modelValue: '',
                  name: 'E Mail',
                  property: 'email',
                  type: 'text',
                  position: 'fourthvalue',
                  options: []
                },

                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'fivthvalue',
                  options: []
                },
                {
                  name: 'Product',
                  property: 'product',
                  type: 'text',
                  position: 'sixthvalue',
                  options: []
                },
                {
                  name: 'Quoted Value',
                  property: 'QuotedValuecustomField10',
                  type: 'text',
                  position: 'seventhvalue',
                  options: [],
                  display: true
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'eighthvalue',
                  options: [],
                  display: true
                },
                {
                  name: 'Source Name',
                  property: 'sourceName',
                  type: 'select',
                  position: 'ninthvalye',
                  options: [],
                  display: true
                },
                {
                  name: 'Sub lead Status',
                  property: 'secondaryLeadStatus',
                  type: 'text',
                  position: 'tenthvalue',
                  options: []
                },
                {
                  name: 'Follow Up Date',
                  property: 'followUpDateTime',
                  type: 'date',
                  position: 'eleventhValue',
                  options: []
                },
                {
                  name: 'Activity Count',
                  property: 'activityCountOnLead',
                  type: 'text',
                  position: 'twlevthValue',
                  options: []
                },

                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'thirteenthvalue',
                  options: [],
                  display: true
                },
                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'fourteenthValue',
                  options: []
                },


                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'fivteenthvalue',
                  options: []
                },

                {
                  name: 'Country',
                  property: 'Country',
                  type: 'select',
                  position: 'sixteenthValue',
                  options: []
                },





              ]

            }
            else if (this.crmType == 3) {


              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Personal Email', property: 'email', visible: false, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'College', property: 'collegeName', visible: true, isModelProperty: false },
                { name: 'Department', property: 'department', visible: true, isModelProperty: false },
                { name: 'Section', property: 'section', visible: true, isModelProperty: false },
                { name: 'Year Of Study', property: 'yearofstudy', visible: true, isModelProperty: false },
                { name: 'Parents Number', property: 'parentsnumber', visible: true, isModelProperty: false },
                { name: 'Choice Of Program', property: 'choiceofprogram', visible: true, isModelProperty: false },
                { name: 'Preferable Language', property: 'preferablelanguage', visible: true, isModelProperty: false },
                { name: 'Lead Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'District', property: 'district', visible: true, isModelProperty: false },
                { name: 'State', property: 'State', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  modelValue: '',
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },
                {
                  name: 'Personal Email',
                  property: 'email',
                  type: 'text',
                  position: 'thirdValue',
                  options: []
                },
                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'fourthValue',
                  options: []
                },
                {
                  name: 'College',
                  property: 'collegeName',
                  type: 'text',
                  position: 'fifthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Department',
                  property: 'department',
                  type: 'text',
                  position: 'sixthValue',
                  options: []
                },
                {
                  name: 'Section',
                  property: 'section',
                  type: 'text',
                  position: 'seventhValue',
                  options: []
                },

                {
                  name: 'Year Of Study',
                  property: 'yearofstudy',
                  type: 'text',
                  position: 'eighthValue',
                  options: []
                },
                {
                  name: 'Parents Number',
                  property: 'parentsnumber',
                  type: 'text',
                  position: 'ninthValue',
                  options: []
                },
                {
                  name: 'Choice Of Program',
                  property: 'choiceofprogram',
                  type: 'text',
                  position: 'tenthValue',
                  options: []
                },
                {
                  name: 'Preferable Language',
                  property: 'preferablelanguage',
                  type: 'text',
                  position: 'eleventhValue',
                  options: []
                },
                {
                  name: 'Lead Source',
                  property: 'sourceName',
                  type: 'select',
                  position: 'TwelfthValue',
                  options: []
                },
                {
                  name: 'District',
                  property: 'district',
                  type: 'text',
                  position: 'thirteenValue',
                  options: []
                },
                {
                  name: 'State',
                  property: 'State',
                  type: 'text',
                  position: 'fourteenValue',
                  options: []
                },
                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'fifteenValue',
                  options: []
                },

                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'sixteenthValue',
                  options: []
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'seventeenValue',
                  options: []
                },





              ]





            }

            else if (this.crmType == 4) {



              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'flag', property: 'flag', visible: true, isModelProperty: false },
                { name: 'Lead Id', property: 'incrementId', visible: true, isModelProperty: true },
                { name: 'Priority', property: 'priority', visible: true, isModelProperty: false },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Icons', property: 'icons', visible: true, isModelProperty: false },
                { name: 'College', property: 'collegeName', visible: true, isModelProperty: true },
                { name: 'Remark', property: 'remarks', visible: false, isModelProperty: true },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Walk In', property: 'walkIn', visible: true, isModelProperty: false },
                { name: 'Favourite', property: 'favourite', visible: true, isModelProperty: false },

                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  name: 'flag',
                  property: 'disable',
                  type: 'disable',
                  position: 'secondValue',
                  options: [],

                },
                {
                  modelValue: '',
                  name: 'Lead ID',
                  property: 'incrementId',
                  type: 'text',
                  position: 'thirdvalue',
                  options: []
                },

                {
                  modelValue: '',
                  name: 'Priority',
                  property: 'priority',
                  type: 'select',
                  position: 'fourthvalue',
                  options: [
                    { "value": "High", "viewValue": "High" },
                    { "value": "Medium", "viewValue": "Medium" },
                    { "value": "Low", "viewValue": "Low" },
                  ]
                },
                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'fivthvalue',
                  options: []
                },

                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'sixthvalue',
                  options: []
                },
                {
                  name: 'Icons',
                  property: 'disable',
                  type: 'disable',
                  position: 'seventhvalue',
                  options: []
                },
                {
                  name: 'College',
                  property: 'collegeName',
                  type: 'text',
                  position: 'eighthvalue',
                  options: []
                },
                {
                  name: 'Remarks',
                  property: 'remarks',
                  type: 'text',
                  position: 'ninthvalue',
                  options: [],

                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'tenthvalue',
                  options: []
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'eleventhValue',
                  options: [],

                },
                {
                  name: 'Updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'twelevthValue',
                  options: []
                },
                {
                  name: 'Walkin',
                  property: 'walkIn',
                  type: 'select',
                  position: 'thirteenValue',
                  options: [
                    { value: '1', viewValue: 'Yes' },
                    { value: '0', viewValue: 'No' },
                  ]
                },
                {
                  name: 'Favourite',
                  property: 'favourite$n',
                  type: 'select',
                  position: 'fourteenValue',
                  options: [
                    { value: 1, viewValue: 'Yes' },
                    { value: 0, viewValue: 'No' },
                  ]
                },




              ]





            }

            else if (this.crmType == 5) {


              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone Number', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Destination', property: 'destination', visible: true, isModelProperty: true },
                { name: 'Travel Type', property: 'travelType', visible: true, isModelProperty: true },
                { name: 'Boarding Date', property: 'boardingDate', visible: true, isModelProperty: true },
                { name: 'Owner', property: 'ownerEmail', visible: false, isModelProperty: true },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Lead Received Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },

                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },

                {
                  name: 'Phone Number',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'thirdvalue',
                  options: []
                },
                {
                  name: 'Destination',
                  property: 'destination',
                  type: 'text',
                  position: 'fourthvalue',
                  options: []
                },
                {
                  name: 'Travel Type',
                  property: 'travelType',
                  type: 'text',
                  position: 'fivthvalue',
                  options: []
                },
                {
                  name: 'Boarding Date',
                  property: 'boardingDate',
                  type: 'date',
                  position: 'sixthvalue',
                  options: []
                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'seventhvalue',
                  options: []
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'eighthvalue',
                  options: [],

                },
                {
                  name: 'Lead Received Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'ninthvalue',
                  options: []
                },


              ]





            }
            else if (this.crmType == 6) {

              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
                { name: 'Contact Id', property: 'incrementId', visible: true, isModelProperty: true },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Mobile', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Life Stage', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Deal', property: 'deal', visible: true, isModelProperty: false },
                { name: 'Status', property: 'status', visible: true, isModelProperty: false },
                { name: 'Priority', property: 'priority', visible: true, isModelProperty: false },
                { name: 'Note', property: 'note', visible: true, isModelProperty: false },
                { name: 'Assigned To', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'Upcoming Follow Up', property: 'followUpDateTimePopup', visible: true, isModelProperty: false },
                { name: 'Last Follow Up Date', property: 'followUpDateTime', visible: true, isModelProperty: true },
              ] as ListColumn[];

              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  name: 'Contact Id',
                  property: 'incrementId',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },

                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'thirdvalue',
                  options: []
                },
                {
                  name: 'Mobile',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'fourthvalue',
                  options: []
                },
                {
                  name: 'Life Stage',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'fivthvalue',
                  options: []
                },
                {
                  name: 'Deal',
                  property: 'deal',
                  type: 'text',
                  position: 'sixthvalue',
                  options: []
                },
                {
                  name: 'Status',
                  property: 'status',
                  type: 'select',
                  position: 'seventhvalue',
                  options: [],

                },
                {
                  name: 'Priority',
                  property: 'priority',
                  type: 'select',
                  position: 'eighthvalue',
                  options: [
                    { "value": "High", "viewValue": "High" },
                    { "value": "Medium", "viewValue": "Medium" },
                    { "value": "Low", "viewValue": "Low" },
                  ]
                },
                {
                  name: 'Note',
                  property: 'note',
                  type: 'text',
                  position: 'ninevalue',
                  options: []
                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'tenthvalue',
                  options: []
                },
                {
                  name: 'Upcoming Follow Up',
                  property: 'followUpDateTime',
                  type: 'date',
                  position: 'eleventhvalue',
                  options: []
                },
                {
                  name: 'Last Follow Up Date',
                  property: 'followUpDateTime',
                  type: 'date',
                  position: 'twelvethvalue',
                  options: []
                },
              ]
            }
            else if (this.crmType == 7) {


              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                {
                  name: 'Name', property: 'name', visible: true, isModelProperty: false,
                  cssClasses:
                    ['text-secondary', 'font-medium']
                },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Icons', property: 'icons', visible: true, isModelProperty: false },
                { name: 'Priority', property: 'priority', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Notes', property: 'notes', visible: true, isModelProperty: true },
                { name: 'Total Durations', property: 'totalCallDuration', visible: true, isModelProperty: false },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                // {
                //   name: 'Email', property: 'email', visible: true, isModelProperty: true,
                //   cssClasses: ['text-secondary', 'font-medium']
                // },
                { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'Activity Count', property: 'activityCountOnLead', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'Last Activity Notes', property: 'lastActivityNotes', visible: false, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.filterSelectObj = [
                {
                  name: 'Select',
                  property: 'select1',
                  type: 'disable',
                  position: 'firstssValue',
                  options: []
                },
                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'firstValue',
                  options: []
                },
                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },
                {
                  name: 'Priority',
                  property: 'priority',
                  type: 'select',
                  position: 'thirdValue',
                  options: [
                    { "value": "High", "viewValue": "High" },
                    { "value": "Medium", "viewValue": "Medium" },
                    { "value": "Low", "viewValue": "Low" },
                  ]
                },

                {
                  name: 'Status',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'fourthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Notes',
                  property: 'notes',
                  type: 'text',
                  position: 'fifthValue',
                  options: []
                },
                {
                  name: 'Total Durations',
                  property: 'totalCallDuration',
                  type: 'text',
                  position: 'sixthValue',
                  options: []
                },

                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'seventhValue',
                  options: [],
                  display: true
                },
                // {
                //   name: 'Email',
                //   property: 'email',
                //   type: 'text',
                //   position: 'eigthValue',
                //   options: [],
                //   display: false
                // },

                {
                  name: 'Source Name',
                  property: 'sourceName',
                  type: 'select',
                  position: 'ninethValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Activity Count',
                  property: 'activityCountOnLead',
                  type: 'text',
                  position: 'tenthValue',
                  options: []
                },

                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'eleventhValue',
                  options: []
                },
                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'tenthValue',
                  options: []
                },



              ]
            }
            else if (this.crmType == 8) {


              this.getGridById(this.customGridType);
              this.columnsProperties = this.columns.map(col => col.property);
              this.columnsReady = true;


            }
            else if (this.crmType == 9) {

              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, isSticky: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Account', property: 'company', visible: true, isModelProperty: true },
                { name: 'Job Title', property: 'jobtitle', visible: true, isModelProperty: false },
                { name: 'Email', property: 'email', visible: true, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Tags', property: 'tagName', visible: true, isModelProperty: true },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.columnsVisble = [...this.columns];

              this.columnsVisble = this.columns.filter(col => col.name !== 'Action' && col.name !== 'select');


              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'secondValue',
                  options: []
                },
                {
                  name: 'Account',
                  property: 'company',
                  type: 'text',
                  position: 'thirdValue',
                  options: []
                },
                {
                  name: 'Job Title',
                  property: 'jobtitle',
                  type: 'text',
                  position: 'fourthValue',
                  options: []
                },
                {
                  name: 'Email',
                  property: 'email',
                  type: 'text',
                  position: 'fifthValue',
                  options: []
                },
                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'sixthValue',
                  options: []
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'seventhValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Tags',
                  property: 'tagName',
                  type: 'multiSelect',
                  position: 'eighthValue',
                  options: []
                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'ninthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Source Name',
                  property: 'sourceName',
                  type: 'select',
                  position: 'tenThvalye',
                  options: [],
                  display: true
                },
                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'TwelfthValue',
                  options: []
                },

                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'thirteenValue',
                  options: []
                },
              ]
              this.columnsReady = true;
            }
            else {
              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false },
                { name: 'Favourite', property: 'favourite', visible: true, isModelProperty: false },
                { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Email', property: 'email', visible: false, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
                { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
                { name: 'Icons', property: 'icons', visible: true, isModelProperty: false },
                { name: 'Priority', property: 'priority', visible: true, isModelProperty: false },
                { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
                { name: 'Sub lead Status', property: 'secondaryLeadStatus', visible: true, isModelProperty: true },
                { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
                { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
                { name: 'Activity Count', property: 'activityCountOnLead', visible: true, isModelProperty: false },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Country', property: 'Country', visible: false, isModelProperty: false },
                { name: 'City', property: 'City', visible: false, isModelProperty: false },
                { name: 'State', property: 'State', visible: false, isModelProperty: false },
                { name: 'Campaign Name', property: 'adGroupName', visible: true, isModelProperty: false },
                { name: 'Call Durations', property: 'totalCallDuration', visible: true, isModelProperty: false },
                { name: 'Score', property: 'score', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];
              this.filterSelectObj = [

                {
                  name: 'Select',
                  property: 'disable',
                  type: 'disable',
                  position: 'firstValue',
                  options: [],

                },
                {
                  name: 'Favourite',
                  property: 'favourite$n',
                  type: 'select',
                  position: 'secondValue',
                  options: [
                    { value: 1, viewValue: 'Yes' },
                    { value: 0, viewValue: 'No' },
                  ]
                },
                {
                  name: 'Name',
                  property: 'name',
                  type: 'text',
                  position: 'thirdValue',
                  options: []
                },
                {
                  name: 'Email',
                  property: 'email',
                  type: 'text',
                  position: 'fourthValue',
                  options: []
                },
                {
                  name: 'Phone No',
                  property: 'phoneNumber',
                  type: 'text',
                  position: 'fifthValue',
                  options: []
                },
                {
                  modelValue: '',
                  name: 'Priority',
                  property: 'priority',
                  type: 'select',
                  position: 'sixthValue',
                  options: [
                    { "value": "High", "viewValue": "High" },
                    { "value": "Medium", "viewValue": "Medium" },
                    { "value": "Low", "viewValue": "Low" },
                  ]
                },
                {
                  name: 'Status Name',
                  property: 'statusName',
                  type: 'multiSelect',
                  position: 'seventhValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Sub lead Status',
                  property: 'secondaryLeadStatus',
                  type: 'text',
                  position: 'eighthValue',
                  options: []
                },
                {
                  name: 'Source Name',
                  property: 'sourceName',
                  type: 'select',
                  position: 'ninthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Owner',
                  property: 'ownerEmail',
                  type: 'multiSelect',
                  position: 'tenthValue',
                  options: [],
                  display: true
                },
                {
                  name: 'Activity Count',
                  property: 'activityCountOnLead',
                  type: 'text',
                  position: 'eleventhValue',
                  options: []
                },
                {
                  name: 'created Date',
                  property: 'createdDate',
                  type: 'date',
                  position: 'TwelfthValue',
                  options: []
                },

                {
                  name: 'updated Date',
                  property: 'updatedDate',
                  type: 'date',
                  position: 'thirteenValue',
                  options: []
                },
                {
                  name: 'Country',
                  property: 'Country_cust',
                  type: 'select',
                  position: 'fourteenValue',
                  options: []
                },
                {
                  name: 'City',
                  property: 'City_cust',
                  type: 'text',
                  position: 'fivteenthValue',
                  options: []
                },
                {
                  name: 'State',
                  property: 'State_cust',
                  type: 'text',
                  position: 'sixteenthValue',
                  options: []
                },
                {
                  name: 'Campaign Name',
                  property: 'adGroupName_configurableProduct',
                  type: 'text',
                  position: 'seventeenValue',
                  options: []
                },
                // {
                //   name: 'Cr No',
                //   property: 'CrNo_cust',
                //   type: 'text',
                //   position: 'EighteenValue',
                //   options: []
                // },
                // {
                //   name: 'Cr Name',
                //   property: 'CrName_cust',
                //   type: 'text',
                //   position: 'NineteenValue',
                //   options: []
                // },
                {
                  name: 'Call Durations',
                  property: 'totalCallDuration',
                  type: 'text',
                  position: 'TwentyValue',
                  options: []
                },
                {
                  name: 'Score',
                  property: 'score',
                  type: 'text',
                  position: 'TwentyOneValue',
                  options: []
                },
              ]

            }
            if (this.redirected == true) {
              this.urlPage = this.route.snapshot.queryParamMap.get("page")
              this.urlSize = this.route.snapshot.queryParamMap.get("size")
              this.urlSort = this.route.snapshot.queryParamMap.get("sort")
              if (this.urlPage != null) {
                this.redirected = true;

                this.page = this.urlPage;
                this.size = this.urlSize;
                this.sortParam = this.urlSort;
              }
              this.firstFormGroup.value.page = this.page;
              this.firstFormGroup.value.size = this.size;
            }
            if (this.sortParam.split(",")[0] == 'entityId') {
              this.firstFormGroup.value.sort = 'name';
            } else {
              this.firstFormGroup.value.sort = this.sortParam.split(",")[0]
            }

          }
          this.read = this.resourcePrivilege?.read;
        } else {
          this.whatsAppCustomUrl = 0;
          this.leadFilterType = 0;
          this.crmType = 1;
          if (window.innerWidth < 822) {
            this.display = false;
          } else {
            this.display = true
          }


          this.productList = [];
        }

        let val = parseInt(localStorage.getItem(Constant.SU))

        let userType: any = localStorage.getItem(Constant.Sup);

        if (isNaN(val)) {
          val = 0;
        }

        if (val > 0 || userType === 'Sales User') {

          this.displayOwner = true;

        } else {

          this.displayOwner = false;
        }

        if (this.displayOwner) {

          let index = this.columns.findIndex(x => x.property == 'ownerEmail');

          if (index > 0) {
            this.columns.splice(index, 1);
          }

        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
        this.read = this.resourcePrivilege?.read;
        this.getProduct();
      }


    } else {
      this.whatsAppCustomUrl = 0;
      this.leadFilterType = 0;
      this.crmType = 1;
      if (window.innerWidth < 822) {
        this.display = false;
      } else {
        this.display = true
      }
      this.columns = [
        { name: 'select', property: 'select', visible: true, isModelProperty: false },
        { name: 'Name', property: 'name', visible: true, isModelProperty: false, cssClasses: ['text-secondary', 'font-medium'] },
        { name: 'Email', property: 'email', visible: false, isModelProperty: true, cssClasses: ['text-secondary', 'font-medium'] },
        { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: false },
        { name: 'Status', property: 'statusName', visible: true, isModelProperty: false },
        { name: 'Source', property: 'sourceName', visible: true, isModelProperty: false },
        { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
        { name: 'Activity Count', property: 'activityCountOnLead', visible: true, isModelProperty: false },
        { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
        { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
        { name: 'Country', property: 'Country', visible: false, isModelProperty: false },
        { name: 'City', property: 'City', visible: true, isModelProperty: false },
        { name: 'State', property: 'State', visible: false, isModelProperty: false },
        { name: 'Campaign Name', property: 'adGroupName', visible: false, isModelProperty: false },
        { name: 'Budget', property: 'budget', visible: true, isModelProperty: true },
        { name: 'Budget Min', property: 'budgetMin', visible: true, isModelProperty: true },
        { name: 'Sub Loction', property: 'subLocation', visible: true, isModelProperty: true },
        { name: 'Last Activity Notes', property: 'lastActivityNotes', visible: false, isModelProperty: false },
        { name: 'Cr No', property: 'CrNo_cust', visible: false, isModelProperty: false },
        { name: 'Cr Name', property: 'CrName_cust', visible: false, isModelProperty: false },
        { name: 'Call Durations', property: 'totalCallDuration', visible: true, isModelProperty: false },
        { name: 'Score', property: 'score', visible: true, isModelProperty: false },
        { name: 'Notes', property: 'notes', visible: false, isModelProperty: true },
        { name: 'Action', property: 'actions', visible: true, disabled: true },
      ] as ListColumn[];

      this.filterSelectObj = [

        {
          name: 'Select',
          property: 'disable',
          type: 'disable',
          position: 'firstValue',
          options: [],

        },
        {
          modelValue: '',
          name: 'Name',
          property: 'name',
          type: 'text',
          position: 'secondValue',
          options: []
        },
        {
          name: 'Email',
          property: 'email',
          type: 'text',
          position: 'thirdValue',
          options: []
        },
        {
          name: 'Phone No',
          property: 'phoneNumber',
          type: 'text',
          position: 'fourthValue',
          options: []
        },
        {
          name: 'Status Name',
          property: 'statusName',
          type: 'multiSelect',
          position: 'fifthValue',
          options: [],
          display: true
        },
        {
          name: 'Source Name',
          property: 'sourceName',
          type: 'select',
          position: 'sixthValue',
          options: [],
          display: true
        },
        {
          name: 'Owner',
          property: 'ownerEmail',
          type: 'multiSelect',
          position: 'seventhValue',
          options: [],
          display: true
        },
        {
          name: 'Activity Count',
          property: 'activityCountOnLead',
          type: 'text',
          position: 'eighthValue',
          options: []
        },
        {
          name: 'created Date',
          property: 'createdDate',
          type: 'date',
          position: 'ninthValue',
          options: []
        },

        {
          name: 'updated Date',
          property: 'updatedDate',
          type: 'date',
          position: 'tenthValue',
          options: []
        },
        {
          name: 'Country',
          property: 'Country_cust',
          type: 'select',
          position: 'eleventhValue',
          options: []
        },
        {
          name: 'City',
          property: 'City_cust',
          type: 'text',
          position: 'TwelfthValue',
          options: []
        },
        {
          name: 'State',
          property: 'State_cust',
          type: 'text',
          position: 'thirteenValue',
          options: []
        },
        {
          name: 'Campaign Name',
          property: 'adGroupName_configurableProduct',
          type: 'text',
          position: 'fourteenValue',
          options: []
        },
        {
          name: 'Budget',
          property: 'budget',
          type: 'text',
          position: 'fivteenthValue',
          options: []
        },
        {
          name: 'Budget Min',
          property: 'budgetMin',
          type: 'text',
          position: 'sixteenthValue',
          options: []
        },
        {
          name: 'Sub Loction',
          property: 'subLocation',
          type: 'text',
          position: 'seventeenthValue',
          options: []
        },

        {
          name: 'Last Activity notes',
          property: 'lastActivityNotes',
          type: 'text',
          position: 'eighteenthValue',
          options: []
        },

        {
          name: 'Cr No',
          property: 'CrNo_cust',
          type: 'text',
          position: 'nighteenthValue',
          options: []
        },

        {
          name: 'Cr Name',
          property: 'CrName_cust',
          type: 'text',
          position: 'TwentyValue',
          options: []
        },

        {
          name: 'Call Durations',
          property: 'totalCallDuration',
          type: 'text',
          position: 'TwentyOneValue',
          options: []
        },
        {
          name: 'Score',
          property: 'score',
          type: 'text',
          position: 'TwentyTwoValue',
          options: []
        },



      ]

      this.productList = [];
      this.read = this.resourcePrivilege?.read;
      this.getProduct();
    }




  }
  toggleFilterByColumnsPanel() {

  }

  updateAllEntityIds(content?: any[]) {
    if (content && Array.isArray(content) && content.length > 0) {
      this.allEntityIds = content.map((item: any) => item.entityId || item.id).filter(id => id != null);
    } else if (Array.isArray(this.productList) && this.productList.length > 0) {
      this.allEntityIds = this.productList.map((item: any) => item.entityId || item.id).filter(id => id != null);
    } else if (this.productList && Array.isArray(this.productList.data) && this.productList.data.length > 0) {
      this.allEntityIds = this.productList.data.map((item: any) => item.entityId || item.id).filter(id => id != null);
    } else if (this.dataSource && Array.isArray(this.dataSource.data) && this.dataSource.data.length > 0) {
      this.allEntityIds = this.dataSource.data.map((item: any) => item.entityId || item.id).filter(id => id != null);
    }
  }

  openLeadPanel(element: any) {
    this.updateAllEntityIds();
    let allIds = this.allEntityIds;
    if (!allIds || !Array.isArray(allIds) || allIds.length === 0) {
      if (Array.isArray(this.productList) && this.productList.length > 0) {
        allIds = this.productList.map((item: any) => item.entityId || item.id).filter(id => id != null);
      } else if (this.productList && Array.isArray(this.productList.data) && this.productList.data.length > 0) {
        allIds = this.productList.data.map((item: any) => item.entityId || item.id).filter(id => id != null);
      } else if (this.dataSource && Array.isArray(this.dataSource.data) && this.dataSource.data.length > 0) {
        allIds = this.dataSource.data.map((item: any) => item.entityId || item.id).filter(id => id != null);
      } else if (element?.entityId || element?.id) {
        allIds = [element.entityId || element.id];
      }
      this.allEntityIds = allIds || [];
    }

    if (window.innerWidth > 768) {
      if (this.leadDetailPageType == 5) {
        const dialogRef = this.dialog.open(LeadDetailPanelComponent, {
          width: '80%',
          maxWidth: '1200px',
          height: '100%',
          data: {
            currentId: element.entityId,
            allIds: this.allEntityIds,
            data: element
          },
          position: { right: '0' },
          panelClass: 'slide-dialog-panel',
          hasBackdrop: true,
          disableClose: false,
          autoFocus: false
        });
      }
    } else {
      let option = Constant.MOBILE_Device;

      if (option == "1") {
        this.leadDetailType == 0;
      }

      if (this.leadDetailType == 0) {
        this.router.navigate([`leadDetail/${element.entityId}`])
      } else {

        const url = this.router.serializeUrl(
          this.router.createUrlTree([`leadDetail/${element.entityId}`])
        );
        const relativeUrl = url.replace(window.location.origin, '');
        window.open(relativeUrl, '_blank');

      }
    }
  }
  gridList: any;

  getGridById(id) {
    this.gridService.getGridById(id).subscribe(
      res => {
        this.gridList = res;
        this.gridColumnList = this.gridList ? this.gridList.gridColumnList || [] : [];

        const hasProductCol = (this.gridColumnList || []).some((col: any) => {
          if (!col) return false;
          const prop = String(col.property || '').toLowerCase();
          const name = String(col.name || '').toLowerCase();
          const propName = String(col.propertyName || '').toLowerCase();
          const attrCode = String(col.attributeCode || '').toLowerCase();
          return prop.includes('product') || name.includes('product') || propName.includes('product') || attrCode.includes('product');
        });

        if (hasProductCol) {
          this.loadMasterProducts();
        }

        const hasCategoryCol = this.gridColumnList?.some((col: any) => {
          if (!col) return false;
          const prop = String(col.property || '').toLowerCase();
          const name = String(col.name || '').toLowerCase();
          const propName = String(col.propertyName || '').toLowerCase();
          const attrCode = String(col.attributeCode || '').toLowerCase();
          return prop.includes('category') || name.includes('category') || propName.includes('category') || attrCode.includes('category');
        });

        if (hasCategoryCol) {
          this.loadMasterCategories();
        }

        if (!this.gridList || this.gridList.filterValues == "" || this.gridList.filterValues == null) {
          this.filterSelectObj = [];
        } else {
          try {
            let list = JSON.parse(this.gridList.filterValues);
            if (Array.isArray(list) && (this.router.url.includes('lead') || this.router.url.includes('contact'))) {
              list.forEach((f: any) => {
                if (f && f.property) {
                  if (f.property.toLowerCase() === 'product' || f.name?.toLowerCase() === 'product') {
                    f.property = 'Product_cust';
                  } else if (f.property.toLowerCase() === 'category' || f.name?.toLowerCase() === 'category') {
                    f.property = 'Category_cust';
                  } else if (this.mapperMap.get(f.property)) {
                    f.property = this.mapperMap.get(f.property);
                  }
                }
              });
            }
            this.filterSelectObj = list;
          } catch (e) {
            this.filterSelectObj = [];
          }
        }

        if (this.gridColumnList && this.gridColumnList.length) {
          let val: any = localStorage.getItem(Constant.SU);
          let validCols = this.gridColumnList.filter(col => col && col.property != null && col.property !== '' && col.property !== 'null' && col.property !== 'undefined');
          const uniqueProps = new Set();
          validCols = validCols.filter(col => {
            if (col && col.property && !uniqueProps.has(col.property)) {
              uniqueProps.add(col.property);
              return true;
            }
            return false;
          });
          if (val > 0) {
            this.columns = validCols.filter(col => col.property !== 'ownerEmail');
          } else {
            this.columns = validCols;
          }

          this.columns = this.columns.map(col => {
            if (col.optionValues) {
              try {
                col.optionValues = JSON.parse(col.optionValues as string);
              } catch (e) {
                col.optionValues = [];
              }
            }
            return col;
          });

          this.columnsProperties = this.columns.map(col => col.property);
        } else {
          console.error('No columns data found');
        }
      },
      error => {
        console.error('Error fetching grid data', error);
      }
    );
  }


  companyNavigation(entityId) {
    this.router.navigate([`companiesDetail/${entityId}`])
  }



  getColumnName(col: string): string {
    const column = this.gridColumnList ? this.gridColumnList.find(c => c && c.property === col) : null;
    return column ? column.name : col;
  }

  getResource() {

    let access = ResourceAccess.LEAD

    if (this.router.url.includes('contact')) {

      access = ResourceAccess.CONTACT
    }
    this.commonService
      .getAllAccessForResource(access)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          if (data.restriction.length > 0) {
            this.bulkUpload = data.restriction[0].bulkUpload == 1 ? true : false;
            this.productLimitedRestrictionValue = data.restriction[0].productLimitedRestriction;
            this.productLimitedRestriction = true;
          } else {
            this.productLimitedRestriction = false;
          }
          this.resourcePrivilege = data;
          this.getAllCrmData();

          let filterObject = [];
          let url = this.router.url;
          let cleanUrl = url.split('?')[0];
          filterObject = JSON.parse(localStorage.getItem(cleanUrl))
          let searchTerm = localStorage.getItem(cleanUrl + "se")
          let type = localStorage.getItem(cleanUrl + "type")
          let filterSelectedValue = localStorage.getItem(cleanUrl + "filter")

          if (filterObject == null) {
            filterObject = [];
          }

          if (filterSelectedValue != null) {
            try {
              let parsedFilter = JSON.parse(localStorage.getItem(cleanUrl + "filter"));
              if (Array.isArray(parsedFilter)) {
                let validFilterCols = parsedFilter.filter(col => col && col.property != null && col.property !== '' && col.property !== 'null' && col.property !== 'undefined');
                const uniqueProps = new Set();
                this.columns = validFilterCols.filter(col => {
                  if (col && col.property && !uniqueProps.has(col.property)) {
                    uniqueProps.add(col.property);
                    return true;
                  }
                  return false;
                });
              }
            } catch (e) {
              console.error("Error parsing filter columns", e);
            }
          }
          const savedStat = localStorage.getItem('selectedLeadStat');
          if (savedStat) {
            this.selectedLeadStat = savedStat;
          } else {
            // Robust fallback if savedStat is missing but filters are active
            if (type == "2") {
              if (this.search && this.search.includes('statusName')) {
                this.selectedLeadStat = 'untouched';
              } else if (this.search && this.search.includes('transferDate')) {
                this.selectedLeadStat = 'assigned';
              } else {
                this.selectedLeadStat = 'today';
              }
            } else {
              this.selectedLeadStat = 'total';
            }
          }

          if (this.GridType == 6) {
            this.todayLeads();
            this.getUnassignedlead()
            this.getTodayLead();
            this.getUntouchedLed();
            this.getLeadTodayUntouch();
            this.getLeadAssignToday();
          }

          if (type == "2" && searchTerm != null) {

            this.filterActive = true;
            this.search = searchTerm;
            // this.search = this.search.replace(/'/g, '');

            // Directly call filterOption for CRM search, bypassing supplier filter logic
            this.filterOption(this.search);
          } else if (type == "1" && searchTerm != null) {

            this.filterActive = true;
            this.search = searchTerm;
            // this.search = this.search.replace(/'/g, '');

            this.onFilterChange(this.search, 2);
          } else {
            if (this.advanceFilterEnble == true) {
              this.getLeadAdvanceFilter();
            } else if (this.smartViewConditionsEnble == true) {
              this.getDynamicLeadReport(searchTerm)
            } else {
              this.getProduct();

              if (this.GridType == 6) {
                this.getUnassignedlead()
                this.getTodayLead();
                this.getUntouchedLed();
                this.getLeadTodayUntouch();
                this.getLeadAssignToday();
              }
            }
          }

        }
      });
  }

  totalElements: number = 0;

  getProduct() {

    this.ensureSmartViewFromFilter();

    this.todayLeads();

    if (this.sortParam == undefined) {
      this.sortParam = 'updatedDate' + "," + Constant.Dsc;
    }

    if (this.advanceFilterEnble == true) {
      let conditonValue = JSON.parse(localStorage.getItem("advanceFilterConditionsText"));
      if (conditonValue != undefined) {
        let conditon = conditonValue['condition'];
        this.advance.conditions = conditon;
      }
      this.getLeadAdvanceFilter();
      return;
    } else if (this.smartViewConditionsEnble == true) {
      this.getDynamicLeadReport(this.filterActive ? this.search : null);
      return;
    } else {
      this.productList = [];

      if (this.connectedCall) {


        this.getAllConnectedOnes();

      }

      else if (this.contactPage) {

        this.search = undefined;

        this.filterOption(this.search)

      } else if (this.activeTab === 'new') {

        this.filterQuery = 'statusName:*New,*';

        this.getLeadsFilter();

      } else {

        if (this.sortParam == undefined) {
          this.sortParam = 'updatedDate' + "," + Constant.Dsc;
        }

        this.firstFormGroup.patchValue(this.firstFormGroup.value)
        this.filterActive = false;
        this.spinner = true;
        this.productService.getLead(this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit).subscribe(
          res => {
            this.spinner = false;
            this.dataSource.data = res['content'].map((element: any) => {
              const pVal = element.propertyName || element.PropertyName || element.Property || element.property || element.PrimaryPlan || element.primaryPlan ||
                (element.isCustomizedValue ? (element.isCustomizedValue['propertyName'] || element.isCustomizedValue['PropertyName'] || element.isCustomizedValue['Property'] || element.isCustomizedValue['property']) : '') || '';
              const pId = element.propertyId || element.PropertyId || element.PrimaryPlan || element.primaryPlan ||
                (element.isCustomizedValue ? (element.isCustomizedValue['propertyId'] || element.isCustomizedValue['PropertyId']) : '') || '';
              const descVal = element.description || element.Description ||
                (element.isCustomizedValue ? (element.isCustomizedValue['description'] || element.isCustomizedValue['Description']) : '') ||
                (element.values ? (element.values['description'] || element.values['Description']) : '') ||
                (element.downloadList ? (element.downloadList['description'] || element.downloadList['Description']) : '') || '';
              return {
                ...element,
                jobtitle: element.jobTitle || element.jobtitle || '',
                description: descVal,
                Description: descVal,
                propertyName: pVal,
                PropertyName: pVal,
                Property: pVal,
                property: pVal,
                propertyId: pId,
                PropertyId: pId,
                darkTextColor: this.getDarkerTextColor(element.leadStatusColour, 40),
                darkTextColorTag: this.getDarkerTextColor(element.tagNameColour, 40),
              };
            });
            this.totalElements = res['totalElements'];
            this.totalLeadCount = res['totalElements'];
            this.productList = new MatTableDataSource();
            this.elements = res['numberOfElements'];

            this.productList = res['content'].map((element: any) => {
              const pVal = element.propertyName || element.PropertyName || element.Property || element.property || element.PrimaryPlan || element.primaryPlan ||
                (element.isCustomizedValue ? (element.isCustomizedValue['propertyName'] || element.isCustomizedValue['PropertyName'] || element.isCustomizedValue['Property'] || element.isCustomizedValue['property']) : '') || '';
              const pId = element.propertyId || element.PropertyId || element.PrimaryPlan || element.primaryPlan ||
                (element.isCustomizedValue ? (element.isCustomizedValue['propertyId'] || element.isCustomizedValue['PropertyId']) : '') || '';
              const descVal = element.description || element.Description ||
                (element.isCustomizedValue ? (element.isCustomizedValue['description'] || element.isCustomizedValue['Description']) : '') ||
                (element.values ? (element.values['description'] || element.values['Description']) : '') ||
                (element.downloadList ? (element.downloadList['description'] || element.downloadList['Description']) : '') || '';
              return {
                ...element,
                jobtitle: element.jobTitle || element.jobtitle || '',
                description: descVal,
                Description: descVal,
                propertyName: pVal,
                PropertyName: pVal,
                Property: pVal,
                property: pVal,
                propertyId: pId,
                PropertyId: pId,
                darkTextColor: this.getDarkerTextColor(element.leadStatusColour, 40),
                darkTextColorTag: this.getDarkerTextColor(element.tagNameColour, 40),
              };
            });

            this.allEntityIds = this.productList.map((item: any) => item.entityId);

            this.productList.sort = this.sort;
            this.pageList = res['totalElements'];
            this.productList.paginator = this.paginator;
            this.pageSizeValue = LeadgetPageSize(this.pageList);
            this.syncSelectionOnDataLoad();
            this.cdr.detectChanges();
            this.notifyKanbanUpdate();

          },
          () => {
            this.spinner = false;
          }
        )
      }




    }


  }
  saveColumnPreferences(): void {
    localStorage.setItem('leadsDisplayedColumns', JSON.stringify(this.displayedColumns));
  }

  getAvailableColumns(): { key: string; name: string; }[] {
    return this.allColumns.filter(col => !this.displayedColumns.includes(col.key));
  }

  addColumn(columnKey: string): void {
    if (!this.displayedColumns.includes(columnKey)) {
      const actionIndex = this.displayedColumns.indexOf('actions');
      this.displayedColumns.splice(actionIndex, 0, columnKey);
      this.saveColumnPreferences(); // MODIFIED: Save after adding
    }
  }
  pageSizeOptions: number[] = [10, 25, 50, 100];
  removeColumnTwo(columnKey: string): void {
    this.displayedColumns = this.displayedColumns.filter(key => key !== columnKey);
    this.saveColumnPreferences(); // MODIFIED: Save after removing
  }

  handlePageEvent(event: PageEvent): void {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getProduct();
  }
  announceSortChange(sortState: Sort): void {
    const customCol = this.allColumns.find(c => c.key === sortState.active);

    if (sortState.direction) {
      // Handle customValue key
      if (customCol && customCol.key.includes('customValue')) {
        this.sortParam = `${customCol.name}_cust,${sortState.direction}`;
      } else {
        this.sortParam = `${sortState.active},${sortState.direction}`;
      }
    } else {
      this.sortParam = 'createdDate,desc';
    }

    this.page = 0;
    this.getProduct();
  }

  getInitialsTwo(name: string | null): string {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }
  searchTermMain: string = '';
  searchTermMainPresent: boolean = false;
  searchTermMainEmit: number = 0;
  searchFilterMain(index) {
    if (!this.searchTermMainPresent) {
      if (this.searchTermMain.trim().length == 0) {
        this.searchTermMainPresent = true;
        this.searchTermMainEmit = 0;
      } else {
        this.searchTermMainPresent = false;
        this.searchTermMainEmit++;

        let url = this.router.url;

        if (this.router.url.includes('lead')) {
          let cleanUrl = url.split('?')[0];
          localStorage.removeItem(cleanUrl);
          localStorage.removeItem(cleanUrl + "type");
          localStorage.setItem(cleanUrl + "se", this.searchTermMain);
          localStorage.setItem(cleanUrl + "type", "1");
        }
      }

      this.onFilterChange(this.searchTermMain, index);
    } else {
      this.searchTermMainEmit = 0;
      this.searchTermMainPresent = true;
    }
  }
  clearSearch() {
    this.searchTermMain = '';
    this.searchTermMainPresent = false;
    this.searchTermMainEmit = 0;
    this.onFilterChange('', 1);
  }

  // openLeadStage(data){
  //   console.log("the mat row is"+data);

  // }
  isPopupOpen = false;


  popupType = 0;


  openLeadStage(row, i) {

    this.leadObject = row;
    // Activate the current row
    this.clickedIndexes[i] = true;
    this.isPopupOpen = true;
    this.currentLeadID = row.entityId;
    this.popupType = 1;
  }

  clickedIndexes: { [key: number]: boolean } = {};

  openFlagStage(row: any, i: number): void {
    const isSameRow = this.currentLeadID === row.entityId;
    this.leadObject = row;
    if (this.clickedIndexes[i]) {
      delete this.clickedIndexes[i];
      this.isPopupOpen = false;


      if (!isSameRow) {


        this.currentLeadID = row.entityId;
        this.isPopupOpen = true;
        this.popupType = 1;
        this.cdr.detectChanges();

      }
      return;
    }

    this.clickedIndexes[i] = true;

    this.isPopupOpen = false;

    this.currentLeadID = row.entityId;
    this.isPopupOpen = true;
    this.popupType = 1;
    this.cdr.detectChanges();

  }



  openLeadPriority(row) {
    this.isPopupOpen = true;
    this.leadObject = row;
    this.currentLeadID = row.entityId;
    this.popupType = 2;
  }

  openRemarks(row) {
    this.isPopupOpen = true;
    this.leadObject = row;
    this.currentLeadID = row.entityId;
    this.popupType = 4;
  }

  openLead(row) {
    this.isPopupOpen = true;
    this.leadObject = row;
    this.currentLeadID = row.entityId;
    this.popupType = 3;
  }


  openFollowUp(row) {
    this.isPopupOpen = true;
    this.leadObject = row;
    this.currentLeadID = row.entityId;
    this.popupType = 5;
  }


  Note(row) {
    this.isPopupOpen = true;
    this.leadObject = row;
    this.currentLeadID = row.entityId;
    this.popupType = 6;
  }

  closePopup(event) {
    if (event == true) {
      this.isPopupOpen = false;
      this.DetectingRequestType();
    }


  }
  closePopupTwo(event) {
    if (event == true) {
      this.isPopupOpenTwo = false;
      this.toggleFilterColumnPanel();
    }




  }
  isPopupOpenTwo = false;

  OpenTwopopup() {
    this.isPopupOpenTwo = true;
    this.isPopupOpen1 = false;
  }
  taskType = 2;
  addLeadActivity(activityType: string, activityId, leadObject: any, leadId: any) {
    if (window.innerWidth > 768) {
      let dialogConfig: any = {
        disableClose: true,
        data: {
          activityType: activityType,
          type: "lead",
          leadId: leadId,
          activityId: activityId,
          leadObject: leadObject,
          templateDisplayed: this.templateDisplayed,
          taskSaveType: 1

        }
      };

      if (this.taskType === 2) {
        dialogConfig.width = "400px";   // set width (can be 100% if you want full width)
        dialogConfig.height = "100%";   // full height
        dialogConfig.position = { right: "0", top: "0" };
        dialogConfig.panelClass = "right-slide-dialog"; // add custom animation
      } else {
        // Normal centered dialog
        dialogConfig.width = "790px";
      }

      let dialogRef = this.dialog.open(ConversationPopupComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result?.event === "add") {
          this.getProduct();
        }
      });
    }

    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          activityType: activityType,
          type: "lead",
          leadId: leadId,
          activityId: activityId,
          leadObject: leadObject,
          templateDisplayed: this.templateDisplayed,
          taskSaveType: 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          // this.getAllLeadActivity(this.leadId);
          this.getProduct();

        }


      });
    }

  }
  addLeadActivityone(activityType: string, activityId, leadObject: any, leadId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          //this.getAllLeadActivity(this.leadId);
          this.getProduct();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          // this.getAllLeadActivity(this.leadId);
          this.getProduct();

        }


      });
    }

  }

  getUpdate(event) {

    this.selection.clear();

    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;

    this.urlSize = this.size;
    this.urlPage = this.page;

    this.redirected = false;

    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');



    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;

    localtion = localtion.split('&page')[0]


    if (this.sortParam == undefined) {

      if (this.sortEnabled) {
        this.sortParam = 'updatedDate' + "," + Constant.Dsc;
      } else {
        this.sortParam = 'updatedDate' + "," + Constant.Dsc;
      }

    }

    this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.DetectingRequestType();
  }

  sortData(event) {




    if (event.active.includes('customValuesIs')) {


      let originalString = event.active;
      let updatedString = originalString.replace('customValuesIs', '');

      updatedString = updatedString.replace(/\s/g, "_").replace(/\(/g, '_').replace(/\)/g, '_');
      updatedString = updatedString + "_cust"
      event.active = updatedString;

    }


    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {

      if (this.size != Constant.SIZE) {

        this.size = this.size;

      } else {
        this.size = Constant.SIZE;
      }
      this.page = Constant.PAGE;

      this.sortParam = event.active;



      if (event.direction.length > 0) {

        if (this.mapperMap.get(event.active) != null) {

          if (event.direction == 'asc') {

            this.sortParam = event.active;
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = event.active;
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        else {
          if (event.direction == 'asc') {
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');

        if (questionMarkIndex !== -1) {
          // Extract the substring before the ?
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

          // Replace the original string with the substring before the ?
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;

        localtion = localtion.split('&page')[0]


        this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
        this.DetectingRequestType();
      }


    }

  }

  DetectingRequestType() {

    this.ensureSmartViewFromFilter();

    if (!this.filterActive) {

      if (this.advanceFilterEnble == true) {
        this.getLeadAdvanceFilter()
      }
      else if (this.smartViewConditionsEnble) {
        this.getDynamicLeadReport(null);
      }
      else {

        if (this.activeTab === 'new') {
          this.filterQuery = 'statusName:*New,*';

          this.getLeadsFilter();
        } else {
          this.getProduct();
        }

      }


    }
    else {


      if (this.advanceFilterEnble == true) {
        this.getAllLeadAdvanceFilter(this.search)
      }
      else if (this.smartViewConditionsEnble) {
        this.getDynamicLeadReport(this.search);
      } else {
        this.filterOption(this.search);
      }



    }
  }

  normalizeLeadSearchQuery(query: any): any {
    if (!query || typeof query !== 'string') return query;
    let q = query;
    q = q.replace(/(^|[\s(])product:([^\s)]+)/g, '$1Product_cust:$2');
    q = q.replace(/(^|[\s(])Product:([^\s)]+)/g, '$1Product_cust:$2');
    q = q.replace(/(^|[\s(])category:([^\s)]+)/g, '$1Category_cust:$2');
    q = q.replace(/(^|[\s(])Category:([^\s)]+)/g, '$1Category_cust:$2');
    return q;
  }

  filterOption(event) {

    let urlPage = this.route.snapshot.queryParamMap.get("page")
    if (urlPage != null && this.redirected == true) {
      this.redirected = true;

      this.page = this.urlPage;
      this.size = this.urlSize;
      this.sortParam = this.sort;
    }
    this.firstFormGroup.value.page = this.page;
    this.firstFormGroup.value.size = this.size;

    if (event == undefined) {
      this.filterActive = false;
    } else {
      this.filterActive = true;
    }

    let url = this.router.url;
    if (url.includes('lead') || url.includes('contact')) {
      event = this.normalizeLeadSearchQuery(event);
    }

    this.search = event;

    if (url.includes('lead') || url.includes('contact')) {
      let cleanUrl = url.split('?')[0];
      if (this.search) {
        localStorage.setItem(cleanUrl + "se", this.search);
      } else {
        localStorage.removeItem(cleanUrl + "se");
      }
    }
    this.spinner = true;
    this.productList = []

    let search = this.search;

    if (url.includes('lead') || url.includes('contact')) {
      search = this.normalizeLeadSearchQuery(search);
    }

    if (this.contactPage) {
      if (search == null || search == undefined || search == '' || search === 'undefined') {
        search = this.searchContact;
      } else if (typeof search === 'string' && !search.includes("isClosedWon")) {
        search = search + " AND " + this.searchContact;
      }
    } else if (this.activeTab === 'new') {

      search = this.formatSearchForNewLeadTab(search);

    }

    if (this.sortParam == undefined) {
      this.sortParam = 'updatedDate' + "," + Constant.Dsc;
    }

    this.productService.getLeadBySearch(search, this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit).subscribe(
      res => {
        this.spinner = false;


        if (!this.selectUpload) {
          this.productList = res['content'];
          this.updateAllEntityIds(res['content']);
          this.elements = res['numberOfElements'];
          this.pageList = res['totalElements'];
          if (this.activeTab === 'new') {
            this.newContactCount = res['totalElements'];
          }
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();
          // notify kanban to refresh when filters/search updated
          this.notifyKanbanUpdate();
        } else {
          this.downloadDataFinal(res['content'])
        }

      },
      () => {
        this.spinner = false;
      })
    this.searchTermMainPresent = false

  }

  @Input() columns: ListColumn[] = []



  filterSelectObj = [];




  applyFilter(filterValue: string) {
    this.productList.filter = filterValue.trim().toLowerCase();
  }

  defaultSetType: any;
  allColumns: { key: string; name: string; }[] = [
    { key: 'name', name: 'Name' },
    { key: 'customValuesIsAccount', name: "Account" },
    { key: 'customValuesIsJob', name: "Job_Title" },
    { key: 'phoneNumber', name: 'Mobile' },
    { key: 'email', name: 'Email' },
    { key: 'statusName', name: 'Status' },
    { key: 'sourceName', name: 'Lead Source' },
    { key: 'ownerIdName', name: 'Sales Owner' },
    { key: 'createdDate', name: 'Created Date' },
    { key: 'updatedDate', name: 'Last Updated' },
    { key: 'lastActivityNotes', name: 'Last Activity' },
    { key: 'Tags', name: 'Tags' },
    { key: 'entityId', name: 'ID' }
  ];
  defaultColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  displayedColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  dataSource = new MatTableDataSource<any>([]);


  addproduct() {


    if (this.pageList >= this.productLimitedRestrictionValue) {
      this.restritionPopup();
      return;
    } else {
      if (this.defaultSet == null) {

        this.crmsettingsService.getCrmSettingsData()
          .subscribe(
            (setting: any) => {
              const encryptedCrmSettings = this.ecryptService.encryptionAES(JSON.stringify(setting));
              localStorage.setItem('crmSettingsData', encryptedCrmSettings);
              this.getAllCrmData();

              this.defaultSet = setting['defaultSet'];
              this.defaultSetType = setting['defaultSetType'];
              if (this.crmType == 6) {
                this.openLeadPopup(this.defaultSet, 0);
              }
              else {

                if (this.defaultSetType == 0) {
                  let productId = 0;
                  this.router.navigate([`lead/add-edit-lead/${productId}/${this.defaultSet}`])
                } else {
                  let productId = 0;

                  let setId = 0;

                  this.router.navigate([`lead/add-edit-lead/${productId}/${setId}`])
                }

              }
            },
            () => {

            }
          )
      } else {
        let setId = this.defaultSet
        if (this.crmType == 6) {
          this.openLeadPopup(setId, 0);
        }
        else {
          if (this.defaultSetType == 0) {
            let productId = 0;
            this.showLoaderTemporarily(2000);
            this.router.navigate([`lead/add-edit-lead/${productId}/${this.defaultSet}`])
          } else {
            let productId = 0;

            let setId = 0;

            this.router.navigate([`lead/add-edit-lead/${productId}/${setId}`])
          }
        }
      }
    }

  }



  onFilterChange(value, index) {


    this.ensureSmartViewFromFilter();

    if (this.GridType == 6) {
      this.refreshTypesixDatas();
    }
    if (value == '') {
      this.leadIdList = [];
      this.selectionLead = [];
      if (this.advanceFilterEnble == true) {
        this.getLeadAdvanceFilter();
      } else if (this.smartViewConditionsEnble == true) {

        this.getDynamicLeadReport(null)
      } else if (this.activeTab === 'new') {
        this.filterQuery = 'statusName:*New,*';
        this.getLeadsFilter();
      } else {
        this.getProduct();
      }

      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;



      let searchTerm;

      if (searchTerm == undefined && index == 2) {
        searchTerm = "name:" + '*' + value.trim() + '*'
          + "' OR phoneNumber:" + '*' + value.trim() + '*'
          + "' OR secondaryphoneno:" + '*' + value.trim() + '*'
          + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "
      } else {

        if (searchTerm != undefined && index == 2) {
          searchTerm = value;
        } else {
          searchTerm = "name:" + '*' + value.trim() + '*'
            + "' OR phoneNumber:" + '*' + value.trim() + '*'
            + "' OR secondaryphoneno:" + '*' + value.trim() + '*'
            + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "
        }
      }




      this.search = searchTerm;
      if (index == 1) {
        this.redirected = false;
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');



        if (questionMarkIndex !== -1) {
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;

        localtion = localtion.split('&page')[0]


        if (this.sortParam == undefined) {
          if (this.sortEnabled) {

            if (this.sortDirection == 1) {
              this.sortParam = this.sortParamNew + "," + Constant.Dsc;
            } else {
              this.sortParam = this.sortParamNew + "," + Constant.Asc;
            }


          } else {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

        }

        this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
      }


      if (this.advanceFilterEnble == true) {
        this.getAllLeadAdvanceFilter(this.search)
      } else if (this.smartViewConditionsEnble == true) {
        this.filterActive = true;
        this.getDynamicLeadReport(this.search)
      }
      else {
        this.filterOption(this.search);
      }



    }
  }


  onFilterChangeColumn(i, index) {


    this.ensureSmartViewFromFilter();

    if (this.connectedCall) {

      this.getAllConnectedOnes();
    }

    else if (this.GridType == 6) {
      this.refreshTypesixDatas();
    }
    if (i == undefined) {
      this.leadIdList = [];
      this.selectionLead = [];
      this.filterActive = false
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      let location = this.router.url;
      const questionMarkIndex = location.indexOf('?');



      if (questionMarkIndex !== -1) {
        // Extract the substring before the ?
        const beforeQuestionMark = location.substring(0, questionMarkIndex);

        // Replace the original string with the substring before the ?
        location = beforeQuestionMark;
      }

      let url = this.router.url;
      let cleanUrl = url.split('?')[0];


      if (this.sortEnabled) {

        if (this.sortDirection == 1) {
          this.sortParam = this.sortParamNew + "," + Constant.Dsc;
        } else {
          this.sortParam = this.sortParamNew + "," + Constant.Asc;
        }


      } else {
        this.sortParam = 'updatedDate' + "," + Constant.Dsc;
      }

      this.location.go(`${cleanUrl}`)

      if (this.advanceFilterEnble == true) {
        this.getLeadAdvanceFilter();
      } else if (this.smartViewConditionsEnble == true) {
        this.getDynamicLeadReport(null)
      } else if (this.activeTab === 'new') {
        this.filterQuery = 'statusName:*New,*';
        this.getLeadsFilter();
      } else {
        this.getProduct();
      }

    } else {
      i = i.replace(/'/g, '');
      if (this.router.url.includes('lead') || this.router.url.includes('contact')) {
        i = this.normalizeLeadSearchQuery(i);
      }
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
          console.error('Error decrypting or parsing userSettingsData:', error);
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }

      if (val > 0) {
        //   let searchTerm = "name:" + '*' + value.trim() + '*'
        //   + "' AND supplierId_cust:" + '*' + val + '*'
        //   + "' OR sku:" + '*' + value.trim() + '*' + "' "
        // this.filterOption(searchTerm)

        //  let length=i.length;

        //  i = i.substring(0, length - 1);

        // Only add supplier filter if not from CRM search (index != 2)
        if (index != 2) {
          i = i + " AND supplierId_cust:" + '*' + val + '*' + "'"
        }
        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;

          localtion = localtion.split('&page')[0]


          if (this.sortEnabled) {

            if (this.sortDirection == 1) {
              this.sortParam = this.sortParamNew + "," + Constant.Dsc;
            } else {
              this.sortParam = this.sortParamNew + "," + Constant.Asc;
            }


          } else {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }

        if (this.advanceFilterEnble == true) {
          this.getAllLeadAdvanceFilter(i)
        }
        else if (this.smartViewConditionsEnble == true) {
          this.getDynamicLeadReport(i)
        }
        else {
          this.filterOption(i);
        }


      } else {
        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;

          localtion = localtion.split('&page')[0]


          if (this.sortEnabled) {

            if (this.sortDirection == 1) {
              this.sortParam = this.sortParamNew + "," + Constant.Dsc;
            } else {
              this.sortParam = this.sortParamNew + "," + Constant.Asc;
            }


          } else {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }

        if (this.advanceFilterEnble == true) {
          this.getAllLeadAdvanceFilter(i)
        } else if (this.smartViewConditionsEnble == true) {
          this.filterActive = true;

          this.activeTab = localStorage.getItem("activeTab");
          this.getDynamicLeadReport(i)
        }
        else {
          this.filterOption(i);
        }
      }

    }
    this.loaderService.hide();
    this.notifyKanbanUpdate();
  }
  refreshTypesixDatas() {
    this.getLead();
    this.getUnassignedlead()
    this.getTodayLead();
    this.getUntouchedLed();
    this.getLeadTodayUntouch();
    this.getLeadAssignToday();

  }

  exportExcel() {
    this.router.navigate([`/lead/export-lead`])
  }




  downloadReportTemplate() {
    this.productService.downloadProductTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  downloadTemplate1() {
    this.productService.downloadProductNameTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  exportGmc() {
    this.productService.downloadGmc().subscribe(
      data => {
        download(data);
      },
    )
  }

  sitedata() {
    this.productService.downloadshopdata().subscribe(
      data => {
        download(data);
      }
    )
  }

  openImportDataPopup() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductQtyAndPrice' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }


  openImportDataPopup1() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductNameAndDescription' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }

  @ViewChild('delete') delete: TemplateRef<any>;

  deleteAllProductDialog() {
    this.deleteConfirmText = '';
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  @ViewChild('deleteSelected') deleteSelected: TemplateRef<any>;

  deleteSelectedDialog() {
    let dialogRef = this.dialog.open(this.deleteSelected, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProduct() {
    if (this.textAccount === 'Processing') return;

    if (this.resourcePrivilege && this.resourcePrivilege.delete === false) {
      this.snackBar.open('You do not have permission to delete leads', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    this.textAccount = 'Processing';
    this.spinner = true;
    this.productService.deleteAllLead().subscribe(
      response => {
        this.spinner = false;
        this.textAccount = 'OK';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.dialog.closeAll();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.getProduct();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
        this.spinner = false;
        this.textAccount = 'OK';
        this.snackBar.open('Error deleting leads', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  @ViewChild('housindata') housinLead: TemplateRef<any>;

  housingLeadData() {
    let dialogRef = this.dialog.open(this.housinLead, {
      width: '550px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }
  @ViewChild('Whatsapp') Whatsapp: TemplateRef<any>;
  form: FormGroup;
  temp: FormGroup;
  selectedTemplate: string;
  init: boolean = true;


  Openwhatsappdata() {
    let dialogRef = this.dialog.open(this.Whatsapp, {
      width: '550px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  getALLWhatsAppNumbers() {
    if (this.text == 'Save' && this.templateId.valid) {
      if (this.id != 0) {
        // this.firstFormGroup.value.operationType = "Change"
      }
      else {
        // this.firstFormGroup.value.operationType = "New"
      }

      this.text = "Processing"
      this.productService.sendWhatsAppMessage(this.leadIdList, this.templateId.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.dialog.closeAll();
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.dialog.closeAll();
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => {
          this.dialog.closeAll();
          this.text = "Save"
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  cancel() {
    this.location.back()
  }

  @ViewChild('whatsapptemplatedata') whatsapptemplatedata: TemplateRef<any>;

  sendWhatsappMessage() {

    if (this.leadIdList.length > 0) {

      let leadOBject = JSON.stringify(this.leadIdList);

      let encryptedLeadObject = this.ecryptService.encryptionAES(leadOBject);

      // Store in sessionStorage to avoid URL length issues
      sessionStorage.setItem('leadContactsData', encryptedLeadObject);

      // Close any open dialogs before navigating
      this.dialog.closeAll();

      this.router.navigate(['/createCampaignTemplate'], {
        queryParams: {
          lead: encryptedLeadObject,
          fromLeads: true
        }
      });

    }


  }

  secondinit: boolean = true;
  goback() {
    this.init = true;
    this.secondinit = false;
  }

  dateRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const start = group.get('start')?.value;
    const end = group.get('end')?.value;
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
      if (diffInDays > 7) {
        return { 'exceedsMaxRange': true };
      }
    }
    return null;
  }

  createHousingLead() {
    if (this.range.hasError('exceedsMaxRange')) {
      this.snackBar.open('Date range exceeds the maximum limit of 7 days.', '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 500
      });
      return;
    }

    if (this.textAccountHousing == 'OK' && this.range.valid) {
      const startDate = this.range.value.start;
      const endDate = this.range.value.end;
      const obj = {
        "start": this.dataPipe.transform(startDate, 'yyyyMMdd'),
        "end": this.dataPipe.transform(endDate, 'yyyyMMdd')
      };

      this.textAccountHousing = "Processing";
      this.productService.addOrEditHousingLeadData(obj).subscribe(
        (response) => {
          console.log('Response:', response);
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.textAccountHousing = "OK";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

            this.dialog.closeAll();
          } else {
            this.textAccountHousing = "OK";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          console.error('Error:', err);
          this.textAccountHousing = "OK";
        }
      );
    } else {
      validateAllFormFields(this.range);
    }
  }

  deleteAllProductId(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.productService.deleteByLeadId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getProduct();
          if (this.GridType == 6) {
            this.refreshTypesixDatas();
          }
          this.cancelBulkSelection();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      () => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct(leadId, setId) {

    if (this.crmType == 6) {
      this.openLeadPopup(setId, leadId);
    }
    else {

      if (this.defaultSetType == 0) {
        this.router.navigate([`lead/add-edit-lead/${leadId}/${this.defaultSet}`])
      } else {
        this.router.navigate([`lead/add-edit-lead/${leadId}/${setId}`])
      }

    }

  }

  importExcel() {
    let setId = this.defaultSet
    this.router.navigate([`/lead/import-lead/${setId}`])
  }

  importExcelAdvance() {
    if (this.pageList >= this.productLimitedRestrictionValue) {
      this.restritionPopup();
      return;
    } else {
      this.router.navigate([`/lead/xlMapper`])
    }
  }


  public serverPath4 = environment.commonImageApiNew
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath8 = environment.commonImageApi;

  getImage(value, images, row) {

    if (row.maintainImageIndConfProduct == 1 && row.type == 'Variants') {



      let i = 0

      this.configurableProductDropdown = row['configProduct'];

      if (this.configurableProductDropdown != null) {
        for (let key of Object.keys(this.configurableProductDropdown)) {
          if (i == 0) {
            key = key;
            this.productSelected = JSON.parse(this.configurableProductDropdown[key]);

            break;
          }

        }


        // let productSelected = JSON.parse(this.configurableProductDropdown[key]);



        value = this.productSelected['productImageUrl']
        images = this.productSelected['images']
      }
      if (value == '') {
        if (images != null) {

          if (images.length > 0) {
            value = images[0]
          }



        }
      }


    }

    if (value != null) {

      if (value.includes('external')) {
        return this.serverPath8 + value;
      }
      if (value.includes('commonimages')) {
        return this.serverPath7 + value;
      }
      else if (value.includes('http')) {
        return value;
      } else if (!value.includes('medicineimages')
        && !value.includes('http')) {

        return this.serverPath + '/' + value;
      } else if (!value.includes('medicineimages')) {
        return this.serverPath4 + value;
      } else {
        return "assets/images/logo/no-image.png";
      }

    }
  }





  //seleted data

  selectionLead: any = [];
  public attributeIdList: any = [];
  public attributeListForProduct: any = [];
  @Output() onConfirAttribute: EventEmitter<any> = new EventEmitter<any>();

  checkBoxControl: UntypedFormControl = new UntypedFormControl();
  changeValue(isChecked: boolean, row) {


    if (isChecked) {

      let indexForSelection = this.leadIdList.findIndex(
        x => x.ownerId == row.ownerId && x.leadId == row.entityId
      );

      if (indexForSelection < 0) {
        this.selectionLead.push(row.entityId);
        let object = {
          ...row,
          'ownerId': row.ownerId,
          'leadId': row.entityId,
          'phoneNo': row.phoneNumber,
          'status': row.statusName,
          'downloadList': row.downloadList,
          'entityId': row.entityId,
          'email': row.email,
          'name': row.name,
          'activityCountOnLead': row.activityCountOnLead
        }
        this.leadIdList.push(object);
        this.checkBoxControl.patchValue(row.entityId)
      }

    } else {
      let indexForSelectedIncrementId = this.selectionLead.findIndex(x => x == row.entityId)

      this.selectionLead.splice(indexForSelectedIncrementId, 1);

      let indexForSelected = this.leadIdList.findIndex(x => x.leadId == row.entityId)

      this.leadIdList.splice(indexForSelected, 1);


    }

    console.log(this.leadIdList);

    this.onConfirAttribute.emit(this.attributeListForProduct);
  }

  selection = new SelectionModel<any>(true, [], true, (o1, o2) => o1 && o2 && (o1.entityId === o2.entityId || o1 === o2));

  isRowSelected(element: any): boolean {
    if (!element || !this.selectionLead) return false;
    return this.selectionLead.includes(element.entityId);
  }

  syncSelectionOnDataLoad() {
    if (!this.productList || !Array.isArray(this.productList)) {
      return;
    }
    if (this.selectionLead && this.selectionLead.length > 0) {
      const selectedSet = new Set(this.selectionLead);
      const matched = this.productList.filter(row => row && selectedSet.has(row.entityId));
      if (matched.length > 0) {
        this.selection.select(...matched);
      }
    }
  }

  getSelectedCount(): number {
    if (this.selectionLead && Array.isArray(this.selectionLead) && this.selectionLead.length > 0) {
      return this.selectionLead.length;
    }
    return this.selection?.selected?.length || 0;
  }

  isSelectionEmpty(): boolean {
    const hasLeadSelection = this.selectionLead && Array.isArray(this.selectionLead) && this.selectionLead.length > 0;
    return !hasLeadSelection && (!this.selection || this.selection.isEmpty());
  }
  attributeList: any = [];
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.productList?.length;
    return numSelected === numRows;

  }
  cancelBulkSelection() {
    this.selection.clear();
    this.selectionLead = [];
    this.leadIdList = [];
  }
  //For Filter 
  isFilterPanelOpen = false;
  isFilterPanelColumnOpen = false;
  rowLeft: string = "100";
  rowRight: string = "30";
  rowgap: string = "0px";
  isGridVisible: boolean = true;

  activeFilters: any[] = [];
  appliedFilterCount = 0;
  private filterQuery: string | null = 'statusName:*New*';


  toggleFilterPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelOpen = !this.isFilterPanelOpen;

    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  toggleFilterColumnPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelColumnOpen = !this.isFilterPanelColumnOpen;

    if (this.isFilterPanelColumnOpen) {
      this.isFilterPanelOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  addFilter(): void {
    this.activeFilters.push({ field: '', value: '' });
  }

  removeFilter(index: number): void {
    this.activeFilters.splice(index, 1);
    this._buildAndFetchFilters();
  }
  private formatSearchForNewLeadTab(searchStr: string | null | undefined): string {
    const newLeadStatus = 'statusName:*New,*';
    if (!searchStr || searchStr.trim() === '') {
      return newLeadStatus;
    }

    const trimmed = searchStr.trim();
    if (trimmed.includes('statusName:*New,') || trimmed.includes('statusName:*New*')) {
      return trimmed;
    }

    if (trimmed.includes(' OR ') && !trimmed.startsWith('(')) {
      return `${newLeadStatus} AND (${trimmed})`;
    } else {
      return `${trimmed} AND ${newLeadStatus}`;
    }
  }

  private _buildAndFetchFilters(): void {
    const queryParts = this.activeFilters
      .filter(f => f.field && f.value)
      .map(f => `${f.field}:*${f.value}*`);
    let queryStr = queryParts.length > 0 ? queryParts.join(' AND ') : null;
    if (this.activeTab === 'new') {
      queryStr = this.formatSearchForNewLeadTab(queryStr);
    }
    this.filterQuery = queryStr;
    this.appliedFilterCount = this.activeFilters.filter(f => f.field && f.value).length;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.page = 0;
    if (queryParts.length > 0 || this.activeTab === 'new') {
      this.getLeadsFilter(); // Hypothetical method if filters exist
    } else {
      this.getProduct(); // Called when no filters are present
    }
  }
  getAdjustedColor(
    color: string,
    targetLightness: number,
    saturationAdjustmentFactor: number = 0
  ): string {
    const hex = this.parseColorToHex(color);

    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = 0,
      s: number,
      l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    const targetL = targetLightness / 100;

    const blendFactor = 0.6;
    let newL = l + (targetL - l) * blendFactor;


    newL = Math.max(0, Math.min(1, newL));
    let newS = s;
    if (newL * 100 > 90 && s > 0.1) { // Only adjust if not already desaturated

      const lightnessProximityToWhite = (newL * 100 - 90) / 10;
      newS = s * (1 - lightnessProximityToWhite * saturationAdjustmentFactor);
      newS = Math.max(0, newS);
    }


    return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
  }
  updateColor(column: any, newColor: string) {
    column.statusColor = newColor;
    this.cdr.markForCheck();
  }
  private parseColorToHex(color: string): string {

    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);


    const computed = window.getComputedStyle(div).color;
    document.body.removeChild(div);

    const rgb = computed.match(/\d+/g).map(Number);
    return '#' + rgb.map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }

  /**
   * Return a darker color (HSL string) based on the provided color.
   * darkenByPercent: how much to reduce lightness (0-100). Default 40%.
   */
  getDarkerTextColor(color: string, darkenByPercent: number = 40): string {
    try {
      if (!color) return '#000000';
      const hex = this.parseColorToHex(color);

      const r = parseInt(hex.substring(1, 3), 16) / 255;
      const g = parseInt(hex.substring(3, 5), 16) / 255;
      const b = parseInt(hex.substring(5, 7), 16) / 255;

      const max = Math.max(r, g, b), min = Math.min(r, g, b);
      let h = 0, s = 0, l = (max + min) / 2;

      if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }

      // Decrease lightness by the requested percent
      let newL = l - (darkenByPercent / 100);
      newL = Math.max(0, Math.min(1, newL));

      // If saturation is NaN (e.g., grey), keep it 0
      const newS = isNaN(s) ? 0 : s;

      return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
    } catch (e) {
      return '#000000';
    }
  }

  viewMode: 'compact' | 'comfortable' = 'compact';
  tableViewMode: 'tableView' | 'kanbanView' = "tableView"

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }
  setTableView(mode) {
    this.tableViewMode = mode;
    localStorage.setItem('leadsViewMode', mode);

    if (mode === 'kanbanView') {
      let isSmartViewActive = localStorage.getItem('smartViewConditionsEnble') === 'true';
      if (isSmartViewActive) {
        this.onTabClick('all', { preventDefault: () => { } } as Event);
      } else {
        this.notifyKanbanUpdate();
      }
    }
  }
  applyFiltersAndClose(): void {
    this._buildAndFetchFilters();
    this.isFilterPanelOpen = false;
  }
  activeTab: any = 'all'; // default tab

  onTabClick(tab: 'all' | 'new', event: Event): void {
    event.preventDefault(); // prevent default anchor behavior

    this.clearFilter();

    this.activeTab = tab;

    if (tab === 'new') {
      this.filterQuery = 'statusName:*New,*';
      this.page = 0;
      this.smartViewConditionsEnble = false;
      localStorage.removeItem("smartViewConditionsEnble");
      localStorage.removeItem("smartViewConditions");
      this.getLeadsFilter();
    } else if (tab === 'all') {
      this.filterQuery = '';
      let url = this.router.url;
      if (url.includes('lead') || url.includes('contact')) {
        let cleanUrl = url.split('?')[0];
        localStorage.removeItem(cleanUrl + "se");
      }
      this.page = 0;
      this.getProduct();
      this.smartViewConditionsEnble = false;
      localStorage.removeItem("smartViewConditionsEnble");
      localStorage.removeItem("smartViewConditions");
    }
  }

  getLeadsFilter() {
    this.productService
      .getLeadBySearch(this.filterQuery, this.page, this.size, this.sortParam)
      .subscribe(
        res => {
          let url = this.router.url;
          if (url.includes('lead') || url.includes('contact')) {
            let cleanUrl = url.split('?')[0];
            if (this.filterQuery) {
              localStorage.setItem(cleanUrl + "se", this.filterQuery);
            } else {
              localStorage.removeItem(cleanUrl + "se");
            }
          }
          this.spinner = false;

          this.totalElements = res['totalElements'];
          this.totalLeadCount = res['totalElements'];
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.updateAllEntityIds(res['content']);
          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.newContactCount = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();
          this.cdr.detectChanges();
          // notify kanban to refresh when filters/search updated
          this.notifyKanbanUpdate();
          this.columnsReady
        },
        error => {
          this.spinner = false;
          console.error("Error fetching leads:", error);
        }
      );
  }
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    // this.selection.select(...this.dataSource.data);

    this.selection.select(...this.productList);
    this.selectionLead = this.productList.map(row => row.entityId);
    this.leadIdList = this.productList.map(row => ({
      ...row,
      'ownerId': row.ownerId,
      'leadId': row.entityId,
      'phoneNo': row.phoneNumber,
      'status': row.statusName,
      'downloadList': row.downloadList,
      'entityId': row.entityId,
      'email': row.email,
      'name': row.name,
      'description': row.description,
      'activityCountOnLead': row.activityCountOnLead
    }));


  }
  selectAllForBulkAction() {
    this.masterToggle();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.entityId}`;
  }

  textAccount: string;
  textAccountHousing: string;
  deleteConfirmText: string = '';

  get isDeleteDisabled(): boolean {
    return this.textAccount !== 'OK' || this.deleteConfirmText?.trim()?.toLowerCase() !== 'delete';
  }

  submit() {
    if (this.isDeleteDisabled) {
      return;
    }
    this.deleteAllProduct();
  }

  deleteSelectedLead() {
    this.deleteAllProductSelected();
  }



  submit1() {

    //this.deleteAllProductId(id:any)
    this.dialog.closeAll();
  }
  // initPromos() {
  //   this.firstFormGroup = this._formBuilder.group({
  //     id: [''],
  //     sharedOn: [''],

  //   });
  // }

  downloadReport(value) {

    if (value == 'full') {
      this.selectionLead = [];
    }

    this.downloadDataComplete = "Processing";
    this.productService.downloadProductReportPrimary(this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit, this.selectionLead).subscribe(
      data => {
        this.downloadDataComplete = "OK";
        this.dialog.closeAll();
        download(data);
        this.selectionLead = [];
      },
    )
  }

  @ViewChild('download') download: TemplateRef<any>;

  openDialog() {
    let dialogRef = this.dialog.open(this.download, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  firstFormGroup = this._formBuilder.group({
    page: ['', Validators.required],
    size: ['', Validators.required],
    sort: ['', Validators.required],
    sortBy: ['0']

  });

  booleanField: any = [
    { "value": "asc", "viewValue": "ASC" },
    { "value": "desc", "viewValue": "DESC" },
  ]

  downloadData() {

    if (this.firstFormGroup.valid) {
      console.log(this.firstFormGroup);
      this.page = this.firstFormGroup.value.page;
      this.sortParam = this.firstFormGroup.value.sort;
      this.size = this.firstFormGroup.value.size;
      if (this.firstFormGroup.value.sortBy == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (this.firstFormGroup.value.sortBy == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.downloadReport('full');

    } else {
      this.firstFormGroup.markAllAsTouched();

    }
  }

  restritionPopup() {

  }


  details(leadId) {

    let option = Constant.MOBILE_Device;

    if (option == "1") {
      this.leadDetailType == 0;
    }

    if (this.leadDetailType == 0) {
      this.router.navigate([`leadDetail/${leadId}`])
    } else {

      const url = this.router.serializeUrl(
        this.router.createUrlTree([`leadDetail/${leadId}`])
      );
      const relativeUrl = url.replace(window.location.origin, '');
      window.open(relativeUrl, '_blank');

    }

  }

  details1(leadId: string) {
    window.open(`/leadDetail/${leadId}`, '_blank');
  }


  @Input() removeColummn: any = ['LeadId', 'Document', 'Owner FirstName', 'ownerId'];


  exportDataFilter() {
    if (window.innerWidth < 768) {
      let objToSend = this.filterSelectObj;

      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        maxWidth: '100vh',
        height: '100vh',
        width: '100%', disableClose: true,
        data: {
          url: 'getLeadBySearch',
          obj: objToSend,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: true,
          url2: 'getLead',
          header: ['Name', 'Email', 'Phone No', 'Status Name', 'Source Name', 'Owner', 'Description', 'Activity Count', 'Created Date', 'Updated Date', 'Country', 'City', 'State', 'Campaign Name', 'Ad Name'],
          service: 'productService',
          headerName: this.contactPage ? 'Contact Download' : 'Lead Download',
          dowloadFileName: this.contactPage ? 'Contact' : 'Lead'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {
          this.selection.clear();
        }
      });
    }
    else {
      let objToSend = this.filterSelectObj;

      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        height: '400px',
        disableClose: true,
        data: {
          url: 'getLeadBySearch',
          obj: objToSend,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: true,
          url2: 'getLead',
          header: ['Name', 'Email', 'Phone No', 'Status Name', 'Source Name', 'Owner', 'Description', 'Activity Count', 'Created Date', 'Updated Date', 'Country', 'City', 'State', 'Campaign Name', 'Ad Name'],
          service: 'productService',
          headerName: this.contactPage ? 'Contact Download' : 'Lead Download',
          dowloadFileName: this.contactPage ? 'Contact' : 'Lead'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {
          this.selection.clear();
        }
      });
    }


  }

  exportDataFilterSelected(type) {

    if (type == 'selected') {
      const selectedRows: any[] = (this.selection?.selected || []);
      if ((!selectedRows || selectedRows.length === 0) && (!this.leadIdList || this.leadIdList.length === 0)) {
        return;
      }

      let value = ['Name', 'Email', 'Phone No', 'Status Name', 'Source Name',
        'Owner', 'Description', 'Activity Count', 'Created Date', 'Updated Date', 'Country',
        'City', 'State', 'Campaign Name', 'Ad Name'];
      const dataToDownload = ((this.leadIdList && this.leadIdList.length > 0) ? this.leadIdList : selectedRows);

      this.commonService.downloadDataFinal(dataToDownload, value, this.contactPage ? 'Contact Download' : 'Lead Download', true);


    } else {

      let i = 0;
      let ownerText = "ownerId:*"
      let leadText = "entityId:*"
      this.leadIdList.forEach(element => {



        if (i == 0) {
          ownerText = ownerText + element.ownerId + ",";;

          leadText = leadText + element.leadId + ",";
        } else {
          ownerText = ownerText + "," + element.ownerId;

          leadText = leadText + "," + element.leadId;
        }



        i++;
      });

      let finalText = ownerText + '*' + ' AND ' + leadText;


      console.log(finalText);

      this.selectUpload = true;

      const prevPage = this.page;
      const prevSize = this.size;
      try {
        this.page = 0;
        const totalToFetch = (this.pageList && this.pageList > 0) ? this.pageList :
          ((this.totalElements && this.totalElements > 0) ? this.totalElements : 1000000);
        this.size = totalToFetch;

        if (this.advanceFilterEnble == true) {
          this.getAllLeadAdvanceFilter(finalText)
        }
        else if (this.smartViewConditionsEnble == true) {
          this.getDynamicLeadReport(finalText)
        }
        else {
          this.filterOption(finalText);
        }

      } finally {
        this.page = prevPage;
        this.size = prevSize;
      }

    }


    this.selection.clear();

  }

  leadIdList: any = [];

  transferLead(randomAssign) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "ownerIds": this.leadIdList,
          "leadIds": this.selectionLead,
          "typeData": 2,
          "randomAssign": randomAssign
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
          this.selection.clear();
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "ownerIds": this.leadIdList,
          "leadIds": this.selectionLead,
          "typeData": 2,
          "randomAssign": randomAssign
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
          this.selection.clear();

        }

      });
    }
  }

  downloadDataFinal(downLoadData) {
    let value = ['Name', 'Email', 'Phone No', 'Status Name', 'Source Name',
      'Owner', 'Description', 'Activity Count', 'Created Date', 'Updated Date', 'Country',
      'City', 'State', 'Campaign Name', 'Ad Name'];
    this.commonService.downloadDataFinal(downLoadData, value, this.contactPage ? 'Contact Download' : 'Lead Download', true);
    this.selectionLead = [];
    this.selectUpload = false;
    this.leadIdList = [];

    if (this.GridType == 8) {
      this.getProduct();
    } else {
      this.getProduct();
    }
  }


  removeColumn(downloadData) {

    this.downloadData = downloadData.map(obj => {
      for (const column of this.removeColummn) {
        delete obj[column];
      }
      return obj;
    });


    return this.downloadData;

  }


  //WhatsappTemplateMessage
  protected _onDestroy = new Subject<void>();
  protected _onDestroy1 = new Subject<void>();

  WhatsappTemplateMessageList: any;
  filteredWhatsappTemplateMessageTypeList: any;

  public WhatsappTemplateMessageFilterControl: UntypedFormControl = new UntypedFormControl();

  getWhatsappTemplateMessageList() {
    this.whatsapptemplatemessageService.getAllWhatsapptemplatemessageDropDown().subscribe(
      (res) => {
        this.WhatsappTemplateMessageList = res;
        this.WhatsappTemplateMessageList = this.WhatsappTemplateMessageList;
        this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList;
      },
      () => { }
    );
  }

  WhatsappTemplateMessageYFilter() {
    this.WhatsappTemplateMessageFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.WhatsappTemplateMessageFilter();
      });
  }

  protected WhatsappTemplateMessageFilter() {
    if (!this.WhatsappTemplateMessageList) {
      return;
    }
    let search = this.WhatsappTemplateMessageFilterControl.value;
    if (!search) {
      this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList.filter(
      (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllWhatsappTemplateMessage() {
    this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList;
  }

  deleteAllProductSelected() {
    if (this.textAccount === 'Processing') return;

    if (this.resourcePrivilege && this.resourcePrivilege.delete === false) {
      this.snackBar.open('You do not have permission to delete leads', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    if (!this.selectionLead || this.selectionLead.length === 0) {
      this.snackBar.open('No leads selected', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    this.textAccount = 'Processing';
    this.spinner = true;
    this.productService.deleteBySelectedId(this.selectionLead).subscribe(
      response => {
        this.spinner = false;
        this.textAccount = 'OK';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.dialog.closeAll();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.getProduct();
          this.selectionLead = [];
          this.cancelBulkSelection();
          this.leadIdList = [];
          this.checkBoxControl.reset();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
        this.spinner = false;
        this.textAccount = 'OK';
        this.snackBar.open('Error deleting selected leads', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }


  @ViewChild('updateStatus') updateStatus: TemplateRef<any>;

  UpdateStatus() {

    this.text = 'Save';
    let dialogRef = this.dialog.open(this.updateStatus, {
      width: '550px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  secondFormGroup = this._formBuilder.group({
    page: ['', Validators.required],
  });

  //leadStatus

  filtereddropdownTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  // defaultLeadStatus = new FormControl('');

  defaultLeadStatus = new FormControl('', [Validators.required]);

  dropdownTypeList: any;
  dropdownList: any;


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
      },
      () => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  UpdateLeadStatus() {


    if (this.text == 'Save' && this.defaultLeadStatus.valid && this.selectionLead.length > 0) {

      console.log(this.defaultLeadStatus);

      console.log(this.leadIdList);
      this.text = "Processing";
      this.spinner = true;
      this.dialog.closeAll();
      this.snackBar.open("Lead status update started in the background...", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

      this.productService.updateLeadStatus(this.selectionLead, this.defaultLeadStatus.value).subscribe(
        response => {
          this.text = 'Save';
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.getProduct();
            this.selectionLead = [];
            this.selection.clear();

            this.leadIdList = [];
            this.checkBoxControl.reset();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        () => {
          this.text = 'Save';
          this.spinner = false;
        })

    } else {

      this.snackBar.open('Please select Lead Status and Lead',
        '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }
  }


  getInitials(name: string | null | undefined): string {
    if (!name) {
      return '';
    }
    const nameParts = name.split(' ');
    let initials = nameParts[0].slice(0, 2);
    return initials;
  }


  generateLetterIcon(name) {

    if (name != null) {
      const words = name.split(' ');

      if (words.length > 1) {
        return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toLowerCase();
      } else {
        return name.charAt(0).toUpperCase() + name.charAt(1).toLowerCase();
      }
    }

  }

  LeadOwnerSearch(data) {

    this.LeadOwnerCallSearch(data);

  }



  LeadOwnerCallSearch(row) {
    if (row.paid <= 0 && row.balance == 0 || row.paymentStatus == 'Paid') {
      this.snackBar.open('Payment status is already paid for the Sales', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    } else {

      if (window.innerWidth > 768) {

        let dialogRef = this.dialog.open(LeadOwnerSearchComponent, {
          width: '790px',
          data: {
            finalData: row,
          }


        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(() => {


        });

      }
      else {
        let dialogRef = this.dialog.open(LeadOwnerSearchComponent, {
          minWidth: '100vw', height: '100vh',
          data: {
            finalData: row
          }

        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(() => {

        });
      }
    }
  }

  filterSelectObj1 = [
    {
      name: 'Name',
      property: 'name',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Email',
      property: 'email',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'Phone No',
      property: 'phoneNumber',
      type: 'text',
      position: 'thirdValue',
      options: []
    },
    {
      name: 'Status Name',
      property: 'statusName',
      type: 'multiSelect',
      position: 'fourthValue',
      options: [],
      display: true
    },
    {
      name: 'Source Name',
      property: 'sourceName',
      type: 'multiSelect',
      position: 'fifthValue',
      options: [],
      display: true
    },
    {
      name: 'Owner',
      property: 'ownerEmail',
      type: 'multiSelect',
      position: 'sixthValue',
      options: [],
      display: true
    },
    {
      name: 'created Date',
      property: 'createdDate',
      type: 'date',
      position: 'seventhValue',
      options: []
    },

    {
      name: 'updated Date',
      property: 'updatedDate',
      type: 'date',
      position: 'eighthValue',
      options: []
    },

    {
      name: 'Follow Up Date',
      property: 'followUpDateTime',
      type: 'date',
      position: 'ninthValue',
      options: []
    },
    {
      name: 'Tags',
      property: 'tagName',
      type: 'select',
      position: 'tenthValue',
      options: []
    },
  ]

  getApprove(row) {
    if (row.email != null) {
      if (row.approvedStatus == 0) {

        this.loaderService.show();
        this.productService.getApproved(row).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.loaderService.hide();

              let associateId = response['data'].associatedUserId;
              let cleanUrl = "/lead";

              localStorage.removeItem(cleanUrl);
              localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
              localStorage.removeItem(cleanUrl + "type");
              localStorage.removeItem(cleanUrl + "range");

              this.getLead();

              // this.router.navigate([`/salesOrder/add-salesOrder/${salesOrderId}/${userId}`])
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            }
            else {
              this.loaderService.hide();
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }

          },
          () => { this.loaderService.hide(); });
      } else {

        let msg = "Lead Already Converted to a Cusotmer"
        this.snackBar.open(msg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      }
    } else {
      alert("Email cannot be null.");
    }
  }




  switchView(type: string) {
    this.viewType = type;
    if (this.viewType === 'kanban') {

    }
  }

  isLeadViewSelected: boolean = false;

  viewType: string = 'leadview';

  selectView(view: string) {
    this.isLeadViewSelected = view === 'leadView';
    this.viewType = view; // Update viewType so that the display changes accordingly
  }

  /**
   * If kanban view is active, trigger the kanban child to reload its columns so it picks up
   * the latest filters/search state.
   */
  private notifyKanbanUpdate(): void {
    try {
      const shouldRefresh = (this.viewType === 'kanban') || (this.tableViewMode === 'kanbanView');
      if (shouldRefresh && this.dealsKanban && typeof this.dealsKanban.getLeadStatus === 'function') {
        this.dealsKanban.getLeadStatus();
      }
    } catch (e) {
      console.warn('Failed to refresh common-product kanban:', e);
    }
  }


  openNew1() {
    this.isPopupOpen1 = true;
    this.isPopupOpenTwo = false;
  }


  closePopupNew(event) {
    if (event == true) {
      this.isPopupOpen1 = false;
      this.toggleFilterPanel();
    }
  }

  emailtemplateId = new FormControl('', [Validators.required]);

  fromEmailId = new FormControl('', [Validators.required]);
  fromEmail = new FormControl('', [Validators.required]);

  @ViewChild('emailtemplatedata') emailtemplatedata: TemplateRef<any>;

  sendEmailMessage() {
    let dialogRef = this.dialog.open(this.emailtemplatedata, {
      width: '750px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  // emailTemplateMessage

  protected _onDestroy2 = new Subject<void>();

  emailTemplateMessageList: any;

  filteredEmailTemplateMessageTypeList: any;

  public emailTemplateMessageFilterControl: UntypedFormControl = new UntypedFormControl();

  getEmailTemplateMessageList() {
    this.templateService.getAllEmailSendDropDown().subscribe(
      (res) => {
        this.emailTemplateMessageList = res;
        this.emailTemplateMessageList = this.emailTemplateMessageList;
        this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
      },
      () => { }
    );
  }

  EmailTemplateMessageYFilter() {
    this.emailTemplateMessageFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.EmailTemplateMessageFilter();
      });
  }

  protected EmailTemplateMessageFilter() {
    if (!this.emailTemplateMessageList) {
      return;
    }
    let search = this.emailTemplateMessageFilterControl.value;
    if (!search) {
      this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.filter(
      (dynamicForm) => dynamicForm['templateName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllEmailTemplateMessage() {
    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
  }

  sendMailTemplate() {
    if (this.textSend == 'Send' && this.emailtemplateId.valid && (this.useIndividualMail != 1 || (this.fromEmailId.valid && this.fromEmail.valid))) {

      this.textSend = "Processing"
      const fromEmailIdVal = this.useIndividualMail == 1 ? this.fromEmailId.value : null;
      const fromEmailVal = this.useIndividualMail == 1 ? this.fromEmail.value : null;
      this.templateService.sendEmailMessage(this.leadIdList, this.emailtemplateId.value, fromEmailIdVal, fromEmailVal).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.textSend = "Send";
            this.dialog.closeAll();
            this.cancelBulkSelection();

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.dialog.closeAll();
            this.textSend = "Send";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            this.cancelBulkSelection();
          }
        },
        () => {
          this.dialog.closeAll();
          this.textSend = "Send"
        });
    }
    else {
      this.emailtemplateId.markAsTouched();
      if (this.useIndividualMail == 1) {
        this.fromEmailId.markAsTouched();
        this.fromEmail.markAsTouched();
      }
    }
  }

  onFromEmailChange(userMailConfigId: any) {
    if (!this.dropdownEmailTypeList) {
      return;
    }
    const selected = this.dropdownEmailTypeList.find(opt => opt.userMailConfigId === userMailConfigId);
    if (selected) {
      this.fromEmail.setValue(selected.emailAddress);
    }
  }

  advanceFilterEnble: boolean = false

  smartViewConditionsEnble: boolean = false

  advanceFilter() {

    const savedConditions = localStorage.getItem('advanceFilterConditions');
    const parsedData = savedConditions ? JSON.parse(savedConditions) : null;

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(AdvanceFilterComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "data": parsedData,
        }

      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'submit') {

          this.advance.conditions = result.conditions;

          this.advanceFilterEnble = true;

          localStorage.setItem('filtercondition', JSON.stringify(this.advance.conditions));


          localStorage.setItem('advanceFilterEnble', 'true');

          this.getLeadAdvanceFilter();


        } else if (result['event'] == 'clear') {
          this.advanceFilterEnble = false;
          localStorage.removeItem("advanceFilterEnble");
          localStorage.removeItem("advanceFilterConditionsText");
          localStorage.removeItem("advanceFilterConditions");
          this.getProduct();
        }
      });
    }
    else {

      let dialogRef = this.dialog.open(AdvanceFilterComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: {
          "data": parsedData,
        }

      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'submit') {

          this.advance.conditions = result.conditions;

          localStorage.setItem('filtercondition', JSON.stringify(this.advance.conditions));


          localStorage.setItem('advanceFilterEnble', 'true');

          this.advanceFilterEnble = true;

          this.getLeadAdvanceFilter();


        } else if (result['event'] == 'clear') {
          this.advanceFilterEnble = false;
          localStorage.removeItem("advanceFilterEnble");
          localStorage.removeItem("advanceFilterConditionsText");
          localStorage.removeItem("advanceFilterConditions");
          this.getProduct();
        }
      });
    }


  }

  advance: any = [];

  condition: any;

  getLeadAdvanceFilter() {

    this.smartViewConditionsEnble = false;
    localStorage.removeItem("smartViewConditionsEnble");
    localStorage.removeItem("smartViewConditions");

    this.loaderService.show();

    let sortParam: any = 'a.updatedDate' + "," + Constant.Dsc;

    if (this.advance.conditions !== null && this.advance.conditions !== undefined && this.advance.conditions !== '') {
      this.condition = this.advance.conditions;
    } else {
      this.condition = JSON.parse(localStorage.getItem('filtercondition'));
    }

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';


    if (this.advanceFilterEnble == true) {

      this.filterActive = false;
      this.spinner = true;
      this.leadActivityService.searchLeadAdvanceFilterNew(null, this.page, this.size, sortParam, this.condition).subscribe(
        res => {
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.updateAllEntityIds(res['content']);
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);

          this.loaderService.hide();

          console.log(this.productList);
          // notify kanban to refresh when filters/search updated
          this.notifyKanbanUpdate();


        },
        () => {
          this.spinner = false;
        }
      )

    } else {
      this.getProduct();
    }


  }

  getAllLeadAdvanceFilter(search) {

    this.smartViewConditionsEnble = false;
    localStorage.removeItem("smartViewConditionsEnble");
    localStorage.removeItem("smartViewConditions");

    let sortParam: any = 'a.updatedDate' + "," + Constant.Dsc;

    if (this.advance.conditions !== null && this.advance.conditions !== undefined && this.advance.conditions !== '') {
      this.condition = this.advance.conditions;
    } else {
      this.condition = JSON.parse(localStorage.getItem('filtercondition'));
    }

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';

    if (this.contactPage) {
      if (search == null || search == undefined || search == '') {
        search = this.searchContact;
      } else if (typeof search === 'string' && !search.includes("isClosedWon")) {
        search = search + " AND isClosedWon:*1,*";
      }
    }


    if (this.advanceFilterEnble == true) {

      this.filterActive = false;
      this.spinner = true;
      this.leadActivityService.searchLeadAdvanceFilterNew(search, this.page, this.size, sortParam, this.condition).subscribe(
        res => {
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.updateAllEntityIds(res['content']);
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.notifyKanbanUpdate();



          console.log(this.productList);

        },
        () => {
          this.spinner = false;
        }
      )
    }
    else {
      this.filterOption(search);
    }
  }

  filterSelectObjToday: any = [{ "name": "Select", "property": "disable", "type": "disable", "position": "firstValue", "options": [] },
  { "modelValue": "", "name": "Name", "property": "name", "type": "text", "position": "secondValue", "options": [] },
  { "name": "Phone No", "property": "phoneNumber", "type": "text", "position": "thirdvalue", "options": [] },
  { "name": "Icons", "property": "disable", "type": "disable", "position": "thirdvalue", "options": [] },
  { "name": "Source Name", "property": "sourceName", "type": "select", "position": "fourthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "fifthValue", "options": [] },
  { "name": "created Date", "property": "createdDate", "type": "date", "position": "fifteenValue", "options": [] },
  { "name": "updated Date", "property": "updatedDate", "type": "date", "position": "sixteenthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "seventeenValue", "options": [] }
  ]


  leadRange: any = {
    "ranges": [{ "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" }, { "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" },
    { "start": "", "end": "" },
    { "start": "", "end": "" }, { "start": "", "end": "" }]
  }

  todayDate: Date = new Date();
  viewPageToday() {

    this.commonService.clearStorage();
    this.selectedLeadStat = 'today';
    localStorage.setItem('selectedLeadStat', 'today');
    const formattedDate = this.todayDate.toISOString().split('T')[0];
    this.search = `createdDate:*${formattedDate}~${formattedDate}*`;

    this.leadRange.ranges[6].start = this.formatDate(formattedDate)
    this.leadRange.ranges[6].end = this.formatDate(formattedDate)

    let url = '/lead'
    let cleanUrl = url; url

    localStorage.removeItem(cleanUrl);
    localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObjToday));
    localStorage.setItem(cleanUrl + "se", this.search);
    localStorage.setItem(cleanUrl + "type", "2");

    localStorage.setItem(cleanUrl + "range", JSON.stringify(this.leadRange));

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/lead']);
    });

  }


  viewPageTotal() {
    this.commonService.clearStorage();
    this.selectedLeadStat = 'total';
    localStorage.setItem('selectedLeadStat', 'total');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/lead']);

    });

  }

  formatDate(date) {
    let formattedDate = this.dataPipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
    console.log(formattedDate); // Output: 2025-01-10T00:00:00.000Z
    return formattedDate
  }

  getLeadTodayUntouch() {

    const formattedDate = this.todayDate.toISOString().split('T')[0];
    this.search = `statusName:*Pending,New,*%20AND%20createdDate:*${formattedDate}~${formattedDate}*  OR transferDate:*${formattedDate}~${formattedDate}*`;
    this.productService.getLeadBySearch(this.search, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.todayUntochedCnt = res['totalElements'];
      },
      () => {
      })
  }

  filterSelectObjUntouch: any = [{ "name": "Select", "property": "disable", "type": "disable", "position": "firstValue", "options": [] },
  { "modelValue": "", "name": "Name", "property": "name", "type": "text", "position": "secondValue", "options": [] },
  { "name": "Phone No", "property": "phoneNumber", "type": "text", "position": "thirdvalue", "options": [] },
  { "name": "Icons", "property": "disable", "type": "disable", "position": "thirdvalue", "options": [] },
  { "name": "Source Name", "property": "sourceName", "type": "select", "position": "fourthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "fifthValue", "options": [] },
  { "name": "created Date", "property": "createdDate", "type": "date", "position": "fifteenValue", "options": [] },
  { "name": "updated Date", "property": "updatedDate", "type": "date", "position": "sixteenthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "seventeenValue", "options": [] }
  ]


  leadRange1: any = {
    "ranges": [{ "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" }, { "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" },
    { "start": "2025-01-08T18:30:00.000Z", "end": "2025-01-08T18:30:00.000Z" },
    { "start": "", "end": "" }, { "start": "", "end": "" }]
  }


  viewTodayUntouch() {
    this.commonService.clearStorage();
    this.selectedLeadStat = 'untouched';
    localStorage.setItem('selectedLeadStat', 'untouched');
    const formattedDate = this.todayDate.toISOString().split('T')[0];

    this.search = `statusName:*Pending,New,* AND createdDate:*${formattedDate}~${formattedDate}*  OR transferDate:*${formattedDate}~${formattedDate}*`;
    this.leadRange1.ranges[6].start = this.formatDate(formattedDate)
    this.leadRange1.ranges[6].end = this.formatDate(formattedDate)

    let url = '/lead'

    let cleanUrl = url; url

    localStorage.removeItem(cleanUrl);
    localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObjUntouch));
    localStorage.setItem(cleanUrl + "se", this.search);
    localStorage.setItem(cleanUrl + "type", "2");

    localStorage.setItem(cleanUrl + "range", JSON.stringify(this.leadRange1));
    let data = [null, null, null, null, null, ["Pending", "New"]];
    localStorage.setItem(cleanUrl + "selected", JSON.stringify(data));

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/lead']);
    });

  }

  userName: any;
  getLeadAssignToday() {

    const formattedDate = this.todayDate.toISOString().split('T')[0];
    this.userName = localStorage.getItem("authenticaterUserEmail");
    this.search = `createdDate:*${formattedDate}~${formattedDate}* OR transferDate:*${formattedDate}~${formattedDate}*`;

    this.productService.getLeadBySearch(this.search, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.assignLeadCnt = res['totalElements'];
      },
      () => {
      })

  }

  filterSelectObj2: any = [{ "name": "Select", "property": "disable", "type": "disable", "position": "firstValue", "options": [] },
  { "modelValue": "", "name": "Name", "property": "name", "type": "text", "position": "secondValue", "options": [] },
  { "name": "Phone No", "property": "phoneNumber", "type": "text", "position": "thirdvalue", "options": [] },
  { "name": "Icons", "property": "disable", "type": "disable", "position": "thirdvalue", "options": [] },
  { "name": "Source Name", "property": "sourceName", "type": "select", "position": "fourthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "fifthValue", "options": [] },
  { "name": "created Date", "property": "createdDate", "type": "date", "position": "fifteenValue", "options": [] },
  { "name": "updated Date", "property": "updatedDate", "type": "date", "position": "sixteenthValue", "options": [] },
  { "name": "Status Name", "property": "statusName", "type": "multiSelect", "position": "seventeenValue", "options": [] }
  ]


  leadRange2: any = {
    "ranges": [{ "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" }, { "start": "", "end": "" }, { "start": "", "end": "" },
    { "start": "", "end": "" },
    { "start": "2025-01-08T18:30:00.000Z", "end": "2025-01-08T18:30:00.000Z" },
    { "start": "", "end": "" }, { "start": "", "end": "" }]
  }

  viewPageAssignToday() {

    this.commonService.clearStorage();
    this.selectedLeadStat = 'assigned';
    localStorage.setItem('selectedLeadStat', 'assigned');
    const formattedDate = this.todayDate.toISOString().split('T')[0];
    this.search = `createdDate:*${formattedDate}~${formattedDate}* OR transferDate:*${formattedDate}~${formattedDate}*`;

    this.leadRange2.ranges[6].start = this.formatDate(formattedDate)
    this.leadRange2.ranges[6].end = this.formatDate(formattedDate)

    let url = '/lead'

    let cleanUrl = url; url

    localStorage.removeItem(cleanUrl);
    localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObj2));
    localStorage.setItem(cleanUrl + "se", this.search);
    localStorage.setItem(cleanUrl + "type", "2");

    localStorage.setItem(cleanUrl + "range", JSON.stringify(this.leadRange2));

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/lead']);
    });
  }

  getStatusColor(status: string): string {
    const statusColorMap: { [key: string]: string } = {
      'Followup': '#4d52ff',
      'Not Interested': '#ff6e1a',
      'Demo Arranged': '#c546ec',
      'New': '#2e9e9c',
      'Pending': '#ff3370',
      'Not Connecting': '#008ae6',
      'Call Back Later': '#c546ec',
      'Call Not Answered': '#43b5ff',
      'Other Language': '#787cff',
      'interested': '#0000ff',
      'Warm': '#09B895',
      'Hot': '#e74c3c',
    };
    return statusColorMap[status] || '#8c8c8c'; // Default color if status is not found
  }

  // Define a list of colors
  colorPalette: string[] = ['#ff779f', '#39c5c2', '#787cff', '#43b5ff', '#ff9254', '#e74c3c']; // Example: Red, Green, Blue, Magenta, Cyan

  getAvatarColor(index: number): string {
    const paletteSize = this.colorPalette.length;
    return this.colorPalette[index % paletteSize]; // Cycle through the colors
  }

  toggleSection(i) {
    this.productList[i].open = !this.productList[i].open;
  }

  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  isDateColumn(col: any): boolean {
    if (!col) return false;
    const prop = (col.property || '').toString().toLowerCase();
    const name = (col.name || '').toString().toLowerCase().trim();
    const frontEndType = (col.frontEndType || '').toString().toLowerCase();
    const frontendInput = (col.frontendInput || '').toString().toLowerCase();
    const inputType = (col.inputType || '').toString().toLowerCase();
    const type = (col.type || '').toString().toLowerCase();
    const backendType = (col.backendType || '').toString().toLowerCase();
    const attributeCode = (col.attributeCode || '').toString().toLowerCase();
    const propertyName = (col.propertyName || '').toString().toLowerCase();

    if (
      name === 'date data' ||
      name.includes('date') ||
      prop.includes('date') ||
      attributeCode.includes('date') ||
      propertyName.includes('date') ||
      frontEndType === 'date' ||
      frontEndType === 'datetime' ||
      frontEndType === 'datepicker' ||
      frontEndType === 'datetimepicker' ||
      frontendInput === 'date' ||
      frontendInput === 'datetime' ||
      frontendInput === 'datepicker' ||
      frontendInput === 'datetimepicker' ||
      inputType === 'date' ||
      inputType === 'datetime' ||
      inputType === 'datepicker' ||
      inputType === 'datetimepicker' ||
      type === 'date' ||
      type === 'datetime' ||
      backendType === 'date' ||
      backendType === 'datetime' ||
      backendType === 'timestamp' ||
      prop === 'createddate' ||
      prop === 'updateddate' ||
      prop === 'firstresponsetime'
    ) {
      return true;
    }

    if (this.filterSelectObj && this.filterSelectObj.length) {
      let targetProp = prop;
      if (col.propertyName) {
        targetProp = (col.propertyName + '_cust').toLowerCase();
      }
      const fieldMeta = this.filterSelectObj.find((f: any) => {
        const fProp = (f.property || '').toString().toLowerCase();
        return fProp === targetProp || fProp === prop || (col.propertyName && fProp === col.propertyName.toLowerCase());
      });
      if (fieldMeta) {
        const metaType = (fieldMeta.type || '').toString().toLowerCase();
        if (
          metaType === 'date' ||
          metaType === 'datetime' ||
          metaType === 'datepicker' ||
          metaType === 'datetimepicker'
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isCategoryColumn(col: any): boolean {
    if (!col) return false;
    const prop = (col.property || '').toString().toLowerCase();
    const name = (col.name || '').toString().toLowerCase().trim();
    const attributeCode = (col.attributeCode || '').toString().toLowerCase();
    const propertyName = (col.propertyName || '').toString().toLowerCase();

    return (
      prop === 'category' || prop === 'categoryname' || prop === 'categorynames' || prop === 'categories' ||
      prop === 'category_cust' || prop.includes('category') ||
      name === 'category' || name === 'category name' || name === 'categories' || name.includes('category') ||
      attributeCode === 'category' || attributeCode === 'categoryname' || attributeCode.includes('category') ||
      propertyName === 'category' || propertyName === 'categoryname' || propertyName.includes('category')
    );
  }

  isProductColumn(col: any): boolean {
    if (!col) return false;
    if (this.isCategoryColumn(col)) return false;
    const prop = (col.property || '').toString().toLowerCase();
    const name = (col.name || '').toString().toLowerCase().trim();
    const attributeCode = (col.attributeCode || '').toString().toLowerCase();
    const propertyName = (col.propertyName || '').toString().toLowerCase();

    return (
      prop === 'product' || prop === 'productname' || prop === 'productnames' || prop === 'products' ||
      prop === 'product_cust' || prop.includes('product') ||
      name === 'product' || name === 'product name' || name === 'products' || name.includes('product') ||
      attributeCode === 'product' || attributeCode === 'productname' || attributeCode.includes('product') ||
      propertyName === 'product' || propertyName === 'productname' || propertyName.includes('product')
    );
  }

  isProductOrCategoryColumn(col: any): boolean {
    if (!col) return false;
    return this.isCategoryColumn(col) || this.isProductColumn(col);
  }

  startEdit(rowId: any, colProperty: string, element: any, col: any) {

    if (this.isDateColumn(col) || this.isProductOrCategoryColumn(col) || colProperty === 'activityCountOnLead' || colProperty === 'activityCount') {
      return;
    }

    if (colProperty === 'tagName' || colProperty === 'Tags' || (col && (col.property === 'Tags' || col.attributeCode === 'Tags'))) {
      this.opentagName(element);
      return;
    }

    if (colProperty === 'phoneNumber' || colProperty === 'secondaryphoneno' || (col && col.property === 'phoneNumber')) {
      this.openEditPhoneDialog(element);
      return;
    }

    if (
      colProperty === 'ownerEmail' ||
      colProperty === 'ownerIdName' ||
      colProperty === 'ownerId' ||
      colProperty === 'ownerName' ||
      colProperty === 'owner' ||
      (col && (col.property === 'ownerEmail' || col.property === 'ownerIdName' || col.property === 'owner' || col.attributeCode === 'OwnerFirstName'))
    ) {
      this.openOwnerEdit(element);
      return;
    }

    if (this.isPropertyColumn(colProperty, col)) {
      this.openPropertyName(element, col);
      return;
    }

    if (col.property.includes("customValuesIs")) {

      this.customValue = true;

    } else {
      this.customValue = false;
    }

    // Discard any previous unsaved edit before starting a new one
    if (this.editingCell && this.editingElement) {
      const prevKey = this.editingCell.colProperty;
      // Use `in` so null/'' originals are also restored (not just non-undefined)
      if (prevKey in this.previousValues) {
        this.editingElement[prevKey] = this.previousValues[prevKey];
      }
      if (prevKey === 'statusName') {
        if ('LeadStatus' in this.previousValues) {
          this.editingElement['LeadStatus'] = this.previousValues['LeadStatus'];
        }
        if ('leadStatusColour' in this.previousValues) {
          this.editingElement['leadStatusColour'] = this.previousValues['leadStatusColour'];
        }
        if ('darkTextColor' in this.previousValues) {
          this.editingElement['darkTextColor'] = this.previousValues['darkTextColor'];
        }
      }
      this.editingCell = null;
      this.editingElement = null;
      this.editingCol = null;
    }

    this.backupValue(colProperty, element);
    if (colProperty === 'statusName') {
      this.backupValue('LeadStatus', element);
      this.backupValue('leadStatusColour', element);
      this.backupValue('darkTextColor', element);
    }

    this.lastValue = element[colProperty];


    if (window.innerWidth > 768) {

      let fieldMeta = null;
      if (this.customValue) {

        let property = col.propertyName + "_cust";

        fieldMeta = this.filterSelectObj.find(f => f.property === property);
        if (!fieldMeta) {
          fieldMeta = this.filterSelectObj.find((f: any) => {
            const fProp = (f.property || '').toString().toLowerCase();
            return fProp === property.toLowerCase() || (col.propertyName && fProp === col.propertyName.toLowerCase()) || (col.property && fProp === col.property.toLowerCase());
          });
        }

      } else {
        fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);
        if (!fieldMeta) {
          fieldMeta = this.filterSelectObj.find((f: any) => {
            const fProp = (f.property || '').toString().toLowerCase();
            return fProp === colProperty.toLowerCase() || (col.propertyName && fProp === col.propertyName.toLowerCase());
          });
        }
      }


      if (typeof col.optionValues === 'string' && (col.optionValues as string).trim().length > 0) {
        try {
          col.optionValues = JSON.parse(col.optionValues as string);
        } catch (e) { }
      }

      const hasValidColOptionValues = Array.isArray(col.optionValues) && col.optionValues.length > 0;

      if (hasValidColOptionValues) {
        col.inputType = fieldMeta?.type || col.inputType || col.frontEndType || 'text';
        col.options = col.optionValues;
      } else if (fieldMeta) {
        col.inputType = fieldMeta.type || col.inputType || 'text';
        col.options = fieldMeta.options || col.options || [];
        col.optionValues = (fieldMeta.options && fieldMeta.options.length) ? fieldMeta.options : (col.optionValues || col.options || []);
      } else {
        col.inputType = col.inputType || col.frontEndType || 'text';
        col.options = col.options || [];
        col.optionValues = col.optionValues || col.options || [];
      }

      if (colProperty === 'statusName' || (col && col.property === 'statusName') || colProperty === 'LeadStatus') {
        if (!this.filteredleadStatusTypeList || this.filteredleadStatusTypeList.length === 0) {
          this.getLeadStatusList();
        }
        col.inputType = 'select';
        col.options = this.filteredleadStatusTypeList || this.leadStatusTypeList || [];
        col.optionValues = this.filteredleadStatusTypeList || this.leadStatusTypeList || [];
      }

      if (colProperty === 'sourceName' || colProperty === 'LeadSource' || colProperty === 'source' || colProperty === 'LeadSource_cust' || colProperty === 'customValuesIsLeadSource' || (col && (col.property === 'sourceName' || col.property === 'LeadSource' || col.property === 'source' || col.property === 'LeadSource_cust' || col.property === 'customValuesIsLeadSource' || col.attributeCode === 'LeadSource'))) {
        if (!this.filteredLeadSourceTypeList || this.filteredLeadSourceTypeList.length === 0) {
          this.getLeadSourceDownList();
        }
        col.inputType = 'select';
        col.options = this.filteredLeadSourceTypeList || this.LeadSourceTypeList || [];
        col.optionValues = this.filteredLeadSourceTypeList || this.LeadSourceTypeList || [];
      }

      if (colProperty === 'Country' || colProperty === 'country' || colProperty === 'Country_cust' || colProperty === 'customValuesIsCountry' || (col && (col.property === 'Country' || col.property === 'country' || col.property === 'Country_cust'))) {
        if (!this.countryTypeList || this.countryTypeList.length === 0) {
          this.getAllCountry();
        }
        col.inputType = 'select';
        col.options = this.filteredcountryTypeList || this.countryTypeList || [];
        col.optionValues = this.filteredcountryTypeList || this.countryTypeList || [];
      }

      const isMultiSelect = (
        colProperty !== 'sourceName' &&
        colProperty !== 'LeadSource' &&
        colProperty !== 'source' &&
        (!col || (col.property !== 'sourceName' && col.property !== 'LeadSource' && col.property !== 'source' && col.attributeCode !== 'LeadSource')) &&
        colProperty !== 'statusName' &&
        (!col || col.property !== 'statusName') &&
        colProperty !== 'LeadStatus' &&
        (
          col.inputType === 'multiSelect' ||
          col.inputType === 'multiselect' ||
          col.frontEndType === 'multiSelect' ||
          col.frontEndType === 'multiselect' ||
          (fieldMeta && (fieldMeta.type === 'multiSelect' || fieldMeta.type === 'multiselect'))
        )
      );

      const isSelect = !isMultiSelect && (
        colProperty !== 'sourceName' &&
        colProperty !== 'LeadSource' &&
        colProperty !== 'source' &&
        (!col || (col.property !== 'sourceName' && col.property !== 'LeadSource' && col.property !== 'source' && col.attributeCode !== 'LeadSource')) &&
        colProperty !== 'statusName' &&
        (!col || col.property !== 'statusName') &&
        colProperty !== 'LeadStatus' &&
        (
          col.inputType === 'select' ||
          col.frontEndType === 'select' ||
          (fieldMeta && fieldMeta.type === 'select')
        )
      );

      if (isMultiSelect) {
        col.inputType = 'multiSelect';
        let rawVal = element[colProperty];
        if (rawVal === undefined || rawVal === null || rawVal === '') {
          if (element.isCustomizedValue && col && col.propertyName && element.isCustomizedValue[col.propertyName] !== undefined && element.isCustomizedValue[col.propertyName] !== null) {
            rawVal = element.isCustomizedValue[col.propertyName];
          } else if (element.isCustomizedValue && element.isCustomizedValue[colProperty] !== undefined && element.isCustomizedValue[colProperty] !== null) {
            rawVal = element.isCustomizedValue[colProperty];
          }
        }
        let items: any[] = [];
        if (Array.isArray(rawVal)) {
          items = [...rawVal];
        } else if (typeof rawVal === 'string' && rawVal.trim().length > 0) {
          if (rawVal.startsWith('[') && rawVal.endsWith(']')) {
            try {
              items = JSON.parse(rawVal);
            } catch (e) {
              items = rawVal.split(',').map((s: string) => s.trim()).filter(Boolean);
            }
          } else {
            items = rawVal.split(',').map((s: string) => s.trim()).filter(Boolean);
          }
        } else {
          items = [];
        }

        if (Array.isArray(col.optionValues) && col.optionValues.length > 0) {
          element[colProperty] = items.map((item: any) => {
            const foundOpt = col.optionValues.find((opt: any) => opt.value == item || opt.viewValue == item);
            return foundOpt ? foundOpt.value : item;
          });
        } else {
          element[colProperty] = items;
        }
      } else if (isSelect) {
        let rawVal = element[colProperty];
        if (rawVal === undefined || rawVal === null || rawVal === '') {
          if (element.isCustomizedValue && col && col.propertyName && element.isCustomizedValue[col.propertyName] !== undefined && element.isCustomizedValue[col.propertyName] !== null) {
            rawVal = element.isCustomizedValue[col.propertyName];
          } else if (element.isCustomizedValue && element.isCustomizedValue[colProperty] !== undefined && element.isCustomizedValue[colProperty] !== null) {
            rawVal = element.isCustomizedValue[colProperty];
          }
        }
        if (rawVal !== undefined && rawVal !== null && rawVal !== '' && Array.isArray(col.optionValues) && col.optionValues.length > 0) {
          const foundOpt = col.optionValues.find((opt: any) => opt.value == rawVal || opt.viewValue == rawVal);
          if (foundOpt) {
            element[colProperty] = foundOpt.value;
          } else {
            element[colProperty] = rawVal;
          }
        }
      }

      // Normalize textarea inputType variants
      const isTextArea = (
        col.inputType === 'textarea' ||
        col.inputType === 'textArea' ||
        col.inputType === 'text_area' ||
        col.frontEndType === 'textarea' ||
        col.frontEndType === 'textArea' ||
        col.frontEndType === 'text_area' ||
        (fieldMeta && (
          fieldMeta.type === 'textarea' ||
          fieldMeta.type === 'textArea' ||
          fieldMeta.type === 'text_area'
        ))
      );

      if (isTextArea) {
        col.inputType = 'text';  // Use standard input for TEXT AREA columns
        // Load value from isCustomizedValue if element property is empty
        if ((element[colProperty] === undefined || element[colProperty] === null || element[colProperty] === '') &&
          element.isCustomizedValue) {
          const cv = element.isCustomizedValue[col.propertyName] ?? element.isCustomizedValue[colProperty];
          if (cv !== undefined && cv !== null) {
            element[colProperty] = cv;
          }
        }
      }

      this.editingCell = { rowId, colProperty };
      this.editingElement = element;
      this.editingCol = col;
    } else {

      const fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);

      let value = element[colProperty];
      let property = colProperty;
      if (colProperty == 'statusName') {

        value = element['statusId'];


      }
      if (colProperty == 'sourceName') {

        value = element['sourceId'];


      }
      let dialogRef = this.dialog.open(PopupEditComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: {
          element: element,
          key: property,
          previousValue: value,
          inputType: fieldMeta?.type || col.inputType || 'text',
          options: (fieldMeta?.options && fieldMeta.options.length) ? fieldMeta.options : (col.optionValues || col.options || [])
        },

      });


      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {

          console.log(result['event']);

          let value = result['data']

          if (element[colProperty] != value) {

            element[colProperty] = value;
            this.saveEdit(rowId, colProperty, value, element, col)
          } else {
            this.closeEdit(rowId, colProperty, value, element)
          }


        } else {

          element[colProperty] = this.lastValue;
          this.closeEdit(rowId, colProperty, 'value', element)
        }

      });


    }

  }

  stopEdit() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;

  }

  closeEdit(leadId, key, value, element) {

    // Restore original value — use `in` so null/'' originals are also restored
    if (key in this.previousValues) {
      element[key] = this.previousValues[key];
    }
    if (key === 'statusName') {
      if ('LeadStatus' in this.previousValues) {
        element['LeadStatus'] = this.previousValues['LeadStatus'];
      }
      if ('leadStatusColour' in this.previousValues) {
        element['leadStatusColour'] = this.previousValues['leadStatusColour'];
      }
      if ('darkTextColor' in this.previousValues) {
        element['darkTextColor'] = this.previousValues['darkTextColor'];
      }
    }

    this.stopEdit();
  }

  clearValue() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
    this.advanceFilterEnble = false;
    this.smartViewConditionsEnble = false;
    this.notifyKanbanUpdate();
  }

  saveEdit(leadId: any, key: string, value: any, element: any, col: any) {

    const isEmailField = key === 'email' || key === 'Email' || key.toLowerCase().includes('email') || (col && (col.attributeCode === 'Email' || col.attributeCode === 'email'));
    if (isEmailField && value != null && value !== '') {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailPattern.test(String(value).trim())) {
        this.snackBar.open("Please enter a valid email address.", '×', {
          panelClass: ['error'],
          verticalPosition: 'bottom',
          duration: 3000
        });
        this.editingCell = { rowId: leadId, colProperty: key };
        return;
      }
    }

    let customValue = false;
    if (key.includes("customValuesIs")) {

      customValue = true;

    } else {
      customValue = false;
    }
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    this.selectionLead = [];
    this.selection.clear();

    let object: any = {
      entityId: leadId,
    };

    let match: any = null;

    if (key.toLowerCase() === 'company') {


      match = this.companyList?.find(c => c.name === element.company);

      if (match) {
        object['Company'] = match.name;
        object['CompanyId'] = match.entityId;
      }
      else {

        object['Company'] = element['Company'];
        object['CompanyId'] = element['CompanyId'];


        //    this.snackBar.open("No company match found", '×', {
        //   panelClass: 'warning',
        //   verticalPosition: 'bottom',
        //   duration: 1000
        // });

      }
    }

    else if (key === 'statusName' || key === 'LeadStatus') {
      const statusOptions = this.filteredleadStatusTypeList || this.leadStatusTypeList || this.leadStatusList || [];
      const found = statusOptions.find((opt: any) => opt.statusName === value || opt.statusName === element.statusName || opt.statusId === value || opt.statusId === element.LeadStatus);
      if (found) {
        element['LeadStatus'] = found.statusId;
        element['statusName'] = found.statusName;
        if (found.leadStatusColour || found.color) {
          element['leadStatusColour'] = found.leadStatusColour || found.color;
          element['darkTextColor'] = this.getDarkerTextColor(element['leadStatusColour'], 40);
        }
      }
      object['LeadStatus'] = element['LeadStatus'];
    }
    else if (key === 'sourceName') {
      object['LeadSource'] = element['LeadSource'];
    }
    else if (key === 'ownerEmail') {
      object['Owner'] = value;
      object['OwnerName'] = element['OwnerName'];
      object['OwnerId'] = element['OwnerId'];
    } else if (key === 'Country' || key === 'country' || key === 'Country_cust') {
      object['Country'] = value;
      element['Country'] = value;
      element['country'] = value;
      element['Country_cust'] = value;
    } else if (customValue) {
      if (Array.isArray(value)) {
        if (col && col.optionValues && Array.isArray(col.optionValues) && col.optionValues.length) {
          const mappedValues = value.map((v: any) => {
            const opt = col.optionValues.find((o: any) => o.value == v || o.viewValue == v);
            return opt ? opt.value : v;
          });
          object[col['attributeCode']] = mappedValues.join(',');
        } else {
          object[col['attributeCode']] = value.join(',');
        }
      } else {
        if (col && col.optionValues && Array.isArray(col.optionValues) && col.optionValues.length) {
          const opt = col.optionValues.find((o: any) => o.value == value || o.viewValue == value);
          object[col['attributeCode']] = opt ? opt.value : value;
        } else {
          object[col['attributeCode']] = value;
        }
      }
    }
    else {
      if (Array.isArray(value)) {
        object[key] = value.join(',');
      } else {
        object[key] = value;
      }
      if (key === 'phoneNumber' && element.secondaryphoneno !== undefined) {
        object['secondaryphoneno'] = element.secondaryphoneno;
        object['customField10'] = element.secondaryphoneno;
      }
    }

    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;

    if (Array.isArray(value)) {
      let displayString = value.join(', ');
      if (col && col.optionValues && Array.isArray(col.optionValues) && col.optionValues.length) {
        const displayList = value.map((v: any) => {
          const opt = col.optionValues.find((o: any) => o.value == v || o.viewValue == v);
          return opt ? (opt.viewValue !== undefined ? opt.viewValue : opt.value) : v;
        });
        displayString = displayList.join(', ');
      }
      element[key] = displayString;
      if (element.isCustomizedValue && col && col.propertyName) {
        element.isCustomizedValue[col.propertyName] = displayString;
      }
    } else if (col && col.optionValues && Array.isArray(col.optionValues) && col.optionValues.length) {
      let selectedOpt = col.optionValues.find((opt: any) => opt.value == value || opt.viewValue == value);
      if (selectedOpt) {
        const displayVal = selectedOpt.viewValue !== undefined ? selectedOpt.viewValue : selectedOpt.value;
        element[key] = displayVal;
        if (element.isCustomizedValue && col && col.propertyName) {
          element.isCustomizedValue[col.propertyName] = displayVal;
        }
      }
    }

    if (key === 'email' || key === 'phoneNumber') {
      let payload = {
        Email: key === 'email' ? value : (element.Email || element.email || ''),
        PhoneNumber: key === 'phoneNumber' ? value : (element.PhoneNumber || element.phoneNumber || ''),
        entityId: leadId
      };



      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.doSave(object, leadId);
          } else {
            this.snackBar.open(response['data']['message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500
            });
            this.DetectingRequestType();
          }
        },
        () => {
          this.snackBar.open("Error validating lead", '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
          this.DetectingRequestType();
        }
      );
    }
    else {
      this.doSave(object, leadId);
    }
  }


  doSave(object: any, leadId: any) {
    this.leadService.editLead(object, leadId).subscribe(
      (response) => {
        this.loaderService.hide();
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.DetectingRequestType();
          this.editingCell = null;
          this.editingElement = null;
          this.editingCol = null;
          this.selectionLead = [];
          this.selection.clear();

          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 500
          });
        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
        }
      },
      () => {
        this.loaderService.hide();
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 500
        });
      }
    );
  }

  openBusinessEditDialog(): void {
    if (this.dialog.openDialogs.length > 0) {
      return; // Don't open again
    }
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        width: '800px',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });
    } else {

      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        minWidth: '100vw', height: '100vh',
        panelClass: '',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();

        }
      });

    }

  }



  getValueByPath(obj: any, path: string) {
    if (!path) return undefined;
    const parts = path.split('.');
    return parts.reduce((acc, p) => acc?.[p], obj);
  }

  // Utility: set nested value by path (creates intermediate objects if needed)
  setValueByPath(obj: any, path: string, value: any) {
    if (!path) return;
    const parts = path.split('.');
    let curr = obj;
    for (let i = 0; i < parts.length - 1; i++) {
      const k = parts[i];
      if (!curr[k]) curr[k] = {};
      curr = curr[k];
    }
    curr[parts[parts.length - 1]] = value;
  }

  // helper used by template to show current value
  getFieldValue(element: any, col: any) {
    const path = col.valuePath || col.property;
    const val = this.getValueByPath(element, path);
    // fallback: for display formats you can add more handling here (dates, numbers)
    return val ?? '--';
  }


  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    // console.log(val);

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        () => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        () => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  refresh() {

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se");
    localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "selected");
    localStorage.removeItem(cleanUrl + "selectedDate");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
    localStorage.removeItem('smartViewConditionsEnble');
    localStorage.removeItem("activeTab");
    this.advanceFilterEnble = false;
    this.smartViewConditionsEnble = false;
    this.activeTab = 'all';
    this.loaderService.show();
    this.onFilterChangeColumn(undefined, 1)
    this.selection.clear();
    this.selectionLead = [];
    this.clearValue();
    this.getProduct();
  }

  goToPopUp() {
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmSearchComponent, {
        width: '80%',
        maxWidth: '1200px',
        height: '100%',
        data: {

        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
    } else {
      const dialogRef = this.dialog.open(CrmSearchComponent, {
        minWidth: '100vw', height: '100vh',
        data: {

        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
    }
  }




  openEmailPopup(element: any) {
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        width: '80%',
        height: '100%',
        data: {
          email: element.email,
          name: element.name,
          leadId: element.entityId,
          type: 1
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
    } else {

      const dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          email: element.email,
          name: element.name,
          leadId: element.entityId,
          type: 1
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });

    }
  }





  createNote(note: any, noteId: any, leadId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!"
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          // this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!"
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

        }

      });
    }
  }

  //lead status

  leadStatusList: any;
  leadStatusTypeList: any;
  filteredleadStatusTypeList: any;

  public leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.leadStatusList = res;
        this.leadStatusTypeList = res;
        this.filteredleadStatusTypeList = this.leadStatusTypeList;
      },
      () => {
      }
    )
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  //country

  filteredcountryTypeList: any;
  countryTypeList: any;

  countryFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllCountry() {
    this.commonService.getCountryList()
      .pipe(take(1))
      .subscribe(
        res => {
          this.countryTypeList = res;
          this.filteredcountryTypeList = this.countryTypeList;
          if (this.editingCol && (this.editingCol.property === 'Country' || this.editingCol.property === 'country' || this.editingCol.property === 'customValuesIsCountry' || this.editingCol.property === 'Country_cust')) {
            this.editingCol.options = this.filteredcountryTypeList;
            this.editingCol.optionValues = this.filteredcountryTypeList;
          }
          if (this.filterSelectObj && Array.isArray(this.filterSelectObj)) {
            this.filterSelectObj.forEach((f: any) => {
              if (f && (f.property === 'Country' || f.property === 'country' || f.property === 'Country_cust' || f.property === 'customValuesIsCountry' || f.name === 'Country')) {
                f.type = 'select';
                f.options = this.filteredcountryTypeList;
                f._originalOptions = this.filteredcountryTypeList;
                f._filteredOptions = this.filteredcountryTypeList;
              }
            });
          }
          try { this.cdr.detectChanges(); } catch (_) { }
        },
        error => {
        }
      )
  }
  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }

  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }

    // get the search keyword
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }


  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags(callback?: Function) {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data || [];
        this.tagsTypeList = data || [];
        this.filteredtagsTypeList = this.tagsTypeList ? this.tagsTypeList.slice() : [];
        if (callback) {
          callback();
        }
      },
      () => {
        if (callback) {
          callback();
        }
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    const currentSelected = Array.isArray(this.tagNames.value)
      ? this.tagNames.value
      : (this.tagNames.value ? [this.tagNames.value] : []);

    // filter the tags while keeping currently selected tags visible
    this.filteredtagsTypeList = this.tagsTypeList.filter(tags => {
      const matchesSearch = tags['statusName'] && tags['statusName'].toLowerCase().indexOf(search) > -1;
      const isSelected = currentSelected.some(sel =>
        sel === tags.statusName ||
        sel == tags.statusId ||
        (tags.statusName && String(sel).toLowerCase() === tags.statusName.toLowerCase())
      );
      return matchesSearch || isSelected;
    });
  }

  setTagName(event, tag, entityId, element) {

    if (event.isUserInput != false) {

      let object = {

        "entityId": entityId,
        "TagId": tag.statusId,
        "tagName": tag.statusName,
        "tagIds": String(tag.statusId),
        "tagNames": tag.statusName,
        "Tags": tag.statusId
      }

      element.tagNameColour = tag.statusColor;
      element.tagName = tag.statusName;
      element.tagNames = tag.statusName;
      element.tagIds = tag.statusId;

      this.leadService.editLead(object, entityId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          } else {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => {
        });

    }
  }

  @ViewChild('tagName') tagName: TemplateRef<any>;
  @ViewChild('propertyNameModal') propertyNameModal: TemplateRef<any>;
  @ViewChild('editPhoneModal') editPhoneModal: TemplateRef<any>;

  editPrimaryPhone: string = '';
  editSecondaryPhone: string = '';
  isSavingPhone: boolean = false;

  openOwnerEdit(element: any) {
    const leadId = element?.entityId || element?.leadId || element?.id;
    const ownerId = element?.ownerId || element?.OwnerId || element?.user_id || '';

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": leadId,
          "ownerId": ownerId,
          "typeData": 1,
          "randomAssign": 0
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] === 'add') {
          this.DetectingRequestType();
        }
      });
    } else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          "leadId": leadId,
          "ownerId": ownerId,
          "typeData": 1,
          "randomAssign": 0
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] === 'add') {
          this.DetectingRequestType();
        }
      });
    }
  }

  openEditPhoneDialog(element: any) {
    this.isSavingPhone = false;
    this.editingElement = element;

    let primary = element.phoneNumber || element.PhoneNumber || '';
    if (typeof primary === 'object' && primary !== null) {
      primary = primary.value || '';
    }
    this.editPrimaryPhone = (typeof primary === 'string' || typeof primary === 'number') ? String(primary) : '';

    let secondary = element.secondaryphoneno;
    if (typeof secondary === 'object' && secondary !== null) {
      secondary = secondary.value || '';
    }
    this.editSecondaryPhone = (typeof secondary === 'string' || typeof secondary === 'number') ? String(secondary) : '';

    this.dialog.open(this.editPhoneModal, {
      width: '450px',
      disableClose: true
    });
  }

  savePhoneDialog() {
    if (!this.editingElement) return;

    const leadId = this.editingElement.entityId;
    const primaryPhone = this.editPrimaryPhone ? this.editPrimaryPhone.toString().trim() : '';
    const secondaryPhone = this.editSecondaryPhone ? this.editSecondaryPhone.toString().trim() : '';

    let currentPrimary: any = this.editingElement.phoneNumber || this.editingElement.PhoneNumber || '';
    if (typeof currentPrimary === 'object' && currentPrimary !== null) {
      currentPrimary = currentPrimary.value || '';
    }
    currentPrimary = (currentPrimary || '').toString().trim();

    let currentSecondary: any = this.editingElement.secondaryphoneno;
    if (typeof currentSecondary === 'object' && currentSecondary !== null) {
      currentSecondary = currentSecondary.value || '';
    }
    currentSecondary = (currentSecondary || '').toString().trim();

    if (primaryPhone === currentPrimary && secondaryPhone === currentSecondary) {
      this.dialog.closeAll();
      return;
    }

    if (primaryPhone && primaryPhone !== currentPrimary) {
      const isDuplicate = this.dataSource?.data?.some((item: any) =>
        (item.entityId !== leadId && item.id !== leadId) &&
        ((item.phoneNumber && typeof item.phoneNumber !== 'object' && item.phoneNumber.toString().trim() === primaryPhone) ||
          (item.PhoneNumber && typeof item.PhoneNumber !== 'object' && item.PhoneNumber.toString().trim() === primaryPhone))
      );

      if (isDuplicate) {
        this.snackBar.open('Phone number already exists', '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 1500
        });
        return;
      }
    }

    this.isSavingPhone = true;

    let updateObject: any = {
      "entityId": leadId,
      "phoneNumber": primaryPhone,
      "PhoneNumber": primaryPhone,
      "secondaryphoneno": secondaryPhone
    };
    if (typeof this.editingElement.customField10 !== 'object') {
      updateObject['customField10'] = secondaryPhone;
    }

    this.leadService.editLead(updateObject, leadId).subscribe(
      (response) => {
        this.isSavingPhone = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.editingElement.phoneNumber = primaryPhone;
          this.editingElement.PhoneNumber = primaryPhone;
          this.editingElement.secondaryphoneno = secondaryPhone;
          if (typeof this.editingElement.customField10 !== 'object') {
            this.editingElement.customField10 = secondaryPhone;
          }
          this.snackBar.open(response['status_message'] || 'Phone numbers updated successfully', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 1500
          });
          this.dialog.closeAll();
          this.getProduct();
        } else {
          this.snackBar.open(response['status_message'] || response?.['data']?.['message'] || 'Failed to update phone numbers', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 1500
          });
        }
      },
      (err) => {
        this.isSavingPhone = false;
        let errorMessage = 'Error updating phone numbers';
        if (err?.error?.status_message) {
          errorMessage = err.error.status_message;
        } else if (err?.error?.message) {
          errorMessage = err.error.message;
        }
        this.snackBar.open(errorMessage, '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 1500
        });
      }
    );
  }

  tagNames: UntypedFormControl = new UntypedFormControl([], [Validators.required]);

  propertyCtrl: UntypedFormControl = new UntypedFormControl('');
  selectedProperties: any[] = [];
  propertyList: any[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('propertyInput') propertyInput: ElementRef<HTMLInputElement>;

  opentagName(element: any) {
    this.editingElement = element;
    this.tagsFilterControl.setValue('');

    const patchTag = () => {
      let rawTag = element?.tagName || element?.tagNames || element?.Tags || element?.TagId || element?.tagIds || '';
      let tagArray: string[] = [];

      if (Array.isArray(rawTag)) {
        tagArray = rawTag.map(t => String(t).trim()).filter(t => !!t);
      } else if (typeof rawTag === 'string' && rawTag.trim().length > 0) {
        tagArray = rawTag.split(',').map(t => t.trim()).filter(t => !!t);
      } else if (rawTag != null && rawTag !== '') {
        tagArray = [String(rawTag).trim()];
      }

      let selectedValues: string[] = [];
      tagArray.forEach(item => {
        let matchedTag = (this.tagsList || []).find(t =>
          (t.statusName && (t.statusName === item || t.statusName.toLowerCase() === item.toLowerCase())) ||
          (t.statusId != null && String(t.statusId) === item)
        );
        let targetValue = matchedTag ? matchedTag.statusName : item;
        if (targetValue && !selectedValues.includes(targetValue)) {
          selectedValues.push(targetValue);
        }
      });

      this.tagNames.patchValue(selectedValues);
    };

    if (!this.tagsTypeList || this.tagsTypeList.length === 0) {
      this.getAllTags(() => {
        patchTag();
      });
    } else {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      patchTag();
    }

    let dialogRef = this.dialog.open(this.tagName, {
      width: '600px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getLead();
    });
  }

  tagNameUpdate() {
    if (!this.editingElement) return;

    let val = this.tagNames.value;
    let selectedTagNames: string[] = [];
    let selectedTagIds: (string | number)[] = [];
    let selectedColors: string[] = [];

    if (Array.isArray(val)) {
      val.forEach(v => {
        let tagObj = (this.tagsList || []).find(t => t.statusName === v || t.statusId == v);
        if (tagObj) {
          if (!selectedTagNames.includes(tagObj.statusName)) {
            selectedTagNames.push(tagObj.statusName);
          }
          if (!selectedTagIds.includes(tagObj.statusId)) {
            selectedTagIds.push(tagObj.statusId);
          }
          if (tagObj.statusColor && !selectedColors.includes(tagObj.statusColor)) {
            selectedColors.push(tagObj.statusColor);
          }
        } else if (v) {
          if (!selectedTagNames.includes(v)) {
            selectedTagNames.push(v);
          }
        }
      });
    } else if (typeof val === 'string' && val) {
      let tagObj = (this.tagsList || []).find(t => t.statusName === val || t.statusId == val);
      if (tagObj) {
        selectedTagNames.push(tagObj.statusName);
        selectedTagIds.push(tagObj.statusId);
        if (tagObj.statusColor) selectedColors.push(tagObj.statusColor);
      } else {
        selectedTagNames.push(val);
      }
    }

    let joinedNames = selectedTagNames.join(', ');
    let joinedIds = selectedTagIds.join(',');

    let updateObject = {
      "entityId": this.editingElement.entityId,
      "TagId": joinedIds || null,
      "tagName": joinedNames,
      "tagNames": joinedNames,
      "tagIds": joinedIds,
      "tagNameColour": selectedColors.length > 0 ? selectedColors[0] : '',
      "Tags": joinedIds || null
    };

    this.leadService.editLead(updateObject, this.editingElement.entityId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.editingElement.tagName = joinedNames;
          this.editingElement.tagNames = joinedNames;
          this.editingElement.tagIds = joinedIds;
          this.editingElement.TagId = joinedIds || null;
          this.editingElement.Tags = joinedIds || null;
          if (selectedColors.length > 0) {
            this.editingElement.tagNameColour = selectedColors[0];
          }
          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });
          this.dialog.closeAll();
          this.getLead();
        } else {
          this.snackBar.open(response['status_message'] || 'Update failed', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      () => {
      }
    );
  }

  masterProductList: any[] = [];

  loadMasterProducts() {
    if (this.masterProductList && this.masterProductList.length > 0) return;
    if (this.productService) {
      this.productService.getProductByType(0, 1000, 'id,desc', '').subscribe(
        (res: any) => {
          this.masterProductList = res['content'] || res || [];
          if (this.cdr) {
            this.cdr.markForCheck();
          }
        },
        () => { }
      );
    }
  }

  resolveProductNameValue(rawVal: string, element?: any): string {
    if (!rawVal || rawVal === '--') return rawVal;

    const valStr = String(rawVal).trim().toLowerCase();

    if (this.masterProductList && this.masterProductList.length > 0) {
      const matchProd = this.masterProductList.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '').toLowerCase() === valStr ||
        String(p.name ?? p.productName ?? '').trim().toLowerCase() === valStr
      );
      if (matchProd) {
        return matchProd.name ?? matchProd.productName ?? rawVal;
      }
    }

    if (element) {
      const elProd = element.product ?? element.Product ?? element.productName ?? element.ProductName;
      if (elProd && isNaN(Number(elProd)) && String(elProd).trim().length > 0) {
        return String(elProd);
      }
    }

    return rawVal;
  }

  isPropertyColumn(colProperty: string, col?: any): boolean {
    const prop = (colProperty || '').toLowerCase();
    const colProp = (col?.property || '').toLowerCase();
    const colName = (col?.name || '').toLowerCase();
    const attrCode = (col?.attributeCode || '').toLowerCase();
    const colPropertyName = (col?.propertyName || '').toLowerCase();

    return prop === 'propertyname' || prop === 'property' || prop === 'propertyid' || prop === 'primaryplan' ||
      colProp === 'propertyname' || colProp === 'property' || colProp === 'propertyid' || colProp === 'primaryplan' ||
      colName === 'property' || colName === 'property name' || colName === 'primary plan' ||
      attrCode === 'propertyname' || attrCode === 'property' || attrCode === 'propertyid' || attrCode === 'primaryplan' ||
      colPropertyName === 'propertyname' || colPropertyName === 'property' || colPropertyName === 'propertyid' || colPropertyName === 'primaryplan';
  }

  getPropertyDisplayValue(element: any, col?: any): string {
    if (!element) return '';
    let val = element.propertyName || element.PropertyName || element.Property || element.property || element.PrimaryPlan || element.primaryPlan;
    if (!val && element.isCustomizedValue) {
      if (col && col.propertyName) {
        val = element.isCustomizedValue[col.propertyName];
      }
      if (!val) {
        val = element.isCustomizedValue['propertyName'] || element.isCustomizedValue['PropertyName'] || element.isCustomizedValue['Property'] || element.isCustomizedValue['property'] || element.isCustomizedValue['PrimaryPlan'];
      }
    }
    if (!val && col && col.property && element[col.property]) {
      val = element[col.property];
    }
    const valStr = (val != null && val !== undefined) ? String(val) : '';
    return this.resolveProductNameValue(valStr, element);
  }

  masterCategoryList: any[] = [];
  masterCategoryLoading: boolean = false;
  categoryMap: Map<string, string> = new Map<string, string>();
  private dropdownCategoryLoaded: boolean = false;

  loadMasterCategories() {
    if ((this.masterCategoryList && this.masterCategoryList.length > 0) || this.masterCategoryLoading) return;
    if (!this.categoriesService) return;

    this.masterCategoryLoading = true;
    this.categoriesService.getAllCategories(0, 1000, 'id,desc').subscribe(
      (res: any) => {
        const list = res?.['content'] || res || [];
        if (Array.isArray(list) && list.length > 0) {
          this.setMasterCategories(list);
          this.masterCategoryLoading = false;
          this.loadDropdownCategories();
        } else {
          this.fallbackLoadCategoriesDropDown();
        }
      },
      () => {
        this.fallbackLoadCategoriesDropDown();
      }
    );
  }

  loadDropdownCategories() {
    if (this.dropdownCategoryLoaded || !this.categoriesService) return;
    this.dropdownCategoryLoaded = true;
    this.categoriesService.getAllCategoriesDropDown().subscribe(
      (dropRes: any) => {
        const list = Array.isArray(dropRes) ? dropRes : (dropRes?.['content'] || []);
        if (Array.isArray(list) && list.length > 0) {
          this.mergeMasterCategories(list);
        }
      },
      () => {}
    );
  }

  private fallbackLoadCategoriesDropDown() {
    if (!this.categoriesService) {
      this.masterCategoryLoading = false;
      return;
    }
    this.categoriesService.getAllCategoriesDropDown().subscribe(
      (dropRes: any) => {
        this.masterCategoryLoading = false;
        const list = Array.isArray(dropRes) ? dropRes : (dropRes?.['content'] || []);
        this.setMasterCategories(list);
      },
      () => {
        this.masterCategoryLoading = false;
      }
    );
  }

  private flattenCategories(items: any[]): any[] {
    let flat: any[] = [];
    if (!Array.isArray(items)) return flat;
    for (const item of items) {
      if (!item) continue;
      flat.push(item);
      if (Array.isArray(item.children)) flat.push(...this.flattenCategories(item.children));
      if (Array.isArray(item.subcategories)) flat.push(...this.flattenCategories(item.subcategories));
      if (Array.isArray(item.subCategories)) flat.push(...this.flattenCategories(item.subCategories));
    }
    return flat;
  }

  private setMasterCategories(list: any[]) {
    const flatList = this.flattenCategories(list || []);
    this.masterCategoryList = flatList;
    this.categoryMap.clear();
    this.populateCategoryMap(flatList);
    if (this.cdr) {
      this.cdr.markForCheck();
    }
  }

  private mergeMasterCategories(list: any[]) {
    const flatList = this.flattenCategories(list || []);
    if (!this.masterCategoryList) this.masterCategoryList = [];
    this.masterCategoryList = [...this.masterCategoryList, ...flatList];
    this.populateCategoryMap(flatList);
    if (this.cdr) {
      this.cdr.markForCheck();
    }
  }

  private populateCategoryMap(list: any[]) {
    for (const c of list) {
      if (!c) continue;
      const name = c.name ?? c.categoryName ?? c.viewValue ?? c.title;
      if (!name) continue;
      const cleanName = String(name).trim();
      const ids = [c.id, c.entityId, c.categoryId, c.posCategoryId].filter(id => id != null && id !== '');
      for (const id of ids) {
        this.categoryMap.set(String(id).trim().toLowerCase(), cleanName);
      }
      this.categoryMap.set(cleanName.toLowerCase(), cleanName);
    }
  }

  resolveCategoryNameValue(rawVal: any, element?: any): string {
    if (rawVal == null || rawVal === '' || rawVal === '--') {
      if (element) {
        const elCat = element.category ?? element.Category;
        if (elCat != null && isNaN(Number(elCat)) && String(elCat).trim().length > 0) {
          return String(elCat).trim();
        }
        const elDownload = element['Category_downloadList'] ?? element['category_downloadList'];
        if (elDownload != null && isNaN(Number(elDownload)) && String(elDownload).trim().length > 0) {
          return String(elDownload).trim();
        }
      }
      return '--';
    }

    if (Array.isArray(rawVal)) {
      const resolvedList = rawVal.map(v => this.resolveCategoryNameValue(v, element)).filter(v => v && v !== '--');
      return resolvedList.length > 0 ? resolvedList.join(', ') : '--';
    }

    let valStr = String(rawVal).trim();
    if (!valStr || valStr === '--') return '--';

    if (valStr.includes(',')) {
      const parts = valStr.split(',').map(p => this.resolveCategoryNameValue(p.trim(), element)).filter(v => v && v !== '--');
      return parts.length > 0 ? parts.join(', ') : '--';
    }

    const lowerValStr = valStr.toLowerCase();

    // 1. Match from categoryMap
    if (this.categoryMap && this.categoryMap.has(lowerValStr)) {
      const name = this.categoryMap.get(lowerValStr)!;
      if (element) {
        element.category = name;
        element.Category = name;
        if (element.Category_downloadList && !isNaN(Number(element.Category_downloadList))) {
          element.Category_downloadList = name;
        }
      }
      return name;
    }

    // 2. Check if element itself has non-numeric category name
    if (element) {
      const elCat = element.category ?? element.Category;
      if (elCat != null && isNaN(Number(elCat)) && String(elCat).trim().length > 0) {
        return String(elCat).trim();
      }
      const elDownload = element['Category_downloadList'] ?? element['category_downloadList'];
      if (elDownload != null && isNaN(Number(elDownload)) && String(elDownload).trim().length > 0) {
        return String(elDownload).trim();
      }
    }

    // 3. If rawVal is already non-numeric (a name)
    if (isNaN(Number(valStr)) && valStr.length > 0) {
      return valStr;
    }

    // 4. If numeric and not yet in categoryMap, trigger load
    if (!this.masterCategoryList || this.masterCategoryList.length === 0) {
      this.loadMasterCategories();
    } else if (!this.dropdownCategoryLoaded) {
      this.loadDropdownCategories();
    }

    return valStr;
  }

  getColumnValue(element: any, col: any): string {
    if (!element || !col) return '--';

    const prop = col.property ? String(col.property) : '';
    const propName = col.propertyName ? String(col.propertyName) : '';

    const keysToTry: string[] = [];

    if (prop) {
      keysToTry.push(prop);
      const cleaned = prop.replace(/_cust$/i, '').replace(/^customValuesIs/i, '');
      if (cleaned && !keysToTry.includes(cleaned)) keysToTry.push(cleaned);
    }
    if (propName) {
      if (!keysToTry.includes(propName)) keysToTry.push(propName);
      const cleanedName = propName.replace(/_cust$/i, '').replace(/^customValuesIs/i, '');
      if (cleanedName && !keysToTry.includes(cleanedName)) keysToTry.push(cleanedName);
    }

    const isCategoryCol = this.isCategoryColumn(col);
    const isProductCol = !isCategoryCol && this.isProductColumn(col);

    if (isCategoryCol) {
      const catKeys = [
        'category', 'Category', 'categoryName', 'categoryNames', 'CategoryName',
        'Category_downloadList', 'category_downloadList',
        'Category_cust', 'category_cust',
        'Category_s', 'Category_a', 'CategorycustomField10', 'categorycustomfield10'
      ];
      for (const ck of catKeys) {
        if (!keysToTry.includes(ck)) keysToTry.push(ck);
      }
    }

    if (isProductCol) {
      const prodKeys = [
        'product', 'Product', 'productName', 'productNames', 'ProductName',
        'Product_downloadList', 'product_downloadList',
        'Product_cust', 'product_cust',
        'Product_s', 'Product_a', 'ProductcustomField10', 'PRODUCT ENQUIRED', 'PRODUCT ENQUIRED_cust'
      ];
      for (const pk of prodKeys) {
        if (!keysToTry.includes(pk)) keysToTry.push(pk);
      }
    }

    const candidateKeys: string[] = [];
    for (const k of keysToTry) {
      if (!k) continue;
      if (!candidateKeys.includes(k)) candidateKeys.push(k);

      const lower = k.toLowerCase();
      if (!candidateKeys.includes(lower)) candidateKeys.push(lower);

      const upper = k.toUpperCase();
      if (!candidateKeys.includes(upper)) candidateKeys.push(upper);

      const cap = k.charAt(0).toUpperCase() + k.slice(1);
      if (!candidateKeys.includes(cap)) candidateKeys.push(cap);

      const uncap = k.charAt(0).toLowerCase() + k.slice(1);
      if (!candidateKeys.includes(uncap)) candidateKeys.push(uncap);
    }

    const normalizedTargets = candidateKeys.map(k => k.toLowerCase().replace(/[^a-z0-9]/g, '')).filter(Boolean);

    const checkObj = (obj: any): any => {
      if (!obj || typeof obj !== 'object') return undefined;

      // 1. Exact candidate key lookup
      for (const key of candidateKeys) {
        if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
          return obj[key];
        }
      }

      // 2. Universal case-insensitive & symbol-insensitive fuzzy search
      const objKeys = Object.keys(obj);
      for (const oKey of objKeys) {
        const normObjKey = oKey.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (normalizedTargets.includes(normObjKey)) {
          const val = obj[oKey];
          if (val !== undefined && val !== null && val !== '') {
            return val;
          }
        }
      }

      return undefined;
    };

    let val = checkObj(element);
    if (val === undefined && element.isCustomizedValue) val = checkObj(element.isCustomizedValue);
    if (val === undefined && element.values) val = checkObj(element.values);
    if (val === undefined && element.downloadList) val = checkObj(element.downloadList);
    if (val === undefined) {
      for (let i = 1; i <= 10; i++) {
        if (element[`customField${i}`]) {
          val = checkObj(element[`customField${i}`]);
          if (val !== undefined) break;
        }
      }
    }

    if (val !== undefined && val !== null && val !== '') {
      let displayStr = String(val);
      if (Array.isArray(val)) {
        displayStr = val.join(', ');
      } else if (typeof val === 'string' && val.startsWith('[') && val.endsWith(']')) {
        try {
          const parsed = JSON.parse(val);
          if (Array.isArray(parsed)) displayStr = parsed.join(', ');
        } catch (e) { }
      }

      if (isCategoryCol) {
        const resolved = this.resolveCategoryNameValue(displayStr, element);
        if (resolved) {
          return resolved;
        }
      } else if (isProductCol) {
        const resolved = this.resolveProductNameValue(displayStr, element);
        if (resolved) {
          return resolved;
        }
      }

      return displayStr;
    }

    if (isCategoryCol) {
      const resolved = this.resolveCategoryNameValue('', element);
      if (resolved && resolved !== '--') {
        return resolved;
      }
    }

    if (isProductCol) {
      const resolved = this.resolveProductNameValue('', element);
      if (resolved && resolved !== '--') {
        return resolved;
      }
    }

    return '--';
  }

  get filteredPropertyList(): any[] {
    if (!this.propertyList) return [];
    if (!this.selectedProperties || this.selectedProperties.length === 0) return this.propertyList;
    return this.propertyList.filter(opt => {
      const optId = opt.entityId || opt.id;
      const optName = (opt.propertyName || opt.name || '').toString().toLowerCase().trim();
      return !this.selectedProperties.some(sp => {
        const spId = sp.entityId || sp.id;
        const spName = (sp.propertyName || sp.name || '').toString().toLowerCase().trim();
        return (optId != null && spId != null && optId == spId) || (optName.length > 0 && spName.length > 0 && optName === spName);
      });
    });
  }

  getPropertyData(value: string) {
    let sortParam = 'updatedDate' + "," + Constant.Dsc;
    let searchTerm = "propertyName:'" + '*' + value + '*'
      + "'  OR status:'" + '*' + 1 + ',*'
      + "' ";

    this.realEstatePropertyService.searchProperties(searchTerm, 0, 50, sortParam).subscribe(
      res => {
        const fetched = res['content'] || res['data'] || [];
        this.propertyList = fetched;

        if (this.selectedProperties && this.selectedProperties.length > 0 && fetched.length > 0) {
          this.selectedProperties.forEach(sp => {
            if (!sp.entityId && !sp.id) {
              const matched = fetched.find(item =>
                (item.propertyName || item.name || '').toString().toLowerCase().trim() === (sp.propertyName || sp.name || '').toString().toLowerCase().trim()
              );
              if (matched) {
                sp.entityId = matched.entityId || matched.id;
                sp.id = matched.entityId || matched.id;
              }
            }
          });
        }
        this.cdr.detectChanges();
      },
      () => {
        this.propertyList = [];
      });
  }

  onPropertyInput(event: any) {
    let inputElement = event.target as HTMLInputElement;
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();
    if (inputValue.length > 0) {
      this.getPropertyData(inputValue);
    }
  }

  onPropertyOptionSelected(eventOrOption: any): void {
    const option = eventOrOption?.option?.value || eventOrOption;
    if (!option || typeof option === 'string') return;
    const propId = option.entityId || option.id;
    const propName = option.propertyName || option.name;

    if (propName || propId) {
      if (!this.selectedProperties.some(p => (p.entityId == propId || p.id == propId || p.propertyName == propName || p.name == propName))) {
        this.selectedProperties.push({
          entityId: propId,
          id: propId,
          name: propName,
          propertyName: propName
        });
      }
    }

    this.propertyCtrl.setValue('');
    if (this.propertyInput) {
      this.propertyInput.nativeElement.value = '';
    }
    this.cdr.detectChanges();
  }

  removeProperty(item: any): void {
    const index = this.selectedProperties.indexOf(item);
    if (index >= 0) {
      this.selectedProperties.splice(index, 1);
      this.cdr.detectChanges();
    }
  }

  openPropertyName(element: any, col?: any) {
    this.editingElement = element;
    this.editingCol = col;
    this.propertyCtrl.setValue('');
    this.selectedProperties = [];
    this.propertyList = [];

    let rawNames = this.getPropertyDisplayValue(element, col);

    let rawIds = element?.propertyId || element?.PropertyId || element?.PrimaryPlan || element?.primaryPlan ||
      (element?.isCustomizedValue ? (element.isCustomizedValue['propertyId'] || element.isCustomizedValue['PropertyId']) : '') || '';

    if (rawNames) {
      const namesArr = String(rawNames).split(',').map(s => s.trim()).filter(s => s.length > 0);
      const idsArr = rawIds ? String(rawIds).split(',').map(s => s.trim()) : [];

      namesArr.forEach((name, idx) => {
        const id = idsArr[idx] || null;
        if (!this.selectedProperties.some(p => p.name === name || p.propertyName === name)) {
          this.selectedProperties.push({
            entityId: id,
            id: id,
            name: name,
            propertyName: name
          });
        }
      });
    }

    this.getPropertyData('');

    let dialogRef = this.dialog.open(this.propertyNameModal, {
      width: '600px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getLead();
    });
  }

  propertyNameUpdate() {
    if (!this.editingElement) return;

    let ids = this.selectedProperties.map(p => p.entityId || p.id).filter(id => id != null && id !== '').join(',');
    let names = this.selectedProperties.map(p => p.propertyName || p.name).filter(n => n != null && n !== '').join(',');

    let updateObject: any = {
      "entityId": this.editingElement.entityId,
      "PropertyId": ids,
      "propertyId": ids,
      "PropertyName": names,
      "propertyName": names,
      "Property": names,
      "property": names,
      "PrimaryPlan": ids,
      "primaryPlan": ids
    };

    if (this.editingCol && this.editingCol.propertyName) {
      updateObject[this.editingCol.propertyName] = names;
    }

    this.leadService.editLead(updateObject, this.editingElement.entityId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.editingElement.PropertyId = ids;
          this.editingElement.propertyId = ids;
          this.editingElement.PropertyName = names;
          this.editingElement.propertyName = names;
          this.editingElement.Property = names;
          this.editingElement.property = names;
          this.editingElement.PrimaryPlan = ids;
          this.editingElement.primaryPlan = ids;

          if (this.editingElement.isCustomizedValue) {
            this.editingElement.isCustomizedValue['PropertyName'] = names;
            this.editingElement.isCustomizedValue['propertyName'] = names;
            this.editingElement.isCustomizedValue['Property'] = names;
            this.editingElement.isCustomizedValue['property'] = names;
            if (this.editingCol && this.editingCol.propertyName) {
              this.editingElement.isCustomizedValue[this.editingCol.propertyName] = names;
            }
          }

          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });
          this.dialog.closeAll();
          this.getLead();
        } else {
          this.snackBar.open(response['status_message'] || 'Update failed', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      () => {
        this.snackBar.open('Error updating property', '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 3000
        });
      }
    );
  }

  getStatusName(value: any): string {

    if (typeof value === 'string') {
      return value;
    }

    const found = this.filteredleadStatusTypeList.find(opt => opt.statusId === value);
    return found ? found.statusName : '--';
  }

  getTagName(value: any): string {
    if (!value) return '';
    const valStr = String(value).trim();
    if (valStr.includes(',')) {
      return valStr.split(',')
        .map(v => this.getTagNameSingle(v.trim()))
        .filter(v => !!v)
        .join(', ');
    }
    return this.getTagNameSingle(valStr);
  }

  private getTagNameSingle(val: string): string {
    if (isNaN(Number(val))) {
      return val;
    }
    const num = Number(val);
    const found = (this.tagsList || []).find(opt => opt.statusId === num);
    return found ? found.statusName : val;
  }

  getTagColor(value: any): string {
    if (!value) return '';
    let valStr = String(value).trim();
    if (valStr.includes(',')) {
      valStr = valStr.split(',')[0].trim();
    }
    if (isNaN(Number(valStr))) {
      const found = (this.tagsList || []).find(opt => opt.statusName === valStr);
      return found ? found.statusColor : '';
    }
    const num = Number(valStr);
    const found = (this.tagsList || []).find(opt => opt.statusId === num);
    return found ? found.statusColor : '';
  }

  getTagTextColor(value: any): string {
    const color = this.getTagColor(value);
    if (!color) return '';
    return this.getDarkerTextColor(color, 40);
  }

  companyList: any;

  getCompanyData(value) {

    if (value != '') {

      let sortParam = 'updatedDate' + "," + Constant.Dsc;

      let search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


      this.companiesService.getCompanyBySearchAll(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.companyList = res['content'];

        },
        () => {



        })


    }


  }

  onCompanySelected(event, option, element) {
    if (event.isUserInput && option?.entityId) {

      element['CompanyId'] = option.entityId;
      element['Company'] = option.name;


    } else {
      // element['CompanyId'] = null;
      // element['Company'] = '';
    }
  }

  columnsReady: boolean = false;
  trackByProp = (_: number, col: ListColumn) => col.property;

  leadId: any;

  goToMeeting() {
    const dialogRef = this.dialog.open(AddMeetingComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "type": 1
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
      }
    });
  }

  onOwnerSelected(event, option, element) {
    if (event.isUserInput != false) {

      console.log("option", option);


      element['OwnerId'] = option.entityId;
      element['OwnerName'] = option.email;


    }
  }

  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      () => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  getOptionDisplay(opt: any): string {
    if (opt == null || opt === undefined) return '';
    if (typeof opt === 'string') {
      const trimmed = opt.trim();
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
          opt = JSON.parse(trimmed);
        } catch (e) {
          return opt;
        }
      } else {
        return opt;
      }
    }
    if (typeof opt === 'number') return String(opt);
    if (typeof opt === 'object') {
      return opt.sourceName || opt.statusName || opt.countryName || opt.viewValue || opt.label || opt.name || opt.value || opt.statusColor || '';
    }
    return String(opt);
  }

  getOptionValue(opt: any): any {
    if (opt == null || opt === undefined) return '';
    if (typeof opt === 'string') {
      const trimmed = opt.trim();
      if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
        try {
          opt = JSON.parse(trimmed);
        } catch (e) {
          return opt;
        }
      } else {
        return opt;
      }
    }
    if (typeof opt === 'number') return opt;
    if (typeof opt === 'object') {
      if (opt.sourceName !== undefined) return opt.sourceName;
      if (opt.countryName !== undefined) return opt.countryName;
      if (opt.viewValue !== undefined) return opt.viewValue;
      if (opt.value !== undefined) return opt.value;
      if (opt.name !== undefined) return opt.name;
      if (opt.label !== undefined) return opt.label;
      if (opt.sourceId !== undefined) return opt.sourceId;
      if (opt.statusId !== undefined) return opt.statusId;
      if (opt.id !== undefined) return opt.id;
    }
    return opt;
  }

  setSourceName(event, tag, entityId, element) {

    if (event.isUserInput != false) {

      let object = {

        "entityId": entityId,
        "LeadSource": tag.sourceId,

      }

      element.sourceName = tag.sourceName

      element.LeadSource = tag.sourceId

      this.leadService.editLead(object, entityId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          } else {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => {
        });

    }
  }

  previousValues: { [key: string]: any } = {};

  backupValue(key: any, element: any) {
    if (Array.isArray(element[key])) {
      this.previousValues[key] = [...element[key]];
    } else {
      this.previousValues[key] = element[key];
    }
  }


  setStatusName(event, tag, entityId, element) {

    if (event.isUserInput != false) {


      element.statusName = tag.statusName;

      element.LeadStatus = tag.statusId;

      if (tag.leadStatusColour || tag.color) {
        element.leadStatusColour = tag.leadStatusColour || tag.color;
        element.darkTextColor = this.getDarkerTextColor(element.leadStatusColour, 40);
      }

      // this.leadService.editLead(object, entityId).subscribe(
      //   (response) => {
      //     if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
      //       // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
      //     } else {
      //       // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      //     }
      //   },
      //   (err) => {
      //   });

    }
  }



  onDummyClick() {
    this.isPopupOpen1 = true;
  }

  //Sequences


  @ViewChild('SequenceStatus') SequenceStatus: TemplateRef<any>;

  SequenceStatusPopup(type, data) {
    if (!this.enableSequence) {
      return;
    }

    this.showFailedRecords = false;
    this.failedRecords = [];

    if (type == 'single') {

      this.typeSequence = 1;
      this.entityId = data.entityId;


    } else {
      this.typeSequence = 2;
    }



    this.text = 'Save';
    let dialogRef = this.dialog.open(this.SequenceStatus, {
      width: '550px',
      disableClose: true,
      data: data
    });
    dialogRef.disableClose = true;

  }

  filteredSequencesdropdownTypeList: any;

  public typeYSequencesFilterControl: UntypedFormControl = new UntypedFormControl();

  sequences = new FormControl('');

  dropdownSequencesTypeList: any;
  sequencesList: any;





  typeSequncesYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidSequnceYFilter();
      });
  }


  protected typeidSequnceYFilter() {
    let search = this.typeYFilterControl.value;
    if (!search || search.trim() === '') {
      if (this.dropdownSequencesTypeList) {
        this.filteredSequencesdropdownTypeList = this.dropdownSequencesTypeList.slice();
      }
      return;
    }
    let searchTerm = 'sequenceName:*' + search.trim() + '*';
    searchTerm = searchTerm.replace(/'/g, '');

    this.sequencesService.getSequencesBySearch(searchTerm, 0, 50, 'sequenceId,desc').subscribe(
      (res: any) => {
        if (res && res['content']) {
          this.filteredSequencesdropdownTypeList = res['content'];
        }
      },
      () => { }
    );
  }





  UpdateSequence() {
    if (!this.enableSequence) {
      return;
    }
    this.showFailedRecords = false;

    if (this.text == 'Save' && this.sequences.valid) {
      this.text = "Processing"
      this.spinner = true;
      let object = {
        "sequenceId": this.sequences.value,
        "leadId": this.entityId,
      }

      if (this.typeSequence == 1) {

        this.sequencesService.updateLeadSequnces(object).subscribe(
          response => {
            this.text == 'Save'
            this.spinner = false;
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

              this.refresh();
              this.selectionLead = [];

              this.text = 'Save'

              this.leadIdList = [];
              this.checkBoxControl.reset();
              this.dialog.closeAll();
            } else {
              this.text = 'Save'
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
          },
          () => {
            this.text = 'Save'
            this.spinner = false;
          })

      } else if (this.typeSequence == 2) {

        this.sequencesService.updateLeadSequncesBulk(this.leadIdList, this.sequences.value).subscribe(
          response => {
            this.text == 'Save'
            this.spinner = false;
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

              this.selectionLead = [];

              this.text = 'Save'

              this.leadIdList = [];
              this.checkBoxControl.reset();
              if (response['data'] && response['data']['Failed'] && response['data']['Failed'].length > 0) {

                this.failedRecords = response['data']['Failed'];

                this.showFailedRecords = true;

              }
              else {
                this.refresh();

                this.dialog.closeAll();
                this.selectionLead = [];
                this.cancelBulkSelection();
                this.leadIdList = [];
                this.checkBoxControl.reset();

              }



            } else {
              this.text = 'Save'
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
          },
          () => {
            this.text = 'Save'
            this.spinner = false;
          })

      }

    }
  }

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
    else if (step.label === 'Import Lead') {
      this.importExcelAdvance();
    }
  }


  addNewCompany(element, companyName) {

    // Trim the incoming company name and ignore whitespace-only values
    const name = (companyName || '').toString().trim();
    if (!name) {
      return; // nothing to add
    }

    // update the inline element to the trimmed value so UI reflects it
    element['company'] = name;

    this.loaderService.show();

    const object = {
      company: name,
      owner: element.ownerEmail || '',
      ownerId: element.ownerId || '',
      entityId: element.CompanyId || element.companyId || null,
    };

    this.companiesService.addCompanyName(object).subscribe(
      (response) => {
        this.loaderService.hide();
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          if (response['data'] && response['data']['entityId']) {

            element['Company'] = response['data']['name'];
            element['CompanyId'] = response['data']['entityId'];

            this.editingCell = null;
            this.editingElement = null;
            this.editingCol = null;
            let updateObj: any = {
              entityId: element.entityId,
            };

            updateObj['Company'] = response['data']['name'];
            updateObj['CompanyId'] = response['data']['entityId'];

            this.doSave(updateObj, element.entityId);

          }


          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
        }
        else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      () => { this.loaderService.hide(); });
  }

  // Websocket-based sequential dialing using the app's WebsocketService
  wsConnectionSub: any = null;
  wsMessageSub: any = null;
  callSequenceInProgress: boolean = false;
  private _currentCallIndex: number = 0;
  private _callTimeoutHandle: any = null;
  // small delay between calls when advancing (ms). Use ~1s as requested.
  private _interCallDelayMs: number = 1000;
  private _interCallDelayHandle: any = null;

  /**
   * Start sequential calls for all leads in `this.leadIdList` using the shared WebsocketService.
   * Callers should pass the current user's id so the service can subscribe to `/user/{userId}/queue/private-messages`.
   * @param userId user identifier for private queue subscription
   * @param timeoutMs per-lead fallback timeout in ms (default 30000)
   */
  sequenceCallWithWebsocket(userId: any, timeoutMs: number = 30000) {
    if (!this.leadIdList || this.leadIdList.length === 0) {
      this.snackBar.open('No leads selected for calling', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    if (this.callSequenceInProgress) {
      this.snackBar.open('Call sequence already in progress', '×', { panelClass: 'info', verticalPosition: 'bottom', duration: 2000 });
      return;
    }

    if (!userId) {
      this.snackBar.open('Missing user id for websocket subscription', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    this.callSequenceInProgress = true;
    this._currentCallIndex = 0;

    let key = String(userId) + 'autoDial';
    // Connect using shared service. Use userId + 'autoDial' as the connection key per request.
    this.wsConnectionSub = this.websocket.initializeWebSocketConnection(key).subscribe(() => {
      // subscribe to broadcast messages Subject
      this.wsMessageSub = this.websocket.getObservableMsg().subscribe((raw: any) => {
        let payload: any = raw;
        try { payload = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch (e) { /* keep raw */ }

        // Expecting payload to contain lead identifier and status/call status
        const incomingLeadId = payload?.entityId;
        const status = (payload && (payload.status || payload.callStatus || payload.event)) || '';

        const currentLead = this.leadIdList[this._currentCallIndex];
        const currentLeadId = currentLead?.leadId || currentLead?.entityId;

        if (incomingLeadId && currentLeadId && incomingLeadId == currentLeadId) {
          if (typeof status === 'string' && status.toLowerCase().includes('completed')) {
            // clear timeout and move to next after a short delay
            if (this._callTimeoutHandle) { clearTimeout(this._callTimeoutHandle); this._callTimeoutHandle = null; }
            // clear any existing inter-call handle
            if (this._interCallDelayHandle) { clearTimeout(this._interCallDelayHandle); this._interCallDelayHandle = null; }
            this._currentCallIndex++;
            this._interCallDelayHandle = setTimeout(() => {
              this._interCallDelayHandle = null;
              this._dialNextOrFinish(timeoutMs);
            }, this._interCallDelayMs);
          }
        }
      });

      // start dialing first lead
      this._dialNextOrFinish(timeoutMs);
    });
  }

  private _dialNextOrFinish(timeoutMs?: number) {
    if (this._currentCallIndex >= this.leadIdList.length) {
      // finished
      this._finishCallSequence();
      return;
    }

    const lead = this.leadIdList[this._currentCallIndex];
    const dataForCall: any = {
      entityId: lead.leadId || lead.entityId,
      phoneNumber: lead.phoneNo || lead.phoneNumber,
      ownerEmail: lead.ownerEmail || '',
      ownerId: lead.ownerId || '',
      name: lead.name || ''
    };

    try { this.phoneNumbercall(dataForCall); } catch (e) { console.error('Error calling phoneNumbercall:', e); }

    // setup fallback timeout to move to next lead if no websocket message arrives
    if (this._callTimeoutHandle) { clearTimeout(this._callTimeoutHandle); this._callTimeoutHandle = null; }
    // Only set a fallback timer when a positive timeoutMs is provided. If timeoutMs is undefined or 0,
    // we will wait indefinitely for websocket responses.
    if (timeoutMs && timeoutMs > 0) {
      this._callTimeoutHandle = setTimeout(() => {
        this._callTimeoutHandle = null;
        // move to next after a short inter-call delay
        if (this._interCallDelayHandle) { clearTimeout(this._interCallDelayHandle); this._interCallDelayHandle = null; }
        this._currentCallIndex++;
        this._interCallDelayHandle = setTimeout(() => {
          this._interCallDelayHandle = null;
          this._dialNextOrFinish(timeoutMs);
        }, this._interCallDelayMs);
      }, timeoutMs);
    } else {
      // no timeout requested — ensure we have no pending handle
      this._callTimeoutHandle = null;
    }
  }

  private _finishCallSequence() {
    this.callSequenceInProgress = false;
    if (this._callTimeoutHandle) { clearTimeout(this._callTimeoutHandle); this._callTimeoutHandle = null; }
    if (this._interCallDelayHandle) { clearTimeout(this._interCallDelayHandle); this._interCallDelayHandle = null; }
    // cleanup websocket subscriptions and optionally disconnect
    try { if (this.wsMessageSub) { this.wsMessageSub.unsubscribe(); this.wsMessageSub = null; } } catch (e) { }
    try { if (this.wsConnectionSub) { this.wsConnectionSub.unsubscribe(); this.wsConnectionSub = null; } } catch (e) { }
    try { this.websocket.disconnect(); } catch (e) { }
    this.snackBar.open('Completed sequential calls', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2500 });

    this.cancelBulkSelection();
    this.refresh();
  }

  /**
   * Alternate flow: use `websocket.connect(vendorId)` and `message$` observable (as in whatsapp-chat) to
   * receive call-status messages. If `randomId` is not provided we generate a random client id.
   * This mirrors the snippet you provided: this.websocket.connect(id); this.websocket.message$.subscribe(...)
   */
  sequenceCallWithWebsocketConnect() {
    if (!this.leadIdList || this.leadIdList.length === 0) {
      this.snackBar.open('No leads selected for calling', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    if (this.callSequenceInProgress) {
      this.snackBar.open('Call sequence already in progress', '×', { panelClass: 'info', verticalPosition: 'bottom', duration: 2000 });
      return;
    }

    let baseId = this.leadIdList[0]?.ownerId;
    // append 'autoDial' to the connection id so backend can identify auto-dial sessions
    const connId = String(baseId) + 'autoDial';

    // connect using the simple connect API used elsewhere in the app
    try {
      this.websocket.connectCalls(connId);
    } catch (e) {
      console.warn('websocket.connect failed', e);
    }

    this.callSequenceInProgress = true;
    this._currentCallIndex = 0;

    // subscribe to message$ stream
    this.wsMessageSub = this.websocket.message$.subscribe((message: any) => {
      console.log('the message is', message);
      // Otherwise, treat it as a call-status or arrival event: try to parse leadId and status
      let payload: any = message;
      try { payload = typeof message === 'string' ? JSON.parse(message) : message; } catch (e) { /* keep raw */ }

      const incomingLeadId = payload?.leadId || payload?.entityId || payload?.lead_id || payload?.id;
      const status = (payload && (payload.status || payload.callStatus || payload.event)) || '';

      const currentLead = this.leadIdList[this._currentCallIndex];
      const currentLeadId = currentLead?.leadId || currentLead?.entityId;

      if (incomingLeadId && currentLeadId &&
        incomingLeadId == currentLeadId) {

        if (typeof status === 'string' && status.toLowerCase().includes('completed')) {
          // completed -> clear timeout and advance
          if (this._callTimeoutHandle) { clearTimeout(this._callTimeoutHandle); this._callTimeoutHandle = null; }
          // clear any existing inter-call handle
          if (this._interCallDelayHandle) { clearTimeout(this._interCallDelayHandle); this._interCallDelayHandle = null; }
          this._currentCallIndex++;

          this._interCallDelayHandle = setTimeout(() => {
            this._interCallDelayHandle = null;
            // no timeout provided in this connect-flow: pass undefined so _dialNextOrFinish won't set a fallback timer
            this._dialNextOrFinish(undefined);
          }, this._interCallDelayMs || 2000);
        }
      }
    });

    // start dialing first lead; no timeout (wait for websocket) so pass undefined
    this._dialNextOrFinish(undefined);
  }






  getAllConnectedOnes() {

    const encryptedData = this.route.snapshot.params['leadId'];

    const decrypted = this.ecryptService.decryptionAES(encryptedData);

    let value = [];

    value = decrypted.split(",");

    let urlPage = this.route.snapshot.queryParamMap.get("page")
    let urlSort = this.route.snapshot.queryParamMap.get("sort")
    if (urlPage != null && this.redirected == true) {
      this.redirected = true;

      this.page = this.urlPage;
      this.size = this.urlSize;
      this.sortParam = urlSort;
    }
    this.firstFormGroup.value.page = this.page;
    this.firstFormGroup.value.size = this.size;

    this.filterActive = false;
    this.spinner = true;
    this.productList = []

    let search: any = value;


    if (search == null || search.length > 0 || search == undefined) {


      this.productService.getAllConnectedOnes(search, this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit).subscribe(
        res => {
          this.spinner = false;


          if (!this.selectUpload) {
            this.productList = res['content'];
            this.updateAllEntityIds(res['content']);
            this.elements = res['numberOfElements'];
            this.pageList = res['totalElements'];
            this.pageSizeValue = LeadgetPageSize(this.pageList);
            // notify kanban to refresh when filters/search updated
            this.notifyKanbanUpdate();
          } else {
            this.downloadDataFinal(res['content'])
          }

        },
        () => {
          this.spinner = false;
        })
      this.searchTermMainPresent = false

    }

  }


  smartViewList: any;

  getALLSmartViewsNew() {
    this.filterActive = false;
    this.spinner = true;
    this.smartViewsService.getSmartViewsDropDown().subscribe(
      (res: any) => {
        this.spinner = false;
        if (Array.isArray(res)) {
          this.smartViewList = res.filter((item: any) => item.type === 0 || item.type === 1);
        } else {
          this.smartViewList = res;
        }
      },
      () => {
        this.spinner = false;
      }
    )
  }

  smartView: any;

  onClickTabData(tab: any) {
    this.clearFilter();

    this.filterQuery = '';
    let url = this.router.url;
    if (url.includes('lead') || url.includes('contact')) {
      let cleanUrl = url.split('?')[0];
      localStorage.removeItem(cleanUrl + "se");
    }

    this.activeTab = tab.tabName;
    localStorage.setItem(tab.tabName, tab.conditions);
    localStorage.setItem('smartViewConditionsEnble', 'true');
    localStorage.setItem("activeTab", tab.tabName);
    localStorage.setItem("activeTabType", String(tab.type));
    let initialSearch = this.contactPage ? this.searchContact : null;
    this.getDynamicLeadReport(initialSearch, tab.type);
  }


  getDynamicLeadReport(search, tabType?: any) {


    let cleanUrl = this.router.url.split('?')[0];

    if (search == null || search == undefined || search == '') {
      let storedSearch = localStorage.getItem(cleanUrl + "se");
      if (storedSearch) {
        search = storedSearch;
        this.search = storedSearch;
        this.filterActive = true;
      } else {
        this.filterActive = false;
        this.search = '';
      }
    } else {
      this.filterActive = true;
      this.search = search;
      localStorage.setItem(cleanUrl + "se", search);
    }

    if (this.contactPage) {
      if (search == null || search == undefined || search == '') {
        search = this.searchContact;
      } else if (typeof search === 'string' && !search.includes("isClosedWon")) {
        search = search + " AND isClosedWon:*1,*";
      }
    }

    this.spinner = true;
    let activeTab = localStorage.getItem("activeTab")
    let conditonValue = localStorage.getItem(activeTab)
    if (tabType === undefined || tabType === null) {
      const storedType = localStorage.getItem("activeTabType");
      tabType = storedType !== null ? Number(storedType) : 0;
    }

    if (tabType == 1) {
      let sortParam: any = this.sortParam ? this.sortParam : ('a.updatedDate' + "," + Constant.Dsc);
      let conditionObj: any = conditonValue;
      if (typeof conditonValue === 'string') {
        try {
          conditionObj = JSON.parse(conditonValue);
        } catch (e) {
          conditionObj = { activity: conditonValue, lead: null };
        }
      } else if (conditonValue && typeof conditonValue === 'object') {
        conditionObj = conditonValue;
      } else {
        conditionObj = { activity: null, lead: null };
      }

      if (this.contactPage && conditionObj) {
        if (conditionObj.lead && typeof conditionObj.lead === 'string' && !conditionObj.lead.includes("isClosedWon")) {
          conditionObj.lead = conditionObj.lead + " AND " + this.searchContact;
        } else if (!conditionObj.lead) {
          conditionObj.lead = this.searchContact;
        }
      }

      this.leadActivityService.searchLeadAdvanceFilterNew(search, this.page, this.size, sortParam, conditionObj).subscribe(
        (res: any) => {
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          const mappedContent = (res['content'] || []).map((element: any) => {
            return {
              ...element,
              darkTextColor: this.getDarkerTextColor(element.leadStatusColour, 40),
              darkTextColorTag: this.getDarkerTextColor(element.tagNameColour, 40),
            };
          });
          this.productList = mappedContent;
          this.updateAllEntityIds(mappedContent);
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.notifyKanbanUpdate();
        },
        () => {
          this.spinner = false;
        }
      );
    } else {
      this.productService.searchLeadAdvanceFilter(search, this.page, this.size, this.sortParam, conditonValue).subscribe(
        res => {
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          const mappedContent = (res['content'] || []).map((element: any) => {
            return {
              ...element,
              darkTextColor: this.getDarkerTextColor(element.leadStatusColour, 40),
              darkTextColorTag: this.getDarkerTextColor(element.tagNameColour, 40),
            };
          });
          this.productList = mappedContent;
          this.updateAllEntityIds(mappedContent);
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.notifyKanbanUpdate();
        },
        () => {
          this.spinner = false;
        }
      );
    }
  }

  /**
 * If the provided filter string matches any stored smart-view condition,
 * enable smart view and populate the generic `smartViewConditions` key.
 */
  ensureSmartViewFromFilter(): void {


    let activeTab = localStorage.getItem("activeTab");


    if (activeTab == null) {
      this.smartViewConditionsEnble = false;
      return
    }



    let smartViewConditions = localStorage.getItem(activeTab);

    if (activeTab != null && smartViewConditions != null) {

      this.activeTab = activeTab;
      this.smartViewConditionsEnble = true;

      // Reusable helper will attempt to scroll the 'All' tab into view and activate it.

      return;
    } else {
      this.smartViewConditionsEnble = false;
      return
    }






  }

  clearFilter() {

    let activeTab = localStorage.getItem("activeTab");;

    localStorage.removeItem(activeTab);
    localStorage.removeItem('smartViewConditionsEnble');
    localStorage.removeItem("activeTab");
    localStorage.removeItem("activeTabType");


  }

  todayLeads() {
    this.productService.getLead(this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit).subscribe(
      res => {
        this.spinner = false;
        this.pageListTwo = res['totalElements'];

        this.notifyKanbanUpdate();

      },
      () => {
        this.spinner = false;
      }
    )
  }

  UpdateFailedList() {

    this.refresh();

    this.dialog.closeAll();
    this.selectionLead = [];
    this.cancelBulkSelection();
    this.leadIdList = [];
    this.checkBoxControl.reset();

  }

  private showLoaderTemporarily(ms: number = 2000) {
    try {
      this.loaderService.show();
      // ensure we always hide after ms (clear previous timers if any)
      const timer = setTimeout(() => this.loaderService.hide(), ms);
      // In case component destroyed earlier, clear timer
      this._onDestroy.subscribe(() => clearTimeout(timer));
    } catch (e) {
      // ignore if loader service is not available or fails
    }
  }
  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  filteredEmaildropdownTypeList: any;
  dropdownEmailTypeList: any;
  dropdownEmailList: any;
  public typeEmailYFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllUserMailConfig() {

    this.userMailConfigService.getAllUserMailConfig().subscribe(res => {
      this.dropdownEmailList = res;
      this.dropdownEmailTypeList = res;
      this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList;

      if (this.useIndividualMail == 1 && this.dropdownEmailList && this.dropdownEmailList.length > 0) {
        this.fromEmailId.patchValue(this.dropdownEmailList[0].userMailConfigId);
        this.fromEmail.patchValue(this.dropdownEmailList[0].emailAddress);
      } else {
        this.fromEmailId.patchValue('');
        this.fromEmail.patchValue('');
      }

    },
      () => {
      })
  }


  typeEmailYFilter() {
    this.typeEmailYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidEmailYFilter();
      });
  }


  protected typeidEmailYFilter() {
    if (!this.dropdownEmailTypeList) {
      return;
    }
    let search = this.typeEmailYFilterControl.value;
    if (!search) {
      this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList.filter(status => status['emailAddress'].toLowerCase().indexOf(search) > -1)
  }

  formatSecondsToTime(secondsInput: any): string {
    if (secondsInput === null || secondsInput === undefined || secondsInput === '' || secondsInput === '--') {
      return '00:00:00';
    }
    if (typeof secondsInput === 'string' && secondsInput.includes(':')) {
      const parts = secondsInput.split(':');
      const hh = Math.floor(parseFloat(parts[0]) || 0).toString().padStart(2, '0');
      const mm = Math.floor(parseFloat(parts[1]) || 0).toString().padStart(2, '0');
      const ss = Math.floor(parseFloat(parts[2]) || 0).toString().padStart(2, '0');
      return `${hh}:${mm}:${ss}`;
    }
    const val = parseFloat(secondsInput);
    if (isNaN(val) || val < 0) {
      return '00:00:00';
    }
    const seconds = Math.floor(val);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

}





